/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCard = /* GraphQL */ `
  mutation CreateCard(
    $input: CreateCardInput!
    $condition: ModelCardConditionInput
  ) {
    createCard(input: $input, condition: $condition) {
      id
      cardTenantId
      group
      stripeSetupIntent
      stripeCustomerId
      stripePaymentMethodId
      active
      createdAt
      chargeError
      updatedAt
      __typename
    }
  }
`;
export const updateCard = /* GraphQL */ `
  mutation UpdateCard(
    $input: UpdateCardInput!
    $condition: ModelCardConditionInput
  ) {
    updateCard(input: $input, condition: $condition) {
      id
      cardTenantId
      group
      stripeSetupIntent
      stripeCustomerId
      stripePaymentMethodId
      active
      createdAt
      chargeError
      updatedAt
      __typename
    }
  }
`;
export const deleteCard = /* GraphQL */ `
  mutation DeleteCard(
    $input: DeleteCardInput!
    $condition: ModelCardConditionInput
  ) {
    deleteCard(input: $input, condition: $condition) {
      id
      cardTenantId
      group
      stripeSetupIntent
      stripeCustomerId
      stripePaymentMethodId
      active
      createdAt
      chargeError
      updatedAt
      __typename
    }
  }
`;
export const createCompanyScoreCard = /* GraphQL */ `
  mutation CreateCompanyScoreCard(
    $input: CreateCompanyScoreCardInput!
    $condition: ModelCompanyScoreCardConditionInput
  ) {
    createCompanyScoreCard(input: $input, condition: $condition) {
      id
      group
      week
      year
      yearWeek
      overallNumeric
      overall
      safetyAndCompliance
      comprehensiveAudit
      safetyScore
      safeDriving
      safeDrivingText
      fico
      seatbeltOff
      seatbeltOffText
      speedingEvent
      speedingEventText
      dvcrCompliance
      dvcrComplianceText
      onTimeCompliance
      onTimeComplianceText
      complianceScoreText
      workingHoursCompliance
      workingHoursComplianceText
      workingSafetyComplianceDevice
      workingSafetyComplianceDeviceText
      dspAudit
      dspAuditText
      thirtyDaysNoticeText
      customerEscalationDefectDPMO
      customerEscalationDefectDPMOText
      team
      highPerformersShare
      highPerformersShareText
      lowPerformersShare
      lowPerformersShareText
      attritionRate
      attritionRateText
      quality
      pickupQuality
      deliveryCompletion
      deliveryCompletionText
      dcDpmo
      dcDpmoText
      deliveredAndReceived
      deliveredAndReceivedText
      standardWorkComplianceText
      photoOnDelivery
      photoOnDeliveryText
      contactCompliance
      contactComplianceText
      scanCompliance
      scanComplianceText
      attendedDeliveryAccuracy
      attendedDeliveryAccuracyText
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      distractionsRateText
      followingDistanceRateText
      signSignalViolationsRateText
      scorecardPdf
      podQualityPdf
      customerFeedbackPdf
      ppsCsv
      harshBrakingEvent
      harshCorneringEvent
      harshBrakingEventText
      harshCorneringEventText
      deliverySlotPerformance
      deliverySlotPerformanceText
      tenantId
      customerDeliveryExperience
      customerDeliveryFeedback
      customerDeliveryFeedbackText
      cdfDpmo
      cdfDpmoText
      breachOfContract
      tenuredWorkforce
      tenuredWorkforceText
      deliverySuccessBehaviors
      deliverySuccessBehaviorsText
      pickupSuccessBehaviors
      pickupSuccessBehaviorsText
      fleetExecution
      fleetExecutionText
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompanyScoreCard = /* GraphQL */ `
  mutation UpdateCompanyScoreCard(
    $input: UpdateCompanyScoreCardInput!
    $condition: ModelCompanyScoreCardConditionInput
  ) {
    updateCompanyScoreCard(input: $input, condition: $condition) {
      id
      group
      week
      year
      yearWeek
      overallNumeric
      overall
      safetyAndCompliance
      comprehensiveAudit
      safetyScore
      safeDriving
      safeDrivingText
      fico
      seatbeltOff
      seatbeltOffText
      speedingEvent
      speedingEventText
      dvcrCompliance
      dvcrComplianceText
      onTimeCompliance
      onTimeComplianceText
      complianceScoreText
      workingHoursCompliance
      workingHoursComplianceText
      workingSafetyComplianceDevice
      workingSafetyComplianceDeviceText
      dspAudit
      dspAuditText
      thirtyDaysNoticeText
      customerEscalationDefectDPMO
      customerEscalationDefectDPMOText
      team
      highPerformersShare
      highPerformersShareText
      lowPerformersShare
      lowPerformersShareText
      attritionRate
      attritionRateText
      quality
      pickupQuality
      deliveryCompletion
      deliveryCompletionText
      dcDpmo
      dcDpmoText
      deliveredAndReceived
      deliveredAndReceivedText
      standardWorkComplianceText
      photoOnDelivery
      photoOnDeliveryText
      contactCompliance
      contactComplianceText
      scanCompliance
      scanComplianceText
      attendedDeliveryAccuracy
      attendedDeliveryAccuracyText
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      distractionsRateText
      followingDistanceRateText
      signSignalViolationsRateText
      scorecardPdf
      podQualityPdf
      customerFeedbackPdf
      ppsCsv
      harshBrakingEvent
      harshCorneringEvent
      harshBrakingEventText
      harshCorneringEventText
      deliverySlotPerformance
      deliverySlotPerformanceText
      tenantId
      customerDeliveryExperience
      customerDeliveryFeedback
      customerDeliveryFeedbackText
      cdfDpmo
      cdfDpmoText
      breachOfContract
      tenuredWorkforce
      tenuredWorkforceText
      deliverySuccessBehaviors
      deliverySuccessBehaviorsText
      pickupSuccessBehaviors
      pickupSuccessBehaviorsText
      fleetExecution
      fleetExecutionText
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompanyScoreCard = /* GraphQL */ `
  mutation DeleteCompanyScoreCard(
    $input: DeleteCompanyScoreCardInput!
    $condition: ModelCompanyScoreCardConditionInput
  ) {
    deleteCompanyScoreCard(input: $input, condition: $condition) {
      id
      group
      week
      year
      yearWeek
      overallNumeric
      overall
      safetyAndCompliance
      comprehensiveAudit
      safetyScore
      safeDriving
      safeDrivingText
      fico
      seatbeltOff
      seatbeltOffText
      speedingEvent
      speedingEventText
      dvcrCompliance
      dvcrComplianceText
      onTimeCompliance
      onTimeComplianceText
      complianceScoreText
      workingHoursCompliance
      workingHoursComplianceText
      workingSafetyComplianceDevice
      workingSafetyComplianceDeviceText
      dspAudit
      dspAuditText
      thirtyDaysNoticeText
      customerEscalationDefectDPMO
      customerEscalationDefectDPMOText
      team
      highPerformersShare
      highPerformersShareText
      lowPerformersShare
      lowPerformersShareText
      attritionRate
      attritionRateText
      quality
      pickupQuality
      deliveryCompletion
      deliveryCompletionText
      dcDpmo
      dcDpmoText
      deliveredAndReceived
      deliveredAndReceivedText
      standardWorkComplianceText
      photoOnDelivery
      photoOnDeliveryText
      contactCompliance
      contactComplianceText
      scanCompliance
      scanComplianceText
      attendedDeliveryAccuracy
      attendedDeliveryAccuracyText
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      distractionsRateText
      followingDistanceRateText
      signSignalViolationsRateText
      scorecardPdf
      podQualityPdf
      customerFeedbackPdf
      ppsCsv
      harshBrakingEvent
      harshCorneringEvent
      harshBrakingEventText
      harshCorneringEventText
      deliverySlotPerformance
      deliverySlotPerformanceText
      tenantId
      customerDeliveryExperience
      customerDeliveryFeedback
      customerDeliveryFeedbackText
      cdfDpmo
      cdfDpmoText
      breachOfContract
      tenuredWorkforce
      tenuredWorkforceText
      deliverySuccessBehaviors
      deliverySuccessBehaviorsText
      pickupSuccessBehaviors
      pickupSuccessBehaviorsText
      fleetExecution
      fleetExecutionText
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecurringMessages = /* GraphQL */ `
  mutation CreateRecurringMessages(
    $input: CreateRecurringMessagesInput!
    $condition: ModelRecurringMessagesConditionInput
  ) {
    createRecurringMessages(input: $input, condition: $condition) {
      id
      senderId
      group
      messageName
      messageBody
      sendTime
      channelType
      senderName
      staffLabelIds
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecurringMessages = /* GraphQL */ `
  mutation UpdateRecurringMessages(
    $input: UpdateRecurringMessagesInput!
    $condition: ModelRecurringMessagesConditionInput
  ) {
    updateRecurringMessages(input: $input, condition: $condition) {
      id
      senderId
      group
      messageName
      messageBody
      sendTime
      channelType
      senderName
      staffLabelIds
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecurringMessages = /* GraphQL */ `
  mutation DeleteRecurringMessages(
    $input: DeleteRecurringMessagesInput!
    $condition: ModelRecurringMessagesConditionInput
  ) {
    deleteRecurringMessages(input: $input, condition: $condition) {
      id
      senderId
      group
      messageName
      messageBody
      sendTime
      channelType
      senderName
      staffLabelIds
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPendingMessage = /* GraphQL */ `
  mutation CreatePendingMessage(
    $input: CreatePendingMessageInput!
    $condition: ModelPendingMessageConditionInput
  ) {
    createPendingMessage(input: $input, condition: $condition) {
      id
      staffId
      group
      createdAt
      channelType
      destinationNumber
      destinationEmail
      numberOfCO
      numberOfPR
      numberOfCdfCO
      numberOfWeeklyCO
      numberOfWeeklyPR
      numberOfDailyCO
      numberOfMentorCO
      numberOfNetradyneCO
      numberOfEocCO
      numberOfPpsCO
      numberOfDailyPR
      numberOfMentorPR
      numberOfNetradynePR
      numberOfEocPR
      numberOfPpsPR
      bodyText
      bodyTextCO
      bodyTextPR
      bodyTextCdfCO
      bodyTextDailyCO
      bodyTextDailyPR
      bodyTextMentorCO
      bodyTextMentorPR
      bodyTextNetradyneCO
      bodyTextNetradynePR
      bodyTextEocCO
      bodyTextEocPR
      bodyTextPpsCO
      bodyTextPpsPR
      bodyTextWeeklyCO
      bodyTextWeeklyPR
      subject
      bodyHtml
      importId
      smsSendInformation
      emailSendInformation
      isRead
      startLastWeeklyImport
      endLastWeeklyImport
      lastDailyImport
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePendingMessage = /* GraphQL */ `
  mutation UpdatePendingMessage(
    $input: UpdatePendingMessageInput!
    $condition: ModelPendingMessageConditionInput
  ) {
    updatePendingMessage(input: $input, condition: $condition) {
      id
      staffId
      group
      createdAt
      channelType
      destinationNumber
      destinationEmail
      numberOfCO
      numberOfPR
      numberOfCdfCO
      numberOfWeeklyCO
      numberOfWeeklyPR
      numberOfDailyCO
      numberOfMentorCO
      numberOfNetradyneCO
      numberOfEocCO
      numberOfPpsCO
      numberOfDailyPR
      numberOfMentorPR
      numberOfNetradynePR
      numberOfEocPR
      numberOfPpsPR
      bodyText
      bodyTextCO
      bodyTextPR
      bodyTextCdfCO
      bodyTextDailyCO
      bodyTextDailyPR
      bodyTextMentorCO
      bodyTextMentorPR
      bodyTextNetradyneCO
      bodyTextNetradynePR
      bodyTextEocCO
      bodyTextEocPR
      bodyTextPpsCO
      bodyTextPpsPR
      bodyTextWeeklyCO
      bodyTextWeeklyPR
      subject
      bodyHtml
      importId
      smsSendInformation
      emailSendInformation
      isRead
      startLastWeeklyImport
      endLastWeeklyImport
      lastDailyImport
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePendingMessage = /* GraphQL */ `
  mutation DeletePendingMessage(
    $input: DeletePendingMessageInput!
    $condition: ModelPendingMessageConditionInput
  ) {
    deletePendingMessage(input: $input, condition: $condition) {
      id
      staffId
      group
      createdAt
      channelType
      destinationNumber
      destinationEmail
      numberOfCO
      numberOfPR
      numberOfCdfCO
      numberOfWeeklyCO
      numberOfWeeklyPR
      numberOfDailyCO
      numberOfMentorCO
      numberOfNetradyneCO
      numberOfEocCO
      numberOfPpsCO
      numberOfDailyPR
      numberOfMentorPR
      numberOfNetradynePR
      numberOfEocPR
      numberOfPpsPR
      bodyText
      bodyTextCO
      bodyTextPR
      bodyTextCdfCO
      bodyTextDailyCO
      bodyTextDailyPR
      bodyTextMentorCO
      bodyTextMentorPR
      bodyTextNetradyneCO
      bodyTextNetradynePR
      bodyTextEocCO
      bodyTextEocPR
      bodyTextPpsCO
      bodyTextPpsPR
      bodyTextWeeklyCO
      bodyTextWeeklyPR
      subject
      bodyHtml
      importId
      smsSendInformation
      emailSendInformation
      isRead
      startLastWeeklyImport
      endLastWeeklyImport
      lastDailyImport
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createSystem = /* GraphQL */ `
  mutation CreateSystem(
    $input: CreateSystemInput!
    $condition: ModelSystemConditionInput
  ) {
    createSystem(input: $input, condition: $condition) {
      id
      group
      defaultCostStandard
      defaultCostBundle
      defaultCostPerformance
      defaultCostRostering
      defaultCostStaff
      defaultCostVehicles
      importDisabled
      importPodDisabled
      importCxDisabled
      importPpsDisabled
      importDailyPpsDisabled
      importMentorDisabled
      importNetradyneDisabled
      importEocDisabled
      importCdfDisabled
      isZohoCrmDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSystem = /* GraphQL */ `
  mutation UpdateSystem(
    $input: UpdateSystemInput!
    $condition: ModelSystemConditionInput
  ) {
    updateSystem(input: $input, condition: $condition) {
      id
      group
      defaultCostStandard
      defaultCostBundle
      defaultCostPerformance
      defaultCostRostering
      defaultCostStaff
      defaultCostVehicles
      importDisabled
      importPodDisabled
      importCxDisabled
      importPpsDisabled
      importDailyPpsDisabled
      importMentorDisabled
      importNetradyneDisabled
      importEocDisabled
      importCdfDisabled
      isZohoCrmDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSystem = /* GraphQL */ `
  mutation DeleteSystem(
    $input: DeleteSystemInput!
    $condition: ModelSystemConditionInput
  ) {
    deleteSystem(input: $input, condition: $condition) {
      id
      group
      defaultCostStandard
      defaultCostBundle
      defaultCostPerformance
      defaultCostRostering
      defaultCostStaff
      defaultCostVehicles
      importDisabled
      importPodDisabled
      importCxDisabled
      importPpsDisabled
      importDailyPpsDisabled
      importMentorDisabled
      importNetradyneDisabled
      importEocDisabled
      importCdfDisabled
      isZohoCrmDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTextractJob = /* GraphQL */ `
  mutation CreateTextractJob(
    $input: CreateTextractJobInput!
    $condition: ModelTextractJobConditionInput
  ) {
    createTextractJob(input: $input, condition: $condition) {
      id
      textractJobTenantId
      group
      owner
      userId
      key
      fileName
      week
      year
      template
      jobId
      jobStatus
      type
      isProcessed
      isProcessedS
      results
      summaryTableResults
      timeZone
      tenantUsesXL
      tenantUsesXLS
      customerSubType
      metadataCreationDate
      metadataModificationDate
      metadataYear
      metadataWeek
      scoreCardFailedValidators
      date
      automatedCoachingSendTime
      podQualitySummary {
        id
        podQualitySummaryTextractJobId
        group
        week
        year
        yearWeek
        success
        bypass
        rejects
        opportunities
        noPackageDetected
        packageNotClearlyVisible
        blurryPhoto
        packageTooClose
        humanInThePicture
        packageInHand
        photoTooDark
        packageInCar
        other
        grandTotal
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      cxFeedbackSummary {
        id
        cxFeedbackSummaryTextractJobId
        group
        week
        year
        yearWeek
        dcfTier
        dcfScore
        positiveFeedback
        negativeFeedback
        deliveriesWithoutCF
        deliveryWasGreat
        respectfulOfProperty
        followedInstructions
        friendly
        aboveAndBeyond
        deliveredWithCare
        thankMyDriver
        deliveryWasntGreat
        mishandledPackage
        driverUnprofessional
        driverDidNotFollowDeliveryInstructions
        onTime
        lateDelivery
        itemDamaged
        deliveredToWrongAddress
        neverReceivedDelivery
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateTextractJob = /* GraphQL */ `
  mutation UpdateTextractJob(
    $input: UpdateTextractJobInput!
    $condition: ModelTextractJobConditionInput
  ) {
    updateTextractJob(input: $input, condition: $condition) {
      id
      textractJobTenantId
      group
      owner
      userId
      key
      fileName
      week
      year
      template
      jobId
      jobStatus
      type
      isProcessed
      isProcessedS
      results
      summaryTableResults
      timeZone
      tenantUsesXL
      tenantUsesXLS
      customerSubType
      metadataCreationDate
      metadataModificationDate
      metadataYear
      metadataWeek
      scoreCardFailedValidators
      date
      automatedCoachingSendTime
      podQualitySummary {
        id
        podQualitySummaryTextractJobId
        group
        week
        year
        yearWeek
        success
        bypass
        rejects
        opportunities
        noPackageDetected
        packageNotClearlyVisible
        blurryPhoto
        packageTooClose
        humanInThePicture
        packageInHand
        photoTooDark
        packageInCar
        other
        grandTotal
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      cxFeedbackSummary {
        id
        cxFeedbackSummaryTextractJobId
        group
        week
        year
        yearWeek
        dcfTier
        dcfScore
        positiveFeedback
        negativeFeedback
        deliveriesWithoutCF
        deliveryWasGreat
        respectfulOfProperty
        followedInstructions
        friendly
        aboveAndBeyond
        deliveredWithCare
        thankMyDriver
        deliveryWasntGreat
        mishandledPackage
        driverUnprofessional
        driverDidNotFollowDeliveryInstructions
        onTime
        lateDelivery
        itemDamaged
        deliveredToWrongAddress
        neverReceivedDelivery
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteTextractJob = /* GraphQL */ `
  mutation DeleteTextractJob(
    $input: DeleteTextractJobInput!
    $condition: ModelTextractJobConditionInput
  ) {
    deleteTextractJob(input: $input, condition: $condition) {
      id
      textractJobTenantId
      group
      owner
      userId
      key
      fileName
      week
      year
      template
      jobId
      jobStatus
      type
      isProcessed
      isProcessedS
      results
      summaryTableResults
      timeZone
      tenantUsesXL
      tenantUsesXLS
      customerSubType
      metadataCreationDate
      metadataModificationDate
      metadataYear
      metadataWeek
      scoreCardFailedValidators
      date
      automatedCoachingSendTime
      podQualitySummary {
        id
        podQualitySummaryTextractJobId
        group
        week
        year
        yearWeek
        success
        bypass
        rejects
        opportunities
        noPackageDetected
        packageNotClearlyVisible
        blurryPhoto
        packageTooClose
        humanInThePicture
        packageInHand
        photoTooDark
        packageInCar
        other
        grandTotal
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      cxFeedbackSummary {
        id
        cxFeedbackSummaryTextractJobId
        group
        week
        year
        yearWeek
        dcfTier
        dcfScore
        positiveFeedback
        negativeFeedback
        deliveriesWithoutCF
        deliveryWasGreat
        respectfulOfProperty
        followedInstructions
        friendly
        aboveAndBeyond
        deliveredWithCare
        thankMyDriver
        deliveryWasntGreat
        mishandledPackage
        driverUnprofessional
        driverDidNotFollowDeliveryInstructions
        onTime
        lateDelivery
        itemDamaged
        deliveredToWrongAddress
        neverReceivedDelivery
        textractJob {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createPodQualitySummary = /* GraphQL */ `
  mutation CreatePodQualitySummary(
    $input: CreatePodQualitySummaryInput!
    $condition: ModelPodQualitySummaryConditionInput
  ) {
    createPodQualitySummary(input: $input, condition: $condition) {
      id
      podQualitySummaryTextractJobId
      group
      week
      year
      yearWeek
      success
      bypass
      rejects
      opportunities
      noPackageDetected
      packageNotClearlyVisible
      blurryPhoto
      packageTooClose
      humanInThePicture
      packageInHand
      photoTooDark
      packageInCar
      other
      grandTotal
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePodQualitySummary = /* GraphQL */ `
  mutation UpdatePodQualitySummary(
    $input: UpdatePodQualitySummaryInput!
    $condition: ModelPodQualitySummaryConditionInput
  ) {
    updatePodQualitySummary(input: $input, condition: $condition) {
      id
      podQualitySummaryTextractJobId
      group
      week
      year
      yearWeek
      success
      bypass
      rejects
      opportunities
      noPackageDetected
      packageNotClearlyVisible
      blurryPhoto
      packageTooClose
      humanInThePicture
      packageInHand
      photoTooDark
      packageInCar
      other
      grandTotal
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePodQualitySummary = /* GraphQL */ `
  mutation DeletePodQualitySummary(
    $input: DeletePodQualitySummaryInput!
    $condition: ModelPodQualitySummaryConditionInput
  ) {
    deletePodQualitySummary(input: $input, condition: $condition) {
      id
      podQualitySummaryTextractJobId
      group
      week
      year
      yearWeek
      success
      bypass
      rejects
      opportunities
      noPackageDetected
      packageNotClearlyVisible
      blurryPhoto
      packageTooClose
      humanInThePicture
      packageInHand
      photoTooDark
      packageInCar
      other
      grandTotal
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCxFeedbackSummary = /* GraphQL */ `
  mutation CreateCxFeedbackSummary(
    $input: CreateCxFeedbackSummaryInput!
    $condition: ModelCxFeedbackSummaryConditionInput
  ) {
    createCxFeedbackSummary(input: $input, condition: $condition) {
      id
      cxFeedbackSummaryTextractJobId
      group
      week
      year
      yearWeek
      dcfTier
      dcfScore
      positiveFeedback
      negativeFeedback
      deliveriesWithoutCF
      deliveryWasGreat
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      deliveryWasntGreat
      mishandledPackage
      driverUnprofessional
      driverDidNotFollowDeliveryInstructions
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCxFeedbackSummary = /* GraphQL */ `
  mutation UpdateCxFeedbackSummary(
    $input: UpdateCxFeedbackSummaryInput!
    $condition: ModelCxFeedbackSummaryConditionInput
  ) {
    updateCxFeedbackSummary(input: $input, condition: $condition) {
      id
      cxFeedbackSummaryTextractJobId
      group
      week
      year
      yearWeek
      dcfTier
      dcfScore
      positiveFeedback
      negativeFeedback
      deliveriesWithoutCF
      deliveryWasGreat
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      deliveryWasntGreat
      mishandledPackage
      driverUnprofessional
      driverDidNotFollowDeliveryInstructions
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCxFeedbackSummary = /* GraphQL */ `
  mutation DeleteCxFeedbackSummary(
    $input: DeleteCxFeedbackSummaryInput!
    $condition: ModelCxFeedbackSummaryConditionInput
  ) {
    deleteCxFeedbackSummary(input: $input, condition: $condition) {
      id
      cxFeedbackSummaryTextractJobId
      group
      week
      year
      yearWeek
      dcfTier
      dcfScore
      positiveFeedback
      negativeFeedback
      deliveriesWithoutCF
      deliveryWasGreat
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      deliveryWasntGreat
      mishandledPackage
      driverUnprofessional
      driverDidNotFollowDeliveryInstructions
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      textractJob {
        id
        textractJobTenantId
        group
        owner
        userId
        key
        fileName
        week
        year
        template
        jobId
        jobStatus
        type
        isProcessed
        isProcessedS
        results
        summaryTableResults
        timeZone
        tenantUsesXL
        tenantUsesXLS
        customerSubType
        metadataCreationDate
        metadataModificationDate
        metadataYear
        metadataWeek
        scoreCardFailedValidators
        date
        automatedCoachingSendTime
        podQualitySummary {
          id
          podQualitySummaryTextractJobId
          group
          week
          year
          yearWeek
          success
          bypass
          rejects
          opportunities
          noPackageDetected
          packageNotClearlyVisible
          blurryPhoto
          packageTooClose
          humanInThePicture
          packageInHand
          photoTooDark
          packageInCar
          other
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        cxFeedbackSummary {
          id
          cxFeedbackSummaryTextractJobId
          group
          week
          year
          yearWeek
          dcfTier
          dcfScore
          positiveFeedback
          negativeFeedback
          deliveriesWithoutCF
          deliveryWasGreat
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          deliveryWasntGreat
          mishandledPackage
          driverUnprofessional
          driverDidNotFollowDeliveryInstructions
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStripeQueue = /* GraphQL */ `
  mutation CreateStripeQueue(
    $input: CreateStripeQueueInput!
    $condition: ModelStripeQueueConditionInput
  ) {
    createStripeQueue(input: $input, condition: $condition) {
      id
      group
      tenant
      result
      invoiceId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateStripeQueue = /* GraphQL */ `
  mutation UpdateStripeQueue(
    $input: UpdateStripeQueueInput!
    $condition: ModelStripeQueueConditionInput
  ) {
    updateStripeQueue(input: $input, condition: $condition) {
      id
      group
      tenant
      result
      invoiceId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteStripeQueue = /* GraphQL */ `
  mutation DeleteStripeQueue(
    $input: DeleteStripeQueueInput!
    $condition: ModelStripeQueueConditionInput
  ) {
    deleteStripeQueue(input: $input, condition: $condition) {
      id
      group
      tenant
      result
      invoiceId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAuditLogArchive = /* GraphQL */ `
  mutation CreateAuditLogArchive(
    $input: CreateAuditLogArchiveInput!
    $condition: ModelAuditLogArchiveConditionInput
  ) {
    createAuditLogArchive(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      auditLogCreatedAt
      createdAt
      ipAddress
      ttl
      pageUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const updateAuditLogArchive = /* GraphQL */ `
  mutation UpdateAuditLogArchive(
    $input: UpdateAuditLogArchiveInput!
    $condition: ModelAuditLogArchiveConditionInput
  ) {
    updateAuditLogArchive(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      auditLogCreatedAt
      createdAt
      ipAddress
      ttl
      pageUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const deleteAuditLogArchive = /* GraphQL */ `
  mutation DeleteAuditLogArchive(
    $input: DeleteAuditLogArchiveInput!
    $condition: ModelAuditLogArchiveConditionInput
  ) {
    deleteAuditLogArchive(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      auditLogCreatedAt
      createdAt
      ipAddress
      ttl
      pageUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const createNickname = /* GraphQL */ `
  mutation CreateNickname(
    $input: CreateNicknameInput!
    $condition: ModelNicknameConditionInput
  ) {
    createNickname(input: $input, condition: $condition) {
      id
      name
      nicknames
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNickname = /* GraphQL */ `
  mutation UpdateNickname(
    $input: UpdateNicknameInput!
    $condition: ModelNicknameConditionInput
  ) {
    updateNickname(input: $input, condition: $condition) {
      id
      name
      nicknames
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNickname = /* GraphQL */ `
  mutation DeleteNickname(
    $input: DeleteNicknameInput!
    $condition: ModelNicknameConditionInput
  ) {
    deleteNickname(input: $input, condition: $condition) {
      id
      name
      nicknames
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAccident = /* GraphQL */ `
  mutation CreateAccident(
    $input: CreateAccidentInput!
    $condition: ModelAccidentConditionInput
  ) {
    createAccident(input: $input, condition: $condition) {
      id
      accidentVehicleId
      accidentStaffId
      accidentVerifiedById
      accidentMaintenanceVehicleId
      accidentDamageVehicleId
      accidentOdometerReadingVehicleId
      accidentVehicleDamageRouteId
      accidentOptionCustomListId
      accidentCreatedByUserId
      group
      atFault
      drugTestDate
      drugTestResult
      accidentDate
      accidentType
      associateStatement
      witnessName
      witnessStatement
      address
      addressCity
      addressState
      addressZip
      fileName
      verifiedDate
      notes
      insuranceClaimNumber
      policeDepartment
      policeOfficerName
      policeReportNumber
      staffId
      vehicleId
      vehicleHistoryType
      services
      location
      maintenanceStatus
      maintenanceDateCompleted
      mileageAsOfMaintenance
      mileage
      time
      damage
      damageSeverity
      vehicleDamageDate
      odometerDate
      odometerType
      costOfServices
      createdAt
      updatedAt
      incidentDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageImages {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageRoute {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      verifiedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      maintenanceVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      damageVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      odometerReadingVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateAccident = /* GraphQL */ `
  mutation UpdateAccident(
    $input: UpdateAccidentInput!
    $condition: ModelAccidentConditionInput
  ) {
    updateAccident(input: $input, condition: $condition) {
      id
      accidentVehicleId
      accidentStaffId
      accidentVerifiedById
      accidentMaintenanceVehicleId
      accidentDamageVehicleId
      accidentOdometerReadingVehicleId
      accidentVehicleDamageRouteId
      accidentOptionCustomListId
      accidentCreatedByUserId
      group
      atFault
      drugTestDate
      drugTestResult
      accidentDate
      accidentType
      associateStatement
      witnessName
      witnessStatement
      address
      addressCity
      addressState
      addressZip
      fileName
      verifiedDate
      notes
      insuranceClaimNumber
      policeDepartment
      policeOfficerName
      policeReportNumber
      staffId
      vehicleId
      vehicleHistoryType
      services
      location
      maintenanceStatus
      maintenanceDateCompleted
      mileageAsOfMaintenance
      mileage
      time
      damage
      damageSeverity
      vehicleDamageDate
      odometerDate
      odometerType
      costOfServices
      createdAt
      updatedAt
      incidentDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageImages {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageRoute {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      verifiedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      maintenanceVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      damageVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      odometerReadingVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteAccident = /* GraphQL */ `
  mutation DeleteAccident(
    $input: DeleteAccidentInput!
    $condition: ModelAccidentConditionInput
  ) {
    deleteAccident(input: $input, condition: $condition) {
      id
      accidentVehicleId
      accidentStaffId
      accidentVerifiedById
      accidentMaintenanceVehicleId
      accidentDamageVehicleId
      accidentOdometerReadingVehicleId
      accidentVehicleDamageRouteId
      accidentOptionCustomListId
      accidentCreatedByUserId
      group
      atFault
      drugTestDate
      drugTestResult
      accidentDate
      accidentType
      associateStatement
      witnessName
      witnessStatement
      address
      addressCity
      addressState
      addressZip
      fileName
      verifiedDate
      notes
      insuranceClaimNumber
      policeDepartment
      policeOfficerName
      policeReportNumber
      staffId
      vehicleId
      vehicleHistoryType
      services
      location
      maintenanceStatus
      maintenanceDateCompleted
      mileageAsOfMaintenance
      mileage
      time
      damage
      damageSeverity
      vehicleDamageDate
      odometerDate
      odometerType
      costOfServices
      createdAt
      updatedAt
      incidentDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageImages {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceDocuments {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamageRoute {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      verifiedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      maintenanceVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      damageVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      odometerReadingVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createAttachment = /* GraphQL */ `
  mutation CreateAttachment(
    $input: CreateAttachmentInput!
    $condition: ModelAttachmentConditionInput
  ) {
    createAttachment(input: $input, condition: $condition) {
      id
      group
      createdAt
      s3Key
      expirationDate
      expirationTTL
      contentType
      fileSize
      updatedAt
      shortenUrl {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        items {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      message {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateAttachment = /* GraphQL */ `
  mutation UpdateAttachment(
    $input: UpdateAttachmentInput!
    $condition: ModelAttachmentConditionInput
  ) {
    updateAttachment(input: $input, condition: $condition) {
      id
      group
      createdAt
      s3Key
      expirationDate
      expirationTTL
      contentType
      fileSize
      updatedAt
      shortenUrl {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        items {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      message {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteAttachment = /* GraphQL */ `
  mutation DeleteAttachment(
    $input: DeleteAttachmentInput!
    $condition: ModelAttachmentConditionInput
  ) {
    deleteAttachment(input: $input, condition: $condition) {
      id
      group
      createdAt
      s3Key
      expirationDate
      expirationTTL
      contentType
      fileSize
      updatedAt
      shortenUrl {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        items {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      message {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createEocScore = /* GraphQL */ `
  mutation CreateEocScore(
    $input: CreateEocScoreInput!
    $condition: ModelEocScoreConditionInput
  ) {
    createEocScore(input: $input, condition: $condition) {
      id
      textractJobId
      eocScoreStaffId
      group
      date
      level
      average
      averageDailyCompliance
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateEocScore = /* GraphQL */ `
  mutation UpdateEocScore(
    $input: UpdateEocScoreInput!
    $condition: ModelEocScoreConditionInput
  ) {
    updateEocScore(input: $input, condition: $condition) {
      id
      textractJobId
      eocScoreStaffId
      group
      date
      level
      average
      averageDailyCompliance
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteEocScore = /* GraphQL */ `
  mutation DeleteEocScore(
    $input: DeleteEocScoreInput!
    $condition: ModelEocScoreConditionInput
  ) {
    deleteEocScore(input: $input, condition: $condition) {
      id
      textractJobId
      eocScoreStaffId
      group
      date
      level
      average
      averageDailyCompliance
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createCounseling = /* GraphQL */ `
  mutation CreateCounseling(
    $input: CreateCounselingInput!
    $condition: ModelCounselingConditionInput
  ) {
    createCounseling(input: $input, condition: $condition) {
      id
      counselingUserId
      counselingStaffId
      counselingSeverityId
      group
      date
      refusedToSign
      refusedByHeraUserId
      refusedToSignDateTime
      refusedByHeraUserExplanation
      signatureAcknowledge
      signature
      counselingNotes
      internalStaffNotes
      employeeNotes
      correctiveActionSummary
      priorDiscussionSummary
      consequencesOfFailure
      dateSent
      status
      scheduledToSendAt
      scheduledJobId
      dateSigned
      tenantId
      counselingTypeId
      createdFrom
      operationStatus
      createdAt
      updatedAt
      images {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      severity {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateCounseling = /* GraphQL */ `
  mutation UpdateCounseling(
    $input: UpdateCounselingInput!
    $condition: ModelCounselingConditionInput
  ) {
    updateCounseling(input: $input, condition: $condition) {
      id
      counselingUserId
      counselingStaffId
      counselingSeverityId
      group
      date
      refusedToSign
      refusedByHeraUserId
      refusedToSignDateTime
      refusedByHeraUserExplanation
      signatureAcknowledge
      signature
      counselingNotes
      internalStaffNotes
      employeeNotes
      correctiveActionSummary
      priorDiscussionSummary
      consequencesOfFailure
      dateSent
      status
      scheduledToSendAt
      scheduledJobId
      dateSigned
      tenantId
      counselingTypeId
      createdFrom
      operationStatus
      createdAt
      updatedAt
      images {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      severity {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteCounseling = /* GraphQL */ `
  mutation DeleteCounseling(
    $input: DeleteCounselingInput!
    $condition: ModelCounselingConditionInput
  ) {
    deleteCounseling(input: $input, condition: $condition) {
      id
      counselingUserId
      counselingStaffId
      counselingSeverityId
      group
      date
      refusedToSign
      refusedByHeraUserId
      refusedToSignDateTime
      refusedByHeraUserExplanation
      signatureAcknowledge
      signature
      counselingNotes
      internalStaffNotes
      employeeNotes
      correctiveActionSummary
      priorDiscussionSummary
      consequencesOfFailure
      dateSent
      status
      scheduledToSendAt
      scheduledJobId
      dateSigned
      tenantId
      counselingTypeId
      createdFrom
      operationStatus
      createdAt
      updatedAt
      images {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      severity {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMessageTemplate = /* GraphQL */ `
  mutation CreateMessageTemplate(
    $input: CreateMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    createMessageTemplate(input: $input, condition: $condition) {
      id
      group
      name
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessageTemplate = /* GraphQL */ `
  mutation UpdateMessageTemplate(
    $input: UpdateMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    updateMessageTemplate(input: $input, condition: $condition) {
      id
      group
      name
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessageTemplate = /* GraphQL */ `
  mutation DeleteMessageTemplate(
    $input: DeleteMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    deleteMessageTemplate(input: $input, condition: $condition) {
      id
      group
      name
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createShortenUrl = /* GraphQL */ `
  mutation CreateShortenUrl(
    $input: CreateShortenUrlInput!
    $condition: ModelShortenUrlConditionInput
  ) {
    createShortenUrl(input: $input, condition: $condition) {
      id
      shortenId
      attachmentId
      shortenUrlDailyLogId
      shortenUrlAttachmentId
      shortenUrlCounselingId
      shortenUrlAssociateId
      shortenUrlSentByUserId
      group
      type
      expirationTTL
      urlToken
      rosterChecklistSubjectId
      isOpenLink
      urlParameters
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateShortenUrl = /* GraphQL */ `
  mutation UpdateShortenUrl(
    $input: UpdateShortenUrlInput!
    $condition: ModelShortenUrlConditionInput
  ) {
    updateShortenUrl(input: $input, condition: $condition) {
      id
      shortenId
      attachmentId
      shortenUrlDailyLogId
      shortenUrlAttachmentId
      shortenUrlCounselingId
      shortenUrlAssociateId
      shortenUrlSentByUserId
      group
      type
      expirationTTL
      urlToken
      rosterChecklistSubjectId
      isOpenLink
      urlParameters
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteShortenUrl = /* GraphQL */ `
  mutation DeleteShortenUrl(
    $input: DeleteShortenUrlInput!
    $condition: ModelShortenUrlConditionInput
  ) {
    deleteShortenUrl(input: $input, condition: $condition) {
      id
      shortenId
      attachmentId
      shortenUrlDailyLogId
      shortenUrlAttachmentId
      shortenUrlCounselingId
      shortenUrlAssociateId
      shortenUrlSentByUserId
      group
      type
      expirationTTL
      urlToken
      rosterChecklistSubjectId
      isOpenLink
      urlParameters
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDailyRoster = /* GraphQL */ `
  mutation CreateDailyRoster(
    $input: CreateDailyRosterInput!
    $condition: ModelDailyRosterConditionInput
  ) {
    createDailyRoster(input: $input, condition: $condition) {
      id
      dailyRosterAttachmentId
      group
      notesDate
      lastStandUpSentTime
      userId
      creationRoute
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      notes {
        items {
          id
          noteDailyRosterId
          group
          type
          date
          text
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateDailyRoster = /* GraphQL */ `
  mutation UpdateDailyRoster(
    $input: UpdateDailyRosterInput!
    $condition: ModelDailyRosterConditionInput
  ) {
    updateDailyRoster(input: $input, condition: $condition) {
      id
      dailyRosterAttachmentId
      group
      notesDate
      lastStandUpSentTime
      userId
      creationRoute
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      notes {
        items {
          id
          noteDailyRosterId
          group
          type
          date
          text
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteDailyRoster = /* GraphQL */ `
  mutation DeleteDailyRoster(
    $input: DeleteDailyRosterInput!
    $condition: ModelDailyRosterConditionInput
  ) {
    deleteDailyRoster(input: $input, condition: $condition) {
      id
      dailyRosterAttachmentId
      group
      notesDate
      lastStandUpSentTime
      userId
      creationRoute
      createdAt
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      notes {
        items {
          id
          noteDailyRosterId
          group
          type
          date
          text
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSchedulerTask = /* GraphQL */ `
  mutation CreateSchedulerTask(
    $input: CreateSchedulerTaskInput!
    $condition: ModelSchedulerTaskConditionInput
  ) {
    createSchedulerTask(input: $input, condition: $condition) {
      id
      type
      apiEndpoint
      apiStage
      apiPath
      lambdaName
      group
      taskPayload
      scheduledDate
      executionId
      initiated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSchedulerTask = /* GraphQL */ `
  mutation UpdateSchedulerTask(
    $input: UpdateSchedulerTaskInput!
    $condition: ModelSchedulerTaskConditionInput
  ) {
    updateSchedulerTask(input: $input, condition: $condition) {
      id
      type
      apiEndpoint
      apiStage
      apiPath
      lambdaName
      group
      taskPayload
      scheduledDate
      executionId
      initiated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSchedulerTask = /* GraphQL */ `
  mutation DeleteSchedulerTask(
    $input: DeleteSchedulerTaskInput!
    $condition: ModelSchedulerTaskConditionInput
  ) {
    deleteSchedulerTask(input: $input, condition: $condition) {
      id
      type
      apiEndpoint
      apiStage
      apiPath
      lambdaName
      group
      taskPayload
      scheduledDate
      executionId
      initiated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRosterChecklist = /* GraphQL */ `
  mutation CreateRosterChecklist(
    $input: CreateRosterChecklistInput!
    $condition: ModelRosterChecklistConditionInput
  ) {
    createRosterChecklist(input: $input, condition: $condition) {
      id
      name
      completionFrequencyId
      assignedToId
      group
      sendTime
      totalSimpleItems
      totalVehicleItems
      status
      createdAt
      updatedAt
      vehicleTypes {
        items {
          id
          vehicleTypeId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignedUsers {
        items {
          id
          userId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checklistTasks {
        items {
          id
          type
          taskId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistItems {
        items {
          id
          typeId
          titleQuestion
          descriptionExplanation
          order
          group
          status
          rosterChecklistId
          requiredPhotoSpecifications
          photoSpecifications
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklist = /* GraphQL */ `
  mutation UpdateRosterChecklist(
    $input: UpdateRosterChecklistInput!
    $condition: ModelRosterChecklistConditionInput
  ) {
    updateRosterChecklist(input: $input, condition: $condition) {
      id
      name
      completionFrequencyId
      assignedToId
      group
      sendTime
      totalSimpleItems
      totalVehicleItems
      status
      createdAt
      updatedAt
      vehicleTypes {
        items {
          id
          vehicleTypeId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignedUsers {
        items {
          id
          userId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checklistTasks {
        items {
          id
          type
          taskId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistItems {
        items {
          id
          typeId
          titleQuestion
          descriptionExplanation
          order
          group
          status
          rosterChecklistId
          requiredPhotoSpecifications
          photoSpecifications
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklist = /* GraphQL */ `
  mutation DeleteRosterChecklist(
    $input: DeleteRosterChecklistInput!
    $condition: ModelRosterChecklistConditionInput
  ) {
    deleteRosterChecklist(input: $input, condition: $condition) {
      id
      name
      completionFrequencyId
      assignedToId
      group
      sendTime
      totalSimpleItems
      totalVehicleItems
      status
      createdAt
      updatedAt
      vehicleTypes {
        items {
          id
          vehicleTypeId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignedUsers {
        items {
          id
          userId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checklistTasks {
        items {
          id
          type
          taskId
          rosterChecklistId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistItems {
        items {
          id
          typeId
          titleQuestion
          descriptionExplanation
          order
          group
          status
          rosterChecklistId
          requiredPhotoSpecifications
          photoSpecifications
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistVehicleType = /* GraphQL */ `
  mutation CreateRosterChecklistVehicleType(
    $input: CreateRosterChecklistVehicleTypeInput!
    $condition: ModelRosterChecklistVehicleTypeConditionInput
  ) {
    createRosterChecklistVehicleType(input: $input, condition: $condition) {
      id
      vehicleTypeId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistVehicleType = /* GraphQL */ `
  mutation UpdateRosterChecklistVehicleType(
    $input: UpdateRosterChecklistVehicleTypeInput!
    $condition: ModelRosterChecklistVehicleTypeConditionInput
  ) {
    updateRosterChecklistVehicleType(input: $input, condition: $condition) {
      id
      vehicleTypeId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistVehicleType = /* GraphQL */ `
  mutation DeleteRosterChecklistVehicleType(
    $input: DeleteRosterChecklistVehicleTypeInput!
    $condition: ModelRosterChecklistVehicleTypeConditionInput
  ) {
    deleteRosterChecklistVehicleType(input: $input, condition: $condition) {
      id
      vehicleTypeId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistUser = /* GraphQL */ `
  mutation CreateRosterChecklistUser(
    $input: CreateRosterChecklistUserInput!
    $condition: ModelRosterChecklistUserConditionInput
  ) {
    createRosterChecklistUser(input: $input, condition: $condition) {
      id
      userId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistUser = /* GraphQL */ `
  mutation UpdateRosterChecklistUser(
    $input: UpdateRosterChecklistUserInput!
    $condition: ModelRosterChecklistUserConditionInput
  ) {
    updateRosterChecklistUser(input: $input, condition: $condition) {
      id
      userId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistUser = /* GraphQL */ `
  mutation DeleteRosterChecklistUser(
    $input: DeleteRosterChecklistUserInput!
    $condition: ModelRosterChecklistUserConditionInput
  ) {
    deleteRosterChecklistUser(input: $input, condition: $condition) {
      id
      userId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistTask = /* GraphQL */ `
  mutation CreateRosterChecklistTask(
    $input: CreateRosterChecklistTaskInput!
    $condition: ModelRosterChecklistTaskConditionInput
  ) {
    createRosterChecklistTask(input: $input, condition: $condition) {
      id
      type
      taskId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistTask = /* GraphQL */ `
  mutation UpdateRosterChecklistTask(
    $input: UpdateRosterChecklistTaskInput!
    $condition: ModelRosterChecklistTaskConditionInput
  ) {
    updateRosterChecklistTask(input: $input, condition: $condition) {
      id
      type
      taskId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistTask = /* GraphQL */ `
  mutation DeleteRosterChecklistTask(
    $input: DeleteRosterChecklistTaskInput!
    $condition: ModelRosterChecklistTaskConditionInput
  ) {
    deleteRosterChecklistTask(input: $input, condition: $condition) {
      id
      type
      taskId
      rosterChecklistId
      group
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistItem = /* GraphQL */ `
  mutation CreateRosterChecklistItem(
    $input: CreateRosterChecklistItemInput!
    $condition: ModelRosterChecklistItemConditionInput
  ) {
    createRosterChecklistItem(input: $input, condition: $condition) {
      id
      typeId
      titleQuestion
      descriptionExplanation
      order
      group
      status
      rosterChecklistId
      requiredPhotoSpecifications
      photoSpecifications
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistItem = /* GraphQL */ `
  mutation UpdateRosterChecklistItem(
    $input: UpdateRosterChecklistItemInput!
    $condition: ModelRosterChecklistItemConditionInput
  ) {
    updateRosterChecklistItem(input: $input, condition: $condition) {
      id
      typeId
      titleQuestion
      descriptionExplanation
      order
      group
      status
      rosterChecklistId
      requiredPhotoSpecifications
      photoSpecifications
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistItem = /* GraphQL */ `
  mutation DeleteRosterChecklistItem(
    $input: DeleteRosterChecklistItemInput!
    $condition: ModelRosterChecklistItemConditionInput
  ) {
    deleteRosterChecklistItem(input: $input, condition: $condition) {
      id
      typeId
      titleQuestion
      descriptionExplanation
      order
      group
      status
      rosterChecklistId
      requiredPhotoSpecifications
      photoSpecifications
      createdAt
      updatedAt
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      id
      group
      deviceName
      phoneNumber
      carrier
      status
      imei
      notes
      deviceType
      deviceOperatingSystem
      deviceEnrollmentDate
      deviceICCID
      deviceSoftwareUpdateStatus
      deviceMiradoreId
      deviceCarrierValueListItemId
      wirelessSupportConnection
      deviceNameMiradore
      latestLastPing
      latestBattery
      deviceLastMessageTimestamp
      deviceLastMessage
      model
      manufacturer
      createdAt
      updatedAt
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle2 {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      id
      group
      deviceName
      phoneNumber
      carrier
      status
      imei
      notes
      deviceType
      deviceOperatingSystem
      deviceEnrollmentDate
      deviceICCID
      deviceSoftwareUpdateStatus
      deviceMiradoreId
      deviceCarrierValueListItemId
      wirelessSupportConnection
      deviceNameMiradore
      latestLastPing
      latestBattery
      deviceLastMessageTimestamp
      deviceLastMessage
      model
      manufacturer
      createdAt
      updatedAt
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle2 {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      id
      group
      deviceName
      phoneNumber
      carrier
      status
      imei
      notes
      deviceType
      deviceOperatingSystem
      deviceEnrollmentDate
      deviceICCID
      deviceSoftwareUpdateStatus
      deviceMiradoreId
      deviceCarrierValueListItemId
      wirelessSupportConnection
      deviceNameMiradore
      latestLastPing
      latestBattery
      deviceLastMessageTimestamp
      deviceLastMessage
      model
      manufacturer
      createdAt
      updatedAt
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicle2 {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createDailyLog = /* GraphQL */ `
  mutation CreateDailyLog(
    $input: CreateDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    createDailyLog(input: $input, condition: $condition) {
      id
      dailyLogVehicleId
      dailyLogTakenByUserId
      dailyLogRosteredDayId
      dailyLogCreatedByUserId
      dailyLogTakenByAssociateId
      dailyLogCreationLinkSentByUserId
      dailyLogCreationLinkAssociateId
      reviewedByUserId
      group
      type
      date
      notes
      vehicleId
      creationLinkSentDateTime
      specificPhotos
      status
      flaggedAt
      flaggedByUserId
      reviewedAt
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosteredDay {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      history {
        items {
          id
          dailyLogHistoryDailyLogId
          date
          group
          previousValue
          currentValue
          dailyLogId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      creationLinkAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      creationLinkSentByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateDailyLog = /* GraphQL */ `
  mutation UpdateDailyLog(
    $input: UpdateDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    updateDailyLog(input: $input, condition: $condition) {
      id
      dailyLogVehicleId
      dailyLogTakenByUserId
      dailyLogRosteredDayId
      dailyLogCreatedByUserId
      dailyLogTakenByAssociateId
      dailyLogCreationLinkSentByUserId
      dailyLogCreationLinkAssociateId
      reviewedByUserId
      group
      type
      date
      notes
      vehicleId
      creationLinkSentDateTime
      specificPhotos
      status
      flaggedAt
      flaggedByUserId
      reviewedAt
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosteredDay {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      history {
        items {
          id
          dailyLogHistoryDailyLogId
          date
          group
          previousValue
          currentValue
          dailyLogId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      creationLinkAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      creationLinkSentByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteDailyLog = /* GraphQL */ `
  mutation DeleteDailyLog(
    $input: DeleteDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    deleteDailyLog(input: $input, condition: $condition) {
      id
      dailyLogVehicleId
      dailyLogTakenByUserId
      dailyLogRosteredDayId
      dailyLogCreatedByUserId
      dailyLogTakenByAssociateId
      dailyLogCreationLinkSentByUserId
      dailyLogCreationLinkAssociateId
      reviewedByUserId
      group
      type
      date
      notes
      vehicleId
      creationLinkSentDateTime
      specificPhotos
      status
      flaggedAt
      flaggedByUserId
      reviewedAt
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosteredDay {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      history {
        items {
          id
          dailyLogHistoryDailyLogId
          date
          group
          previousValue
          currentValue
          dailyLogId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      creationLinkAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      creationLinkSentByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDailyLogHistory = /* GraphQL */ `
  mutation CreateDailyLogHistory(
    $input: CreateDailyLogHistoryInput!
    $condition: ModelDailyLogHistoryConditionInput
  ) {
    createDailyLogHistory(input: $input, condition: $condition) {
      id
      dailyLogHistoryDailyLogId
      date
      group
      previousValue
      currentValue
      dailyLogId
      createdAt
      updatedAt
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateDailyLogHistory = /* GraphQL */ `
  mutation UpdateDailyLogHistory(
    $input: UpdateDailyLogHistoryInput!
    $condition: ModelDailyLogHistoryConditionInput
  ) {
    updateDailyLogHistory(input: $input, condition: $condition) {
      id
      dailyLogHistoryDailyLogId
      date
      group
      previousValue
      currentValue
      dailyLogId
      createdAt
      updatedAt
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteDailyLogHistory = /* GraphQL */ `
  mutation DeleteDailyLogHistory(
    $input: DeleteDailyLogHistoryInput!
    $condition: ModelDailyLogHistoryConditionInput
  ) {
    deleteDailyLogHistory(input: $input, condition: $condition) {
      id
      dailyLogHistoryDailyLogId
      date
      group
      previousValue
      currentValue
      dailyLogId
      createdAt
      updatedAt
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      documentStaffId
      documentRouteId
      documentVehicleId
      documentIncidentId
      documentInfractionId
      documentImageCounselingId
      documentImagevehicleDamageId
      documentOptionCustomListsId
      documentMaintenanceId
      documentReplaceByRouteId
      documentInjuryId
      documentDailyLogId
      documentShortenUrlId
      documentTakenByUserId
      documentTakenByAssociateId
      documentRosterChecklistSubjectItemId
      documentSchedulingRequestId
      group
      name
      key
      type
      uploadDate
      notes
      documentDate
      isDocVisibleToAssociate
      folderPath
      operationStatus
      externalDocId
      aiSubmissionDateTime
      aiResponseDateTime
      aiResponse
      aiResponseStatus
      aiIssues
      aiResponseAcknowledgedDateTime
      aiResponseFeedback
      aiDeterminedOdometerReadingValue
      aiResponseAcknowledgedBy
      aiSubmittedPrompt
      createdAt
      updatedAt
      incident {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imagevehicleDamage {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      maintenance {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imageCounseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      infraction {
        id
        infractionTypeId
        infractionStaffId
        infractionRouteId
        infractionCounselingId
        group
        infractionType
        comment
        date
        time
        staffId
        station
        trackingNumber
        infractionTier
        infractionDescription
        appealDate
        resolvedDate
        appealStatus
        appealNotes
        miscNotes
        createdFrom
        createdAt
        updatedAt
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injury {
        id
        injuryStaffId
        injuryCompletedByUserId
        group
        createdAt
        caseNumber
        injuryDate
        injuryTime
        injuryTimeIsUnknown
        timeStaffStartedWork
        completedBy
        completedByTitle
        completedByPhone
        driverHireDate
        driverDOB
        driverGender
        driverAddress
        driverCity
        driverState
        driverZip
        physicianName
        physicianFacility
        physicianAddress
        physicianCity
        physicianState
        physicianZip
        wasTreatedInER
        wasHospitalizedOvernight
        descriptionBeforeAccident
        descriptionInjury
        descriptionIncident
        descriptionDirectHarmCause
        injuryType
        notes
        dateOfDeath
        caseNumberFromLog
        staffId
        updatedAt
        documents {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        completedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomLists {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    updateDocument(input: $input, condition: $condition) {
      id
      documentStaffId
      documentRouteId
      documentVehicleId
      documentIncidentId
      documentInfractionId
      documentImageCounselingId
      documentImagevehicleDamageId
      documentOptionCustomListsId
      documentMaintenanceId
      documentReplaceByRouteId
      documentInjuryId
      documentDailyLogId
      documentShortenUrlId
      documentTakenByUserId
      documentTakenByAssociateId
      documentRosterChecklistSubjectItemId
      documentSchedulingRequestId
      group
      name
      key
      type
      uploadDate
      notes
      documentDate
      isDocVisibleToAssociate
      folderPath
      operationStatus
      externalDocId
      aiSubmissionDateTime
      aiResponseDateTime
      aiResponse
      aiResponseStatus
      aiIssues
      aiResponseAcknowledgedDateTime
      aiResponseFeedback
      aiDeterminedOdometerReadingValue
      aiResponseAcknowledgedBy
      aiSubmittedPrompt
      createdAt
      updatedAt
      incident {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imagevehicleDamage {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      maintenance {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imageCounseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      infraction {
        id
        infractionTypeId
        infractionStaffId
        infractionRouteId
        infractionCounselingId
        group
        infractionType
        comment
        date
        time
        staffId
        station
        trackingNumber
        infractionTier
        infractionDescription
        appealDate
        resolvedDate
        appealStatus
        appealNotes
        miscNotes
        createdFrom
        createdAt
        updatedAt
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injury {
        id
        injuryStaffId
        injuryCompletedByUserId
        group
        createdAt
        caseNumber
        injuryDate
        injuryTime
        injuryTimeIsUnknown
        timeStaffStartedWork
        completedBy
        completedByTitle
        completedByPhone
        driverHireDate
        driverDOB
        driverGender
        driverAddress
        driverCity
        driverState
        driverZip
        physicianName
        physicianFacility
        physicianAddress
        physicianCity
        physicianState
        physicianZip
        wasTreatedInER
        wasHospitalizedOvernight
        descriptionBeforeAccident
        descriptionInjury
        descriptionIncident
        descriptionDirectHarmCause
        injuryType
        notes
        dateOfDeath
        caseNumberFromLog
        staffId
        updatedAt
        documents {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        completedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomLists {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument(
    $input: DeleteDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    deleteDocument(input: $input, condition: $condition) {
      id
      documentStaffId
      documentRouteId
      documentVehicleId
      documentIncidentId
      documentInfractionId
      documentImageCounselingId
      documentImagevehicleDamageId
      documentOptionCustomListsId
      documentMaintenanceId
      documentReplaceByRouteId
      documentInjuryId
      documentDailyLogId
      documentShortenUrlId
      documentTakenByUserId
      documentTakenByAssociateId
      documentRosterChecklistSubjectItemId
      documentSchedulingRequestId
      group
      name
      key
      type
      uploadDate
      notes
      documentDate
      isDocVisibleToAssociate
      folderPath
      operationStatus
      externalDocId
      aiSubmissionDateTime
      aiResponseDateTime
      aiResponse
      aiResponseStatus
      aiIssues
      aiResponseAcknowledgedDateTime
      aiResponseFeedback
      aiDeterminedOdometerReadingValue
      aiResponseAcknowledgedBy
      aiSubmittedPrompt
      createdAt
      updatedAt
      incident {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imagevehicleDamage {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      maintenance {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      imageCounseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      infraction {
        id
        infractionTypeId
        infractionStaffId
        infractionRouteId
        infractionCounselingId
        group
        infractionType
        comment
        date
        time
        staffId
        station
        trackingNumber
        infractionTier
        infractionDescription
        appealDate
        resolvedDate
        appealStatus
        appealNotes
        miscNotes
        createdFrom
        createdAt
        updatedAt
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injury {
        id
        injuryStaffId
        injuryCompletedByUserId
        group
        createdAt
        caseNumber
        injuryDate
        injuryTime
        injuryTimeIsUnknown
        timeStaffStartedWork
        completedBy
        completedByTitle
        completedByPhone
        driverHireDate
        driverDOB
        driverGender
        driverAddress
        driverCity
        driverState
        driverZip
        physicianName
        physicianFacility
        physicianAddress
        physicianCity
        physicianState
        physicianZip
        wasTreatedInER
        wasHospitalizedOvernight
        descriptionBeforeAccident
        descriptionInjury
        descriptionIncident
        descriptionDirectHarmCause
        injuryType
        notes
        dateOfDeath
        caseNumberFromLog
        staffId
        updatedAt
        documents {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        completedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      takenByAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomLists {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      takenByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDrugTest = /* GraphQL */ `
  mutation CreateDrugTest(
    $input: CreateDrugTestInput!
    $condition: ModelDrugTestConditionInput
  ) {
    createDrugTest(input: $input, condition: $condition) {
      id
      drugTestStaffId
      group
      date
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateDrugTest = /* GraphQL */ `
  mutation UpdateDrugTest(
    $input: UpdateDrugTestInput!
    $condition: ModelDrugTestConditionInput
  ) {
    updateDrugTest(input: $input, condition: $condition) {
      id
      drugTestStaffId
      group
      date
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteDrugTest = /* GraphQL */ `
  mutation DeleteDrugTest(
    $input: DeleteDrugTestInput!
    $condition: ModelDrugTestConditionInput
  ) {
    deleteDrugTest(input: $input, condition: $condition) {
      id
      drugTestStaffId
      group
      date
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createInfraction = /* GraphQL */ `
  mutation CreateInfraction(
    $input: CreateInfractionInput!
    $condition: ModelInfractionConditionInput
  ) {
    createInfraction(input: $input, condition: $condition) {
      id
      infractionTypeId
      infractionStaffId
      infractionRouteId
      infractionCounselingId
      group
      infractionType
      comment
      date
      time
      staffId
      station
      trackingNumber
      infractionTier
      infractionDescription
      appealDate
      resolvedDate
      appealStatus
      appealNotes
      miscNotes
      createdFrom
      createdAt
      updatedAt
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateInfraction = /* GraphQL */ `
  mutation UpdateInfraction(
    $input: UpdateInfractionInput!
    $condition: ModelInfractionConditionInput
  ) {
    updateInfraction(input: $input, condition: $condition) {
      id
      infractionTypeId
      infractionStaffId
      infractionRouteId
      infractionCounselingId
      group
      infractionType
      comment
      date
      time
      staffId
      station
      trackingNumber
      infractionTier
      infractionDescription
      appealDate
      resolvedDate
      appealStatus
      appealNotes
      miscNotes
      createdFrom
      createdAt
      updatedAt
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteInfraction = /* GraphQL */ `
  mutation DeleteInfraction(
    $input: DeleteInfractionInput!
    $condition: ModelInfractionConditionInput
  ) {
    deleteInfraction(input: $input, condition: $condition) {
      id
      infractionTypeId
      infractionStaffId
      infractionRouteId
      infractionCounselingId
      group
      infractionType
      comment
      date
      time
      staffId
      station
      trackingNumber
      infractionTier
      infractionDescription
      appealDate
      resolvedDate
      appealStatus
      appealNotes
      miscNotes
      createdFrom
      createdAt
      updatedAt
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createInjury = /* GraphQL */ `
  mutation CreateInjury(
    $input: CreateInjuryInput!
    $condition: ModelInjuryConditionInput
  ) {
    createInjury(input: $input, condition: $condition) {
      id
      injuryStaffId
      injuryCompletedByUserId
      group
      createdAt
      caseNumber
      injuryDate
      injuryTime
      injuryTimeIsUnknown
      timeStaffStartedWork
      completedBy
      completedByTitle
      completedByPhone
      driverHireDate
      driverDOB
      driverGender
      driverAddress
      driverCity
      driverState
      driverZip
      physicianName
      physicianFacility
      physicianAddress
      physicianCity
      physicianState
      physicianZip
      wasTreatedInER
      wasHospitalizedOvernight
      descriptionBeforeAccident
      descriptionInjury
      descriptionIncident
      descriptionDirectHarmCause
      injuryType
      notes
      dateOfDeath
      caseNumberFromLog
      staffId
      updatedAt
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      completedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateInjury = /* GraphQL */ `
  mutation UpdateInjury(
    $input: UpdateInjuryInput!
    $condition: ModelInjuryConditionInput
  ) {
    updateInjury(input: $input, condition: $condition) {
      id
      injuryStaffId
      injuryCompletedByUserId
      group
      createdAt
      caseNumber
      injuryDate
      injuryTime
      injuryTimeIsUnknown
      timeStaffStartedWork
      completedBy
      completedByTitle
      completedByPhone
      driverHireDate
      driverDOB
      driverGender
      driverAddress
      driverCity
      driverState
      driverZip
      physicianName
      physicianFacility
      physicianAddress
      physicianCity
      physicianState
      physicianZip
      wasTreatedInER
      wasHospitalizedOvernight
      descriptionBeforeAccident
      descriptionInjury
      descriptionIncident
      descriptionDirectHarmCause
      injuryType
      notes
      dateOfDeath
      caseNumberFromLog
      staffId
      updatedAt
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      completedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteInjury = /* GraphQL */ `
  mutation DeleteInjury(
    $input: DeleteInjuryInput!
    $condition: ModelInjuryConditionInput
  ) {
    deleteInjury(input: $input, condition: $condition) {
      id
      injuryStaffId
      injuryCompletedByUserId
      group
      createdAt
      caseNumber
      injuryDate
      injuryTime
      injuryTimeIsUnknown
      timeStaffStartedWork
      completedBy
      completedByTitle
      completedByPhone
      driverHireDate
      driverDOB
      driverGender
      driverAddress
      driverCity
      driverState
      driverZip
      physicianName
      physicianFacility
      physicianAddress
      physicianCity
      physicianState
      physicianZip
      wasTreatedInER
      wasHospitalizedOvernight
      descriptionBeforeAccident
      descriptionInjury
      descriptionIncident
      descriptionDirectHarmCause
      injuryType
      notes
      dateOfDeath
      caseNumberFromLog
      staffId
      updatedAt
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      completedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createInvoice = /* GraphQL */ `
  mutation CreateInvoice(
    $input: CreateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    createInvoice(input: $input, condition: $condition) {
      id
      invoiceTenantId
      createdAt
      group
      month
      year
      invoiceTotal
      variableTotal
      invoiceSubTotal
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      paidByCustomerAmount
      averageActiveDriverCount
      status
      html
      cardLastFourCharged
      updatedAt
      invoiceLineItems {
        items {
          id
          invoiceLineItemInvoiceId
          createdAt
          group
          date
          month
          year
          day
          isTrial
          activeStaff
          standardCost
          standardCostExt
          bundleCost
          bundleCostExt
          performanceCost
          performanceCostExt
          rosteringCost
          rosteringCostExt
          staffCost
          staffCostExt
          vehiclesCost
          vehiclesCostExt
          messagingCost
          messagingCostExt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateInvoice = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      id
      invoiceTenantId
      createdAt
      group
      month
      year
      invoiceTotal
      variableTotal
      invoiceSubTotal
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      paidByCustomerAmount
      averageActiveDriverCount
      status
      html
      cardLastFourCharged
      updatedAt
      invoiceLineItems {
        items {
          id
          invoiceLineItemInvoiceId
          createdAt
          group
          date
          month
          year
          day
          isTrial
          activeStaff
          standardCost
          standardCostExt
          bundleCost
          bundleCostExt
          performanceCost
          performanceCostExt
          rosteringCost
          rosteringCostExt
          staffCost
          staffCostExt
          vehiclesCost
          vehiclesCostExt
          messagingCost
          messagingCostExt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteInvoice = /* GraphQL */ `
  mutation DeleteInvoice(
    $input: DeleteInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    deleteInvoice(input: $input, condition: $condition) {
      id
      invoiceTenantId
      createdAt
      group
      month
      year
      invoiceTotal
      variableTotal
      invoiceSubTotal
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      paidByCustomerAmount
      averageActiveDriverCount
      status
      html
      cardLastFourCharged
      updatedAt
      invoiceLineItems {
        items {
          id
          invoiceLineItemInvoiceId
          createdAt
          group
          date
          month
          year
          day
          isTrial
          activeStaff
          standardCost
          standardCostExt
          bundleCost
          bundleCostExt
          performanceCost
          performanceCostExt
          rosteringCost
          rosteringCostExt
          staffCost
          staffCostExt
          vehiclesCost
          vehiclesCostExt
          messagingCost
          messagingCostExt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createInvoiceLineItem = /* GraphQL */ `
  mutation CreateInvoiceLineItem(
    $input: CreateInvoiceLineItemInput!
    $condition: ModelInvoiceLineItemConditionInput
  ) {
    createInvoiceLineItem(input: $input, condition: $condition) {
      id
      invoiceLineItemInvoiceId
      createdAt
      group
      date
      month
      year
      day
      isTrial
      activeStaff
      standardCost
      standardCostExt
      bundleCost
      bundleCostExt
      performanceCost
      performanceCostExt
      rosteringCost
      rosteringCostExt
      staffCost
      staffCostExt
      vehiclesCost
      vehiclesCostExt
      messagingCost
      messagingCostExt
      updatedAt
      invoice {
        id
        invoiceTenantId
        createdAt
        group
        month
        year
        invoiceTotal
        variableTotal
        invoiceSubTotal
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        paidByCustomerAmount
        averageActiveDriverCount
        status
        html
        cardLastFourCharged
        updatedAt
        invoiceLineItems {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateInvoiceLineItem = /* GraphQL */ `
  mutation UpdateInvoiceLineItem(
    $input: UpdateInvoiceLineItemInput!
    $condition: ModelInvoiceLineItemConditionInput
  ) {
    updateInvoiceLineItem(input: $input, condition: $condition) {
      id
      invoiceLineItemInvoiceId
      createdAt
      group
      date
      month
      year
      day
      isTrial
      activeStaff
      standardCost
      standardCostExt
      bundleCost
      bundleCostExt
      performanceCost
      performanceCostExt
      rosteringCost
      rosteringCostExt
      staffCost
      staffCostExt
      vehiclesCost
      vehiclesCostExt
      messagingCost
      messagingCostExt
      updatedAt
      invoice {
        id
        invoiceTenantId
        createdAt
        group
        month
        year
        invoiceTotal
        variableTotal
        invoiceSubTotal
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        paidByCustomerAmount
        averageActiveDriverCount
        status
        html
        cardLastFourCharged
        updatedAt
        invoiceLineItems {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteInvoiceLineItem = /* GraphQL */ `
  mutation DeleteInvoiceLineItem(
    $input: DeleteInvoiceLineItemInput!
    $condition: ModelInvoiceLineItemConditionInput
  ) {
    deleteInvoiceLineItem(input: $input, condition: $condition) {
      id
      invoiceLineItemInvoiceId
      createdAt
      group
      date
      month
      year
      day
      isTrial
      activeStaff
      standardCost
      standardCostExt
      bundleCost
      bundleCostExt
      performanceCost
      performanceCostExt
      rosteringCost
      rosteringCostExt
      staffCost
      staffCostExt
      vehiclesCost
      vehiclesCostExt
      messagingCost
      messagingCostExt
      updatedAt
      invoice {
        id
        invoiceTenantId
        createdAt
        group
        month
        year
        invoiceTotal
        variableTotal
        invoiceSubTotal
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        paidByCustomerAmount
        averageActiveDriverCount
        status
        html
        cardLastFourCharged
        updatedAt
        invoiceLineItems {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createKudo = /* GraphQL */ `
  mutation CreateKudo(
    $input: CreateKudoInput!
    $condition: ModelKudoConditionInput
  ) {
    createKudo(input: $input, condition: $condition) {
      id
      kudoTypeId
      kudoRouteId
      kudoStaffId
      group
      kudoType
      notes
      date
      time
      staffId
      createdFrom
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateKudo = /* GraphQL */ `
  mutation UpdateKudo(
    $input: UpdateKudoInput!
    $condition: ModelKudoConditionInput
  ) {
    updateKudo(input: $input, condition: $condition) {
      id
      kudoTypeId
      kudoRouteId
      kudoStaffId
      group
      kudoType
      notes
      date
      time
      staffId
      createdFrom
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteKudo = /* GraphQL */ `
  mutation DeleteKudo(
    $input: DeleteKudoInput!
    $condition: ModelKudoConditionInput
  ) {
    deleteKudo(input: $input, condition: $condition) {
      id
      kudoTypeId
      kudoRouteId
      kudoStaffId
      group
      kudoType
      notes
      date
      time
      staffId
      createdFrom
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      senderId
      staffId
      userId
      contactId
      messageRouteId
      messageTenantId
      messageAttachmentId
      messageReplaceByRouteId
      carrierMessageId
      group
      createdAt
      deviceId
      messageType
      channelType
      destinationNumber
      deviceDestinationNumber
      destinationEmail
      subject
      bodyText
      bodyHtml
      senderName
      smsStatus
      smsSendInformation
      deviceSmsStatus
      deviceSmsSendInformation
      emailStatus
      emailSendInformation
      inAppMessageStatus
      inAppMessageSendInformation
      phoneStatus
      phoneSendInformation
      sendbirdId
      isReadS
      sentBy
      sentAt
      linkExpiryDate
      attachmentLink
      contentType
      owner
      destinationName
      hasParts
      deviceAssociateId
      sendbirdTs
      rosterChecklistSubjectId
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      deviceAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      sender {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      isReadBy {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      senderId
      staffId
      userId
      contactId
      messageRouteId
      messageTenantId
      messageAttachmentId
      messageReplaceByRouteId
      carrierMessageId
      group
      createdAt
      deviceId
      messageType
      channelType
      destinationNumber
      deviceDestinationNumber
      destinationEmail
      subject
      bodyText
      bodyHtml
      senderName
      smsStatus
      smsSendInformation
      deviceSmsStatus
      deviceSmsSendInformation
      emailStatus
      emailSendInformation
      inAppMessageStatus
      inAppMessageSendInformation
      phoneStatus
      phoneSendInformation
      sendbirdId
      isReadS
      sentBy
      sentAt
      linkExpiryDate
      attachmentLink
      contentType
      owner
      destinationName
      hasParts
      deviceAssociateId
      sendbirdTs
      rosterChecklistSubjectId
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      deviceAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      sender {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      isReadBy {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      senderId
      staffId
      userId
      contactId
      messageRouteId
      messageTenantId
      messageAttachmentId
      messageReplaceByRouteId
      carrierMessageId
      group
      createdAt
      deviceId
      messageType
      channelType
      destinationNumber
      deviceDestinationNumber
      destinationEmail
      subject
      bodyText
      bodyHtml
      senderName
      smsStatus
      smsSendInformation
      deviceSmsStatus
      deviceSmsSendInformation
      emailStatus
      emailSendInformation
      inAppMessageStatus
      inAppMessageSendInformation
      phoneStatus
      phoneSendInformation
      sendbirdId
      isReadS
      sentBy
      sentAt
      linkExpiryDate
      attachmentLink
      contentType
      owner
      destinationName
      hasParts
      deviceAssociateId
      sendbirdTs
      rosterChecklistSubjectId
      updatedAt
      attachment {
        id
        group
        createdAt
        s3Key
        expirationDate
        expirationTTL
        contentType
        fileSize
        updatedAt
        shortenUrl {
          nextToken
          __typename
        }
        dailyRoster {
          nextToken
          __typename
        }
        message {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      deviceAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      sender {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      isReadBy {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createResourceUsage = /* GraphQL */ `
  mutation CreateResourceUsage(
    $input: CreateResourceUsageInput!
    $condition: ModelResourceUsageConditionInput
  ) {
    createResourceUsage(input: $input, condition: $condition) {
      id
      userInstanceId
      resourceUsageUserId
      resourceIdentifier
      group
      resourceType
      inUseAsOfDateTime
      connectionId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateResourceUsage = /* GraphQL */ `
  mutation UpdateResourceUsage(
    $input: UpdateResourceUsageInput!
    $condition: ModelResourceUsageConditionInput
  ) {
    updateResourceUsage(input: $input, condition: $condition) {
      id
      userInstanceId
      resourceUsageUserId
      resourceIdentifier
      group
      resourceType
      inUseAsOfDateTime
      connectionId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteResourceUsage = /* GraphQL */ `
  mutation DeleteResourceUsage(
    $input: DeleteResourceUsageInput!
    $condition: ModelResourceUsageConditionInput
  ) {
    deleteResourceUsage(input: $input, condition: $condition) {
      id
      userInstanceId
      resourceUsageUserId
      resourceIdentifier
      group
      resourceType
      inUseAsOfDateTime
      connectionId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createNote = /* GraphQL */ `
  mutation CreateNote(
    $input: CreateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    createNote(input: $input, condition: $condition) {
      id
      noteDailyRosterId
      group
      type
      date
      text
      createdAt
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      vehiclesMentioned {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffMentioned {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateNote = /* GraphQL */ `
  mutation UpdateNote(
    $input: UpdateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    updateNote(input: $input, condition: $condition) {
      id
      noteDailyRosterId
      group
      type
      date
      text
      createdAt
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      vehiclesMentioned {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffMentioned {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteNote = /* GraphQL */ `
  mutation DeleteNote(
    $input: DeleteNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    deleteNote(input: $input, condition: $condition) {
      id
      noteDailyRosterId
      group
      type
      date
      text
      createdAt
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      vehiclesMentioned {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffMentioned {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createVehicleMention = /* GraphQL */ `
  mutation CreateVehicleMention(
    $input: CreateVehicleMentionInput!
    $condition: ModelVehicleMentionConditionInput
  ) {
    createVehicleMention(input: $input, condition: $condition) {
      id
      vehicleMentionNoteId
      vehicleMentionVehicleId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicleMention = /* GraphQL */ `
  mutation UpdateVehicleMention(
    $input: UpdateVehicleMentionInput!
    $condition: ModelVehicleMentionConditionInput
  ) {
    updateVehicleMention(input: $input, condition: $condition) {
      id
      vehicleMentionNoteId
      vehicleMentionVehicleId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicleMention = /* GraphQL */ `
  mutation DeleteVehicleMention(
    $input: DeleteVehicleMentionInput!
    $condition: ModelVehicleMentionConditionInput
  ) {
    deleteVehicleMention(input: $input, condition: $condition) {
      id
      vehicleMentionNoteId
      vehicleMentionVehicleId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffMention = /* GraphQL */ `
  mutation CreateStaffMention(
    $input: CreateStaffMentionInput!
    $condition: ModelStaffMentionConditionInput
  ) {
    createStaffMention(input: $input, condition: $condition) {
      id
      staffMentionNoteId
      staffMentionStaffId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffMention = /* GraphQL */ `
  mutation UpdateStaffMention(
    $input: UpdateStaffMentionInput!
    $condition: ModelStaffMentionConditionInput
  ) {
    updateStaffMention(input: $input, condition: $condition) {
      id
      staffMentionNoteId
      staffMentionStaffId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffMention = /* GraphQL */ `
  mutation DeleteStaffMention(
    $input: DeleteStaffMentionInput!
    $condition: ModelStaffMentionConditionInput
  ) {
    deleteStaffMention(input: $input, condition: $condition) {
      id
      staffMentionNoteId
      staffMentionStaffId
      group
      date
      createdAt
      updatedAt
      note {
        id
        noteDailyRosterId
        group
        type
        date
        text
        createdAt
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        vehiclesMentioned {
          nextToken
          __typename
        }
        staffMentioned {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      group
      owner
      title
      createdAt
      description
      releaseNotes
      payload
      clickAction
      expirationTTL
      isReadS
      updatedAt
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      group
      owner
      title
      createdAt
      description
      releaseNotes
      payload
      clickAction
      expirationTTL
      isReadS
      updatedAt
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      group
      owner
      title
      createdAt
      description
      releaseNotes
      payload
      clickAction
      expirationTTL
      isReadS
      updatedAt
      __typename
    }
  }
`;
export const createCompanyNotification = /* GraphQL */ `
  mutation CreateCompanyNotification(
    $input: CreateCompanyNotificationInput!
    $condition: ModelCompanyNotificationConditionInput
  ) {
    createCompanyNotification(input: $input, condition: $condition) {
      id
      group
      streamTable
      affectedTable
      owner
      message
      expirationTTL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompanyNotification = /* GraphQL */ `
  mutation UpdateCompanyNotification(
    $input: UpdateCompanyNotificationInput!
    $condition: ModelCompanyNotificationConditionInput
  ) {
    updateCompanyNotification(input: $input, condition: $condition) {
      id
      group
      streamTable
      affectedTable
      owner
      message
      expirationTTL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompanyNotification = /* GraphQL */ `
  mutation DeleteCompanyNotification(
    $input: DeleteCompanyNotificationInput!
    $condition: ModelCompanyNotificationConditionInput
  ) {
    deleteCompanyNotification(input: $input, condition: $condition) {
      id
      group
      streamTable
      affectedTable
      owner
      message
      expirationTTL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOnBoard = /* GraphQL */ `
  mutation CreateOnBoard(
    $input: CreateOnBoardInput!
    $condition: ModelOnBoardConditionInput
  ) {
    createOnBoard(input: $input, condition: $condition) {
      id
      onBoardStaffId
      group
      name
      isComplete
      status
      dateComplete
      dateStart
      date3
      date4
      date5
      trainer
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateOnBoard = /* GraphQL */ `
  mutation UpdateOnBoard(
    $input: UpdateOnBoardInput!
    $condition: ModelOnBoardConditionInput
  ) {
    updateOnBoard(input: $input, condition: $condition) {
      id
      onBoardStaffId
      group
      name
      isComplete
      status
      dateComplete
      dateStart
      date3
      date4
      date5
      trainer
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteOnBoard = /* GraphQL */ `
  mutation DeleteOnBoard(
    $input: DeleteOnBoardInput!
    $condition: ModelOnBoardConditionInput
  ) {
    deleteOnBoard(input: $input, condition: $condition) {
      id
      onBoardStaffId
      group
      name
      isComplete
      status
      dateComplete
      dateStart
      date3
      date4
      date5
      trainer
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createPhysical = /* GraphQL */ `
  mutation CreatePhysical(
    $input: CreatePhysicalInput!
    $condition: ModelPhysicalConditionInput
  ) {
    createPhysical(input: $input, condition: $condition) {
      id
      physicalStaffId
      group
      date
      expirationDate
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePhysical = /* GraphQL */ `
  mutation UpdatePhysical(
    $input: UpdatePhysicalInput!
    $condition: ModelPhysicalConditionInput
  ) {
    updatePhysical(input: $input, condition: $condition) {
      id
      physicalStaffId
      group
      date
      expirationDate
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePhysical = /* GraphQL */ `
  mutation DeletePhysical(
    $input: DeletePhysicalInput!
    $condition: ModelPhysicalConditionInput
  ) {
    deletePhysical(input: $input, condition: $condition) {
      id
      physicalStaffId
      group
      date
      expirationDate
      location
      results
      file
      fileName
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createPodQuality = /* GraphQL */ `
  mutation CreatePodQuality(
    $input: CreatePodQualityInput!
    $condition: ModelPodQualityConditionInput
  ) {
    createPodQuality(input: $input, condition: $condition) {
      id
      podQualityStaffId
      group
      matched
      matchedS
      week
      year
      employeeName
      transporterId
      blurry
      explicit
      mailSlot
      noPackage
      other
      opportunities
      success
      bypass
      packageInHand
      notClearlyVisible
      packageTooClose
      personInPhoto
      photoTooDark
      takenFromCar
      grandTotal
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePodQuality = /* GraphQL */ `
  mutation UpdatePodQuality(
    $input: UpdatePodQualityInput!
    $condition: ModelPodQualityConditionInput
  ) {
    updatePodQuality(input: $input, condition: $condition) {
      id
      podQualityStaffId
      group
      matched
      matchedS
      week
      year
      employeeName
      transporterId
      blurry
      explicit
      mailSlot
      noPackage
      other
      opportunities
      success
      bypass
      packageInHand
      notClearlyVisible
      packageTooClose
      personInPhoto
      photoTooDark
      takenFromCar
      grandTotal
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePodQuality = /* GraphQL */ `
  mutation DeletePodQuality(
    $input: DeletePodQualityInput!
    $condition: ModelPodQualityConditionInput
  ) {
    deletePodQuality(input: $input, condition: $condition) {
      id
      podQualityStaffId
      group
      matched
      matchedS
      week
      year
      employeeName
      transporterId
      blurry
      explicit
      mailSlot
      noPackage
      other
      opportunities
      success
      bypass
      packageInHand
      notClearlyVisible
      packageTooClose
      personInPhoto
      photoTooDark
      takenFromCar
      grandTotal
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createReplaceByRoute = /* GraphQL */ `
  mutation CreateReplaceByRoute(
    $input: CreateReplaceByRouteInput!
    $condition: ModelReplaceByRouteConditionInput
  ) {
    createReplaceByRoute(input: $input, condition: $condition) {
      id
      replaceByRouteStaffId
      replaceByRouteRouteId
      replaceByRouteStatusId
      replaceByRouteDeviceId
      replaceByRouteVehicleId
      replaceByRouteDailyRosterId
      replaceByRouteParkingSpaceId
      group
      notes
      createdAt
      routeNumber
      staging
      helperStatus
      isNotActive
      standby
      time
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      lastBulkUploadDate
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateReplaceByRoute = /* GraphQL */ `
  mutation UpdateReplaceByRoute(
    $input: UpdateReplaceByRouteInput!
    $condition: ModelReplaceByRouteConditionInput
  ) {
    updateReplaceByRoute(input: $input, condition: $condition) {
      id
      replaceByRouteStaffId
      replaceByRouteRouteId
      replaceByRouteStatusId
      replaceByRouteDeviceId
      replaceByRouteVehicleId
      replaceByRouteDailyRosterId
      replaceByRouteParkingSpaceId
      group
      notes
      createdAt
      routeNumber
      staging
      helperStatus
      isNotActive
      standby
      time
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      lastBulkUploadDate
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteReplaceByRoute = /* GraphQL */ `
  mutation DeleteReplaceByRoute(
    $input: DeleteReplaceByRouteInput!
    $condition: ModelReplaceByRouteConditionInput
  ) {
    deleteReplaceByRoute(input: $input, condition: $condition) {
      id
      replaceByRouteStaffId
      replaceByRouteRouteId
      replaceByRouteStatusId
      replaceByRouteDeviceId
      replaceByRouteVehicleId
      replaceByRouteDailyRosterId
      replaceByRouteParkingSpaceId
      group
      notes
      createdAt
      routeNumber
      staging
      helperStatus
      isNotActive
      standby
      time
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      lastBulkUploadDate
      updatedAt
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      replaceByRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRoute = /* GraphQL */ `
  mutation CreateRoute(
    $input: CreateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    createRoute(input: $input, condition: $condition) {
      id
      routeDailyRosterId
      routeDeviceId
      routeStaffId
      routeVehicleId
      routeRescuerId
      routeParkingSpaceId
      routeHelperId
      routeStatusId
      routeHelperStatusId
      group
      notes
      routeNumber
      staging
      previousStatus
      statusChangedTime
      standby
      time
      isNotActive
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      helperUpdatedDateTime
      totalStops
      totalPackages
      completedStops
      completedPackages
      undeliveredPackagesTotal
      undeliveredPackagesBusinessClose
      undeliveredPackagesUnableToAccess
      undeliveredPackagesOtherAWS
      pickUpReturnPackage
      additionalPackagesFromRescue
      splitWithRosterAssignment
      additionalPackagesFromSplit
      firstStopTime
      lastStopTime
      daWorkStartTime
      daWorkEndTime
      daRouteStartTime
      daRouteEndTime
      rtsTime
      lunchStartTime
      lunchEndTime
      inspectionFueled
      inspectionCleaned
      inspectionFlashers
      inspectionCreditCard
      inspectionKeys
      inspectionDeviceCharger
      inspectionDeviceBattery
      inspectionNotes
      requiredVehicleTypeString
      expectedDurationHrs
      lastBulkUploadDate
      updatedAt
      createdAt
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rescuer {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      helper {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      helperStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      rescuers {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateRoute = /* GraphQL */ `
  mutation UpdateRoute(
    $input: UpdateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    updateRoute(input: $input, condition: $condition) {
      id
      routeDailyRosterId
      routeDeviceId
      routeStaffId
      routeVehicleId
      routeRescuerId
      routeParkingSpaceId
      routeHelperId
      routeStatusId
      routeHelperStatusId
      group
      notes
      routeNumber
      staging
      previousStatus
      statusChangedTime
      standby
      time
      isNotActive
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      helperUpdatedDateTime
      totalStops
      totalPackages
      completedStops
      completedPackages
      undeliveredPackagesTotal
      undeliveredPackagesBusinessClose
      undeliveredPackagesUnableToAccess
      undeliveredPackagesOtherAWS
      pickUpReturnPackage
      additionalPackagesFromRescue
      splitWithRosterAssignment
      additionalPackagesFromSplit
      firstStopTime
      lastStopTime
      daWorkStartTime
      daWorkEndTime
      daRouteStartTime
      daRouteEndTime
      rtsTime
      lunchStartTime
      lunchEndTime
      inspectionFueled
      inspectionCleaned
      inspectionFlashers
      inspectionCreditCard
      inspectionKeys
      inspectionDeviceCharger
      inspectionDeviceBattery
      inspectionNotes
      requiredVehicleTypeString
      expectedDurationHrs
      lastBulkUploadDate
      updatedAt
      createdAt
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rescuer {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      helper {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      helperStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      rescuers {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteRoute = /* GraphQL */ `
  mutation DeleteRoute(
    $input: DeleteRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    deleteRoute(input: $input, condition: $condition) {
      id
      routeDailyRosterId
      routeDeviceId
      routeStaffId
      routeVehicleId
      routeRescuerId
      routeParkingSpaceId
      routeHelperId
      routeStatusId
      routeHelperStatusId
      group
      notes
      routeNumber
      staging
      previousStatus
      statusChangedTime
      standby
      time
      isNotActive
      messageSentTime
      messageSentError
      receivedAnnouncement
      rescued
      helperUpdatedDateTime
      totalStops
      totalPackages
      completedStops
      completedPackages
      undeliveredPackagesTotal
      undeliveredPackagesBusinessClose
      undeliveredPackagesUnableToAccess
      undeliveredPackagesOtherAWS
      pickUpReturnPackage
      additionalPackagesFromRescue
      splitWithRosterAssignment
      additionalPackagesFromSplit
      firstStopTime
      lastStopTime
      daWorkStartTime
      daWorkEndTime
      daRouteStartTime
      daRouteEndTime
      rtsTime
      lunchStartTime
      lunchEndTime
      inspectionFueled
      inspectionCleaned
      inspectionFlashers
      inspectionCreditCard
      inspectionKeys
      inspectionDeviceCharger
      inspectionDeviceBattery
      inspectionNotes
      requiredVehicleTypeString
      expectedDurationHrs
      lastBulkUploadDate
      updatedAt
      createdAt
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      document {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      rescuer {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      helper {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rosterChecklistSubjects {
        items {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      status {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      helperStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      rescuers {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLabelType = /* GraphQL */ `
  mutation CreateLabelType(
    $input: CreateLabelTypeInput!
    $condition: ModelLabelTypeConditionInput
  ) {
    createLabelType(input: $input, condition: $condition) {
      id
      group
      name
      createdAt
      updatedAt
      labelList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLabelType = /* GraphQL */ `
  mutation UpdateLabelType(
    $input: UpdateLabelTypeInput!
    $condition: ModelLabelTypeConditionInput
  ) {
    updateLabelType(input: $input, condition: $condition) {
      id
      group
      name
      createdAt
      updatedAt
      labelList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLabelType = /* GraphQL */ `
  mutation DeleteLabelType(
    $input: DeleteLabelTypeInput!
    $condition: ModelLabelTypeConditionInput
  ) {
    deleteLabelType(input: $input, condition: $condition) {
      id
      group
      name
      createdAt
      updatedAt
      labelList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLabelTypeList = /* GraphQL */ `
  mutation CreateLabelTypeList(
    $input: CreateLabelTypeListInput!
    $condition: ModelLabelTypeListConditionInput
  ) {
    createLabelTypeList(input: $input, condition: $condition) {
      id
      labelTypeListLabelId
      labelTypeListTypeId
      group
      createdAt
      updatedAt
      type {
        id
        group
        name
        createdAt
        updatedAt
        labelList {
          nextToken
          __typename
        }
        __typename
      }
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateLabelTypeList = /* GraphQL */ `
  mutation UpdateLabelTypeList(
    $input: UpdateLabelTypeListInput!
    $condition: ModelLabelTypeListConditionInput
  ) {
    updateLabelTypeList(input: $input, condition: $condition) {
      id
      labelTypeListLabelId
      labelTypeListTypeId
      group
      createdAt
      updatedAt
      type {
        id
        group
        name
        createdAt
        updatedAt
        labelList {
          nextToken
          __typename
        }
        __typename
      }
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteLabelTypeList = /* GraphQL */ `
  mutation DeleteLabelTypeList(
    $input: DeleteLabelTypeListInput!
    $condition: ModelLabelTypeListConditionInput
  ) {
    deleteLabelTypeList(input: $input, condition: $condition) {
      id
      labelTypeListLabelId
      labelTypeListTypeId
      group
      createdAt
      updatedAt
      type {
        id
        group
        name
        createdAt
        updatedAt
        labelList {
          nextToken
          __typename
        }
        __typename
      }
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createLabel = /* GraphQL */ `
  mutation CreateLabel(
    $input: CreateLabelInput!
    $condition: ModelLabelConditionInput
  ) {
    createLabel(input: $input, condition: $condition) {
      id
      group
      name
      status
      createdAt
      updatedAt
      typeList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      items {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateLabel = /* GraphQL */ `
  mutation UpdateLabel(
    $input: UpdateLabelInput!
    $condition: ModelLabelConditionInput
  ) {
    updateLabel(input: $input, condition: $condition) {
      id
      group
      name
      status
      createdAt
      updatedAt
      typeList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      items {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteLabel = /* GraphQL */ `
  mutation DeleteLabel(
    $input: DeleteLabelInput!
    $condition: ModelLabelConditionInput
  ) {
    deleteLabel(input: $input, condition: $condition) {
      id
      group
      name
      status
      createdAt
      updatedAt
      typeList {
        items {
          id
          labelTypeListLabelId
          labelTypeListTypeId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      items {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createLabelSubscription = /* GraphQL */ `
  mutation CreateLabelSubscription(
    $input: CreateLabelSubscriptionInput!
    $condition: ModelLabelSubscriptionConditionInput
  ) {
    createLabelSubscription(input: $input, condition: $condition) {
      id
      labelId
      staffId
      vehicleId
      group
      createdAt
      updatedAt
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateLabelSubscription = /* GraphQL */ `
  mutation UpdateLabelSubscription(
    $input: UpdateLabelSubscriptionInput!
    $condition: ModelLabelSubscriptionConditionInput
  ) {
    updateLabelSubscription(input: $input, condition: $condition) {
      id
      labelId
      staffId
      vehicleId
      group
      createdAt
      updatedAt
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteLabelSubscription = /* GraphQL */ `
  mutation DeleteLabelSubscription(
    $input: DeleteLabelSubscriptionInput!
    $condition: ModelLabelSubscriptionConditionInput
  ) {
    deleteLabelSubscription(input: $input, condition: $condition) {
      id
      labelId
      staffId
      vehicleId
      group
      createdAt
      updatedAt
      label {
        id
        group
        name
        status
        createdAt
        updatedAt
        typeList {
          nextToken
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaff = /* GraphQL */ `
  mutation CreateStaff(
    $input: CreateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    createStaff(input: $input, condition: $condition) {
      id
      staffDefaultVehicleId
      staffDefaultVehicle2Id
      staffDefaultVehicle3Id
      group
      transporterId
      firstName
      lastName
      alternateNames
      phone
      email
      keyFocusArea
      coachingOpportunity
      status
      dlExpiration
      vehicleReport
      gasCardPin
      dob
      gender
      pronouns
      assignedLead
      isALead
      reportsToStaffId
      hourlyStatus
      hireDate
      terminationDate
      finalCheckIssueDate
      returnedUniform
      latestScorecard
      smsLastMessageTimestamp
      smsLastMessage
      vehicleType
      photo
      onboardingPinned
      netradyneDriverId
      heraScore
      heraRank
      prevHeraRank
      receiveTextMessages
      receiveTextMessagesChangeLog
      receiveEmailMessages
      receiveEmailMessagesChangeLog
      notes
      onboardingNotes
      customDeliveryVan
      authorizedLBS
      preferredDaysOff
      emailAddedToSuppressionListDateTime
      timesRescuerCounter
      timesRescuedCounter
      scoreCardsFantasticConsecutiveCounter
      scoreCardsFantasticCounter
      nickname
      overrideDisplayName
      displayName
      payrollProviderExternalId
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      eocScores {
        items {
          id
          textractJobId
          eocScoreStaffId
          group
          date
          level
          average
          averageDailyCompliance
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      drugTests {
        items {
          id
          drugTestStaffId
          group
          date
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      injuries {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deviceAssociateMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentionedInNotes {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onBoarding {
        items {
          id
          onBoardStaffId
          group
          name
          isComplete
          status
          dateComplete
          dateStart
          date3
          date4
          date5
          trainer
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      physicals {
        items {
          id
          physicalStaffId
          group
          date
          expirationDate
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      podQualities {
        items {
          id
          podQualityStaffId
          group
          matched
          matchedS
          week
          year
          employeeName
          transporterId
          blurry
          explicit
          mailSlot
          noPackage
          other
          opportunities
          success
          bypass
          packageInHand
          notClearlyVisible
          packageTooClose
          personInPhoto
          photoTooDark
          takenFromCar
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelper {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeRescuer {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagePreferencesHistory {
        items {
          id
          messagePreferencesHistoryStaffId
          group
          messagePreferenceType
          description
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      cxFeedback {
        items {
          id
          staffCxFeedbackStaffId
          group
          matched
          matchedS
          week
          year
          name
          messageHasBeenSent
          transporterId
          positiveFeedback
          negativeFeedback
          deliveryWasGreat
          deliveryWasntGreat
          totalDeliveries
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          careForOthers
          mishandledPackage
          drivingUnsafely
          driverUnprofessional
          notDeliveredToPreferredLocation
          noFeedback
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          daTier
          cdfScore
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentor {
        items {
          id
          textractJobId
          staffMentorStaffId
          group
          name
          matched
          messageHasBeenSent
          date
          station
          trips
          geotabTrips
          miles
          time
          fico
          accel
          braking
          cornering
          speeding
          distraction
          seatbelt
          backUp
          sse
          mpg
          idling
          engineOff
          preDvcr
          postDvcr
          trainingAssigned
          trainingCompleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      netrdadyneAlerts {
        items {
          id
          textractJobId
          staffNetradyneAlertStaffId
          group
          staffId
          matched
          matchedS
          driverName
          driverId
          groupName
          vehicleNumber
          vin
          alertId
          timestamp
          alertType
          alertSeverity
          description
          alertVideoStatus
          duration
          startLatLong
          endLatLong
          sortKey
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      scoreCards {
        items {
          id
          staffScoreCardStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          name
          transporterId
          overallTier
          delivered
          keyFocusArea
          ficoScore
          seatbeltOffRate
          cdf
          cdfDpmo
          ced
          dcr
          dcDpmo
          dar
          dsb
          psb
          swcPod
          swcCc
          swcSc
          swcAd
          dnrs
          podOpps
          ccOpps
          speedingEventRate
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          harshBrakingRate
          harshCorneringRate
          starRating
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffStatusHistory {
        items {
          id
          staffStatusStaffId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorizedToDrive {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      uniforms {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle2 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle3 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      routeRescuerStaff {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      properParkingSequences {
        items {
          id
          properParkingSequenceStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          date
          employeeName
          transporterId
          evaluatedStops
          compliance
          percentCompliance
          invalid
          percentInvalid
          missingGearInPark
          percentMissingGearInPark
          missingParkingBrake
          percentMissingParkingBrake
          totalBreaches
          percentTotalBreaches
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateStaff = /* GraphQL */ `
  mutation UpdateStaff(
    $input: UpdateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    updateStaff(input: $input, condition: $condition) {
      id
      staffDefaultVehicleId
      staffDefaultVehicle2Id
      staffDefaultVehicle3Id
      group
      transporterId
      firstName
      lastName
      alternateNames
      phone
      email
      keyFocusArea
      coachingOpportunity
      status
      dlExpiration
      vehicleReport
      gasCardPin
      dob
      gender
      pronouns
      assignedLead
      isALead
      reportsToStaffId
      hourlyStatus
      hireDate
      terminationDate
      finalCheckIssueDate
      returnedUniform
      latestScorecard
      smsLastMessageTimestamp
      smsLastMessage
      vehicleType
      photo
      onboardingPinned
      netradyneDriverId
      heraScore
      heraRank
      prevHeraRank
      receiveTextMessages
      receiveTextMessagesChangeLog
      receiveEmailMessages
      receiveEmailMessagesChangeLog
      notes
      onboardingNotes
      customDeliveryVan
      authorizedLBS
      preferredDaysOff
      emailAddedToSuppressionListDateTime
      timesRescuerCounter
      timesRescuedCounter
      scoreCardsFantasticConsecutiveCounter
      scoreCardsFantasticCounter
      nickname
      overrideDisplayName
      displayName
      payrollProviderExternalId
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      eocScores {
        items {
          id
          textractJobId
          eocScoreStaffId
          group
          date
          level
          average
          averageDailyCompliance
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      drugTests {
        items {
          id
          drugTestStaffId
          group
          date
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      injuries {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deviceAssociateMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentionedInNotes {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onBoarding {
        items {
          id
          onBoardStaffId
          group
          name
          isComplete
          status
          dateComplete
          dateStart
          date3
          date4
          date5
          trainer
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      physicals {
        items {
          id
          physicalStaffId
          group
          date
          expirationDate
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      podQualities {
        items {
          id
          podQualityStaffId
          group
          matched
          matchedS
          week
          year
          employeeName
          transporterId
          blurry
          explicit
          mailSlot
          noPackage
          other
          opportunities
          success
          bypass
          packageInHand
          notClearlyVisible
          packageTooClose
          personInPhoto
          photoTooDark
          takenFromCar
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelper {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeRescuer {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagePreferencesHistory {
        items {
          id
          messagePreferencesHistoryStaffId
          group
          messagePreferenceType
          description
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      cxFeedback {
        items {
          id
          staffCxFeedbackStaffId
          group
          matched
          matchedS
          week
          year
          name
          messageHasBeenSent
          transporterId
          positiveFeedback
          negativeFeedback
          deliveryWasGreat
          deliveryWasntGreat
          totalDeliveries
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          careForOthers
          mishandledPackage
          drivingUnsafely
          driverUnprofessional
          notDeliveredToPreferredLocation
          noFeedback
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          daTier
          cdfScore
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentor {
        items {
          id
          textractJobId
          staffMentorStaffId
          group
          name
          matched
          messageHasBeenSent
          date
          station
          trips
          geotabTrips
          miles
          time
          fico
          accel
          braking
          cornering
          speeding
          distraction
          seatbelt
          backUp
          sse
          mpg
          idling
          engineOff
          preDvcr
          postDvcr
          trainingAssigned
          trainingCompleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      netrdadyneAlerts {
        items {
          id
          textractJobId
          staffNetradyneAlertStaffId
          group
          staffId
          matched
          matchedS
          driverName
          driverId
          groupName
          vehicleNumber
          vin
          alertId
          timestamp
          alertType
          alertSeverity
          description
          alertVideoStatus
          duration
          startLatLong
          endLatLong
          sortKey
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      scoreCards {
        items {
          id
          staffScoreCardStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          name
          transporterId
          overallTier
          delivered
          keyFocusArea
          ficoScore
          seatbeltOffRate
          cdf
          cdfDpmo
          ced
          dcr
          dcDpmo
          dar
          dsb
          psb
          swcPod
          swcCc
          swcSc
          swcAd
          dnrs
          podOpps
          ccOpps
          speedingEventRate
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          harshBrakingRate
          harshCorneringRate
          starRating
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffStatusHistory {
        items {
          id
          staffStatusStaffId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorizedToDrive {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      uniforms {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle2 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle3 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      routeRescuerStaff {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      properParkingSequences {
        items {
          id
          properParkingSequenceStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          date
          employeeName
          transporterId
          evaluatedStops
          compliance
          percentCompliance
          invalid
          percentInvalid
          missingGearInPark
          percentMissingGearInPark
          missingParkingBrake
          percentMissingParkingBrake
          totalBreaches
          percentTotalBreaches
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaff = /* GraphQL */ `
  mutation DeleteStaff(
    $input: DeleteStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    deleteStaff(input: $input, condition: $condition) {
      id
      staffDefaultVehicleId
      staffDefaultVehicle2Id
      staffDefaultVehicle3Id
      group
      transporterId
      firstName
      lastName
      alternateNames
      phone
      email
      keyFocusArea
      coachingOpportunity
      status
      dlExpiration
      vehicleReport
      gasCardPin
      dob
      gender
      pronouns
      assignedLead
      isALead
      reportsToStaffId
      hourlyStatus
      hireDate
      terminationDate
      finalCheckIssueDate
      returnedUniform
      latestScorecard
      smsLastMessageTimestamp
      smsLastMessage
      vehicleType
      photo
      onboardingPinned
      netradyneDriverId
      heraScore
      heraRank
      prevHeraRank
      receiveTextMessages
      receiveTextMessagesChangeLog
      receiveEmailMessages
      receiveEmailMessagesChangeLog
      notes
      onboardingNotes
      customDeliveryVan
      authorizedLBS
      preferredDaysOff
      emailAddedToSuppressionListDateTime
      timesRescuerCounter
      timesRescuedCounter
      scoreCardsFantasticConsecutiveCounter
      scoreCardsFantasticCounter
      nickname
      overrideDisplayName
      displayName
      payrollProviderExternalId
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      eocScores {
        items {
          id
          textractJobId
          eocScoreStaffId
          group
          date
          level
          average
          averageDailyCompliance
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      drugTests {
        items {
          id
          drugTestStaffId
          group
          date
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      infractions {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      injuries {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deviceAssociateMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentionedInNotes {
        items {
          id
          staffMentionNoteId
          staffMentionStaffId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onBoarding {
        items {
          id
          onBoardStaffId
          group
          name
          isComplete
          status
          dateComplete
          dateStart
          date3
          date4
          date5
          trainer
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      physicals {
        items {
          id
          physicalStaffId
          group
          date
          expirationDate
          location
          results
          file
          fileName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      podQualities {
        items {
          id
          podQualityStaffId
          group
          matched
          matchedS
          week
          year
          employeeName
          transporterId
          blurry
          explicit
          mailSlot
          noPackage
          other
          opportunities
          success
          bypass
          packageInHand
          notClearlyVisible
          packageTooClose
          personInPhoto
          photoTooDark
          takenFromCar
          grandTotal
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelper {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeRescuer {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagePreferencesHistory {
        items {
          id
          messagePreferencesHistoryStaffId
          group
          messagePreferenceType
          description
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      cxFeedback {
        items {
          id
          staffCxFeedbackStaffId
          group
          matched
          matchedS
          week
          year
          name
          messageHasBeenSent
          transporterId
          positiveFeedback
          negativeFeedback
          deliveryWasGreat
          deliveryWasntGreat
          totalDeliveries
          respectfulOfProperty
          followedInstructions
          friendly
          aboveAndBeyond
          deliveredWithCare
          thankMyDriver
          careForOthers
          mishandledPackage
          drivingUnsafely
          driverUnprofessional
          notDeliveredToPreferredLocation
          noFeedback
          onTime
          lateDelivery
          itemDamaged
          deliveredToWrongAddress
          neverReceivedDelivery
          daTier
          cdfScore
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mentor {
        items {
          id
          textractJobId
          staffMentorStaffId
          group
          name
          matched
          messageHasBeenSent
          date
          station
          trips
          geotabTrips
          miles
          time
          fico
          accel
          braking
          cornering
          speeding
          distraction
          seatbelt
          backUp
          sse
          mpg
          idling
          engineOff
          preDvcr
          postDvcr
          trainingAssigned
          trainingCompleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      netrdadyneAlerts {
        items {
          id
          textractJobId
          staffNetradyneAlertStaffId
          group
          staffId
          matched
          matchedS
          driverName
          driverId
          groupName
          vehicleNumber
          vin
          alertId
          timestamp
          alertType
          alertSeverity
          description
          alertVideoStatus
          duration
          startLatLong
          endLatLong
          sortKey
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      scoreCards {
        items {
          id
          staffScoreCardStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          name
          transporterId
          overallTier
          delivered
          keyFocusArea
          ficoScore
          seatbeltOffRate
          cdf
          cdfDpmo
          ced
          dcr
          dcDpmo
          dar
          dsb
          psb
          swcPod
          swcCc
          swcSc
          swcAd
          dnrs
          podOpps
          ccOpps
          speedingEventRate
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          harshBrakingRate
          harshCorneringRate
          starRating
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      staffStatusHistory {
        items {
          id
          staffStatusStaffId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routeStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      authorizedToDrive {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      uniforms {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultVehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle2 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      defaultVehicle3 {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      routeRescuerStaff {
        items {
          id
          routeId
          staffId
          group
          startTime
          endTime
          totalRescuedPackages
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      properParkingSequences {
        items {
          id
          properParkingSequenceStaffId
          group
          matched
          matchedS
          messageHasBeenSent
          week
          year
          date
          employeeName
          transporterId
          evaluatedStops
          compliance
          percentCompliance
          invalid
          percentInvalid
          missingGearInPark
          percentMissingGearInPark
          missingParkingBrake
          percentMissingParkingBrake
          totalBreaches
          percentTotalBreaches
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createMessagePreferencesHistory = /* GraphQL */ `
  mutation CreateMessagePreferencesHistory(
    $input: CreateMessagePreferencesHistoryInput!
    $condition: ModelMessagePreferencesHistoryConditionInput
  ) {
    createMessagePreferencesHistory(input: $input, condition: $condition) {
      id
      messagePreferencesHistoryStaffId
      group
      messagePreferenceType
      description
      datetime
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateMessagePreferencesHistory = /* GraphQL */ `
  mutation UpdateMessagePreferencesHistory(
    $input: UpdateMessagePreferencesHistoryInput!
    $condition: ModelMessagePreferencesHistoryConditionInput
  ) {
    updateMessagePreferencesHistory(input: $input, condition: $condition) {
      id
      messagePreferencesHistoryStaffId
      group
      messagePreferenceType
      description
      datetime
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteMessagePreferencesHistory = /* GraphQL */ `
  mutation DeleteMessagePreferencesHistory(
    $input: DeleteMessagePreferencesHistoryInput!
    $condition: ModelMessagePreferencesHistoryConditionInput
  ) {
    deleteMessagePreferencesHistory(input: $input, condition: $condition) {
      id
      messagePreferencesHistoryStaffId
      group
      messagePreferenceType
      description
      datetime
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffCxFeedback = /* GraphQL */ `
  mutation CreateStaffCxFeedback(
    $input: CreateStaffCxFeedbackInput!
    $condition: ModelStaffCxFeedbackConditionInput
  ) {
    createStaffCxFeedback(input: $input, condition: $condition) {
      id
      staffCxFeedbackStaffId
      group
      matched
      matchedS
      week
      year
      name
      messageHasBeenSent
      transporterId
      positiveFeedback
      negativeFeedback
      deliveryWasGreat
      deliveryWasntGreat
      totalDeliveries
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      careForOthers
      mishandledPackage
      drivingUnsafely
      driverUnprofessional
      notDeliveredToPreferredLocation
      noFeedback
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      daTier
      cdfScore
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffCxFeedback = /* GraphQL */ `
  mutation UpdateStaffCxFeedback(
    $input: UpdateStaffCxFeedbackInput!
    $condition: ModelStaffCxFeedbackConditionInput
  ) {
    updateStaffCxFeedback(input: $input, condition: $condition) {
      id
      staffCxFeedbackStaffId
      group
      matched
      matchedS
      week
      year
      name
      messageHasBeenSent
      transporterId
      positiveFeedback
      negativeFeedback
      deliveryWasGreat
      deliveryWasntGreat
      totalDeliveries
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      careForOthers
      mishandledPackage
      drivingUnsafely
      driverUnprofessional
      notDeliveredToPreferredLocation
      noFeedback
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      daTier
      cdfScore
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffCxFeedback = /* GraphQL */ `
  mutation DeleteStaffCxFeedback(
    $input: DeleteStaffCxFeedbackInput!
    $condition: ModelStaffCxFeedbackConditionInput
  ) {
    deleteStaffCxFeedback(input: $input, condition: $condition) {
      id
      staffCxFeedbackStaffId
      group
      matched
      matchedS
      week
      year
      name
      messageHasBeenSent
      transporterId
      positiveFeedback
      negativeFeedback
      deliveryWasGreat
      deliveryWasntGreat
      totalDeliveries
      respectfulOfProperty
      followedInstructions
      friendly
      aboveAndBeyond
      deliveredWithCare
      thankMyDriver
      careForOthers
      mishandledPackage
      drivingUnsafely
      driverUnprofessional
      notDeliveredToPreferredLocation
      noFeedback
      onTime
      lateDelivery
      itemDamaged
      deliveredToWrongAddress
      neverReceivedDelivery
      daTier
      cdfScore
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffMentor = /* GraphQL */ `
  mutation CreateStaffMentor(
    $input: CreateStaffMentorInput!
    $condition: ModelStaffMentorConditionInput
  ) {
    createStaffMentor(input: $input, condition: $condition) {
      id
      textractJobId
      staffMentorStaffId
      group
      name
      matched
      messageHasBeenSent
      date
      station
      trips
      geotabTrips
      miles
      time
      fico
      accel
      braking
      cornering
      speeding
      distraction
      seatbelt
      backUp
      sse
      mpg
      idling
      engineOff
      preDvcr
      postDvcr
      trainingAssigned
      trainingCompleted
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffMentor = /* GraphQL */ `
  mutation UpdateStaffMentor(
    $input: UpdateStaffMentorInput!
    $condition: ModelStaffMentorConditionInput
  ) {
    updateStaffMentor(input: $input, condition: $condition) {
      id
      textractJobId
      staffMentorStaffId
      group
      name
      matched
      messageHasBeenSent
      date
      station
      trips
      geotabTrips
      miles
      time
      fico
      accel
      braking
      cornering
      speeding
      distraction
      seatbelt
      backUp
      sse
      mpg
      idling
      engineOff
      preDvcr
      postDvcr
      trainingAssigned
      trainingCompleted
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffMentor = /* GraphQL */ `
  mutation DeleteStaffMentor(
    $input: DeleteStaffMentorInput!
    $condition: ModelStaffMentorConditionInput
  ) {
    deleteStaffMentor(input: $input, condition: $condition) {
      id
      textractJobId
      staffMentorStaffId
      group
      name
      matched
      messageHasBeenSent
      date
      station
      trips
      geotabTrips
      miles
      time
      fico
      accel
      braking
      cornering
      speeding
      distraction
      seatbelt
      backUp
      sse
      mpg
      idling
      engineOff
      preDvcr
      postDvcr
      trainingAssigned
      trainingCompleted
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffNetradyneAlert = /* GraphQL */ `
  mutation CreateStaffNetradyneAlert(
    $input: CreateStaffNetradyneAlertInput!
    $condition: ModelStaffNetradyneAlertConditionInput
  ) {
    createStaffNetradyneAlert(input: $input, condition: $condition) {
      id
      textractJobId
      staffNetradyneAlertStaffId
      group
      staffId
      matched
      matchedS
      driverName
      driverId
      groupName
      vehicleNumber
      vin
      alertId
      timestamp
      alertType
      alertSeverity
      description
      alertVideoStatus
      duration
      startLatLong
      endLatLong
      sortKey
      date
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffNetradyneAlert = /* GraphQL */ `
  mutation UpdateStaffNetradyneAlert(
    $input: UpdateStaffNetradyneAlertInput!
    $condition: ModelStaffNetradyneAlertConditionInput
  ) {
    updateStaffNetradyneAlert(input: $input, condition: $condition) {
      id
      textractJobId
      staffNetradyneAlertStaffId
      group
      staffId
      matched
      matchedS
      driverName
      driverId
      groupName
      vehicleNumber
      vin
      alertId
      timestamp
      alertType
      alertSeverity
      description
      alertVideoStatus
      duration
      startLatLong
      endLatLong
      sortKey
      date
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffNetradyneAlert = /* GraphQL */ `
  mutation DeleteStaffNetradyneAlert(
    $input: DeleteStaffNetradyneAlertInput!
    $condition: ModelStaffNetradyneAlertConditionInput
  ) {
    deleteStaffNetradyneAlert(input: $input, condition: $condition) {
      id
      textractJobId
      staffNetradyneAlertStaffId
      group
      staffId
      matched
      matchedS
      driverName
      driverId
      groupName
      vehicleNumber
      vin
      alertId
      timestamp
      alertType
      alertSeverity
      description
      alertVideoStatus
      duration
      startLatLong
      endLatLong
      sortKey
      date
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffScoreCard = /* GraphQL */ `
  mutation CreateStaffScoreCard(
    $input: CreateStaffScoreCardInput!
    $condition: ModelStaffScoreCardConditionInput
  ) {
    createStaffScoreCard(input: $input, condition: $condition) {
      id
      staffScoreCardStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      name
      transporterId
      overallTier
      delivered
      keyFocusArea
      ficoScore
      seatbeltOffRate
      cdf
      cdfDpmo
      ced
      dcr
      dcDpmo
      dar
      dsb
      psb
      swcPod
      swcCc
      swcSc
      swcAd
      dnrs
      podOpps
      ccOpps
      speedingEventRate
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      harshBrakingRate
      harshCorneringRate
      starRating
      createdBy
      updatedBy
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffScoreCard = /* GraphQL */ `
  mutation UpdateStaffScoreCard(
    $input: UpdateStaffScoreCardInput!
    $condition: ModelStaffScoreCardConditionInput
  ) {
    updateStaffScoreCard(input: $input, condition: $condition) {
      id
      staffScoreCardStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      name
      transporterId
      overallTier
      delivered
      keyFocusArea
      ficoScore
      seatbeltOffRate
      cdf
      cdfDpmo
      ced
      dcr
      dcDpmo
      dar
      dsb
      psb
      swcPod
      swcCc
      swcSc
      swcAd
      dnrs
      podOpps
      ccOpps
      speedingEventRate
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      harshBrakingRate
      harshCorneringRate
      starRating
      createdBy
      updatedBy
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffScoreCard = /* GraphQL */ `
  mutation DeleteStaffScoreCard(
    $input: DeleteStaffScoreCardInput!
    $condition: ModelStaffScoreCardConditionInput
  ) {
    deleteStaffScoreCard(input: $input, condition: $condition) {
      id
      staffScoreCardStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      name
      transporterId
      overallTier
      delivered
      keyFocusArea
      ficoScore
      seatbeltOffRate
      cdf
      cdfDpmo
      ced
      dcr
      dcDpmo
      dar
      dsb
      psb
      swcPod
      swcCc
      swcSc
      swcAd
      dnrs
      podOpps
      ccOpps
      speedingEventRate
      distractionsRate
      followingDistanceRate
      signSignalViolationsRate
      harshBrakingRate
      harshCorneringRate
      starRating
      createdBy
      updatedBy
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createStaffStatus = /* GraphQL */ `
  mutation CreateStaffStatus(
    $input: CreateStaffStatusInput!
    $condition: ModelStaffStatusConditionInput
  ) {
    createStaffStatus(input: $input, condition: $condition) {
      id
      staffStatusStaffId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateStaffStatus = /* GraphQL */ `
  mutation UpdateStaffStatus(
    $input: UpdateStaffStatusInput!
    $condition: ModelStaffStatusConditionInput
  ) {
    updateStaffStatus(input: $input, condition: $condition) {
      id
      staffStatusStaffId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteStaffStatus = /* GraphQL */ `
  mutation DeleteStaffStatus(
    $input: DeleteStaffStatusInput!
    $condition: ModelStaffStatusConditionInput
  ) {
    deleteStaffStatus(input: $input, condition: $condition) {
      id
      staffStatusStaffId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRouteStatus = /* GraphQL */ `
  mutation CreateRouteStatus(
    $input: CreateRouteStatusInput!
    $condition: ModelRouteStatusConditionInput
  ) {
    createRouteStatus(input: $input, condition: $condition) {
      id
      routeStatusRouteId
      routeStatusAssociateId
      routeStatusReplaceByRouteId
      routeStatusPreviousStatusId
      routeStatusCurrentStatusId
      group
      associateType
      reason
      date
      createdAt
      updatedAt
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      associate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      previousStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      currentStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRouteStatus = /* GraphQL */ `
  mutation UpdateRouteStatus(
    $input: UpdateRouteStatusInput!
    $condition: ModelRouteStatusConditionInput
  ) {
    updateRouteStatus(input: $input, condition: $condition) {
      id
      routeStatusRouteId
      routeStatusAssociateId
      routeStatusReplaceByRouteId
      routeStatusPreviousStatusId
      routeStatusCurrentStatusId
      group
      associateType
      reason
      date
      createdAt
      updatedAt
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      associate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      previousStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      currentStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRouteStatus = /* GraphQL */ `
  mutation DeleteRouteStatus(
    $input: DeleteRouteStatusInput!
    $condition: ModelRouteStatusConditionInput
  ) {
    deleteRouteStatus(input: $input, condition: $condition) {
      id
      routeStatusRouteId
      routeStatusAssociateId
      routeStatusReplaceByRouteId
      routeStatusPreviousStatusId
      routeStatusCurrentStatusId
      group
      associateType
      reason
      date
      createdAt
      updatedAt
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      associate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      previousStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      currentStatus {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistSubject = /* GraphQL */ `
  mutation CreateRosterChecklistSubject(
    $input: CreateRosterChecklistSubjectInput!
    $condition: ModelRosterChecklistSubjectConditionInput
  ) {
    createRosterChecklistSubject(input: $input, condition: $condition) {
      id
      notesDate
      group
      inactive
      staffId
      userId
      rosterChecklistId
      routeId
      replaceByRouteId
      dailyRosterId
      simpleItemsCompleted
      vehicleItemsCompleted
      flaggedAt
      flaggedByUserId
      itemsInProgressCounterCache
      itemsUnderReviewCounterCache
      itemsReviewedCounterCache
      status
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      sentMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubjectItems {
        items {
          id
          group
          rosterChecklistSubjectId
          rosterChecklistItemId
          dailyLogId
          odometerReadingId
          value
          reviewedByUserId
          reviewedAt
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      flaggedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistSubject = /* GraphQL */ `
  mutation UpdateRosterChecklistSubject(
    $input: UpdateRosterChecklistSubjectInput!
    $condition: ModelRosterChecklistSubjectConditionInput
  ) {
    updateRosterChecklistSubject(input: $input, condition: $condition) {
      id
      notesDate
      group
      inactive
      staffId
      userId
      rosterChecklistId
      routeId
      replaceByRouteId
      dailyRosterId
      simpleItemsCompleted
      vehicleItemsCompleted
      flaggedAt
      flaggedByUserId
      itemsInProgressCounterCache
      itemsUnderReviewCounterCache
      itemsReviewedCounterCache
      status
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      sentMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubjectItems {
        items {
          id
          group
          rosterChecklistSubjectId
          rosterChecklistItemId
          dailyLogId
          odometerReadingId
          value
          reviewedByUserId
          reviewedAt
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      flaggedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistSubject = /* GraphQL */ `
  mutation DeleteRosterChecklistSubject(
    $input: DeleteRosterChecklistSubjectInput!
    $condition: ModelRosterChecklistSubjectConditionInput
  ) {
    deleteRosterChecklistSubject(input: $input, condition: $condition) {
      id
      notesDate
      group
      inactive
      staffId
      userId
      rosterChecklistId
      routeId
      replaceByRouteId
      dailyRosterId
      simpleItemsCompleted
      vehicleItemsCompleted
      flaggedAt
      flaggedByUserId
      itemsInProgressCounterCache
      itemsUnderReviewCounterCache
      itemsReviewedCounterCache
      status
      createdAt
      updatedAt
      shortenUrls {
        items {
          id
          shortenId
          attachmentId
          shortenUrlDailyLogId
          shortenUrlAttachmentId
          shortenUrlCounselingId
          shortenUrlAssociateId
          shortenUrlSentByUserId
          group
          type
          expirationTTL
          urlToken
          rosterChecklistSubjectId
          isOpenLink
          urlParameters
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dailyRoster {
        id
        dailyRosterAttachmentId
        group
        notesDate
        lastStandUpSentTime
        userId
        creationRoute
        createdAt
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        notes {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklist {
        id
        name
        completionFrequencyId
        assignedToId
        group
        sendTime
        totalSimpleItems
        totalVehicleItems
        status
        createdAt
        updatedAt
        vehicleTypes {
          nextToken
          __typename
        }
        assignedUsers {
          nextToken
          __typename
        }
        checklistTasks {
          nextToken
          __typename
        }
        rosterChecklistItems {
          nextToken
          __typename
        }
        __typename
      }
      sentMessages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replaceByRoute {
        id
        replaceByRouteStaffId
        replaceByRouteRouteId
        replaceByRouteStatusId
        replaceByRouteDeviceId
        replaceByRouteVehicleId
        replaceByRouteDailyRosterId
        replaceByRouteParkingSpaceId
        group
        notes
        createdAt
        routeNumber
        staging
        helperStatus
        isNotActive
        standby
        time
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        lastBulkUploadDate
        updatedAt
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        replaceByRouteStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      rosterChecklistSubjectItems {
        items {
          id
          group
          rosterChecklistSubjectId
          rosterChecklistItemId
          dailyLogId
          odometerReadingId
          value
          reviewedByUserId
          reviewedAt
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      flaggedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRosterChecklistSubjectItem = /* GraphQL */ `
  mutation CreateRosterChecklistSubjectItem(
    $input: CreateRosterChecklistSubjectItemInput!
    $condition: ModelRosterChecklistSubjectItemConditionInput
  ) {
    createRosterChecklistSubjectItem(input: $input, condition: $condition) {
      id
      group
      rosterChecklistSubjectId
      rosterChecklistItemId
      dailyLogId
      odometerReadingId
      value
      reviewedByUserId
      reviewedAt
      status
      createdAt
      updatedAt
      odometerReading {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistItem {
        id
        typeId
        titleQuestion
        descriptionExplanation
        order
        group
        status
        rosterChecklistId
        requiredPhotoSpecifications
        photoSpecifications
        createdAt
        updatedAt
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      reviewedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRosterChecklistSubjectItem = /* GraphQL */ `
  mutation UpdateRosterChecklistSubjectItem(
    $input: UpdateRosterChecklistSubjectItemInput!
    $condition: ModelRosterChecklistSubjectItemConditionInput
  ) {
    updateRosterChecklistSubjectItem(input: $input, condition: $condition) {
      id
      group
      rosterChecklistSubjectId
      rosterChecklistItemId
      dailyLogId
      odometerReadingId
      value
      reviewedByUserId
      reviewedAt
      status
      createdAt
      updatedAt
      odometerReading {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistItem {
        id
        typeId
        titleQuestion
        descriptionExplanation
        order
        group
        status
        rosterChecklistId
        requiredPhotoSpecifications
        photoSpecifications
        createdAt
        updatedAt
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      reviewedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRosterChecklistSubjectItem = /* GraphQL */ `
  mutation DeleteRosterChecklistSubjectItem(
    $input: DeleteRosterChecklistSubjectItemInput!
    $condition: ModelRosterChecklistSubjectItemConditionInput
  ) {
    deleteRosterChecklistSubjectItem(input: $input, condition: $condition) {
      id
      group
      rosterChecklistSubjectId
      rosterChecklistItemId
      dailyLogId
      odometerReadingId
      value
      reviewedByUserId
      reviewedAt
      status
      createdAt
      updatedAt
      odometerReading {
        id
        accidentVehicleId
        accidentStaffId
        accidentVerifiedById
        accidentMaintenanceVehicleId
        accidentDamageVehicleId
        accidentOdometerReadingVehicleId
        accidentVehicleDamageRouteId
        accidentOptionCustomListId
        accidentCreatedByUserId
        group
        atFault
        drugTestDate
        drugTestResult
        accidentDate
        accidentType
        associateStatement
        witnessName
        witnessStatement
        address
        addressCity
        addressState
        addressZip
        fileName
        verifiedDate
        notes
        insuranceClaimNumber
        policeDepartment
        policeOfficerName
        policeReportNumber
        staffId
        vehicleId
        vehicleHistoryType
        services
        location
        maintenanceStatus
        maintenanceDateCompleted
        mileageAsOfMaintenance
        mileage
        time
        damage
        damageSeverity
        vehicleDamageDate
        odometerDate
        odometerType
        costOfServices
        createdAt
        updatedAt
        incidentDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageImages {
          nextToken
          scannedCount
          __typename
        }
        maintenanceDocuments {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamageRoute {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        optionCustomList {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        verifiedBy {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        maintenanceVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        damageVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        odometerReadingVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistItem {
        id
        typeId
        titleQuestion
        descriptionExplanation
        order
        group
        status
        rosterChecklistId
        requiredPhotoSpecifications
        photoSpecifications
        createdAt
        updatedAt
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      dailyLog {
        id
        dailyLogVehicleId
        dailyLogTakenByUserId
        dailyLogRosteredDayId
        dailyLogCreatedByUserId
        dailyLogTakenByAssociateId
        dailyLogCreationLinkSentByUserId
        dailyLogCreationLinkAssociateId
        reviewedByUserId
        group
        type
        date
        notes
        vehicleId
        creationLinkSentDateTime
        specificPhotos
        status
        flaggedAt
        flaggedByUserId
        reviewedAt
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        rosteredDay {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        history {
          nextToken
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        creationLinkAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        takenByAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        creationLinkSentByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        takenByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      rosterChecklistSubject {
        id
        notesDate
        group
        inactive
        staffId
        userId
        rosterChecklistId
        routeId
        replaceByRouteId
        dailyRosterId
        simpleItemsCompleted
        vehicleItemsCompleted
        flaggedAt
        flaggedByUserId
        itemsInProgressCounterCache
        itemsUnderReviewCounterCache
        itemsReviewedCounterCache
        status
        createdAt
        updatedAt
        shortenUrls {
          nextToken
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        rosterChecklist {
          id
          name
          completionFrequencyId
          assignedToId
          group
          sendTime
          totalSimpleItems
          totalVehicleItems
          status
          createdAt
          updatedAt
          __typename
        }
        sentMessages {
          nextToken
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubjectItems {
          nextToken
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        flaggedByUser {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      reviewedByUser {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      taskAssigneeId
      taskAssignerId
      taskAssigneeAssociateId
      createdAt
      owner
      creator
      group
      executionARN
      description
      date
      status
      taskName
      isDateReminder
      isNotifyOnCreation
      reminderDate
      updatedAt
      assigneeAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      assigner {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      assignee {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      taskAssigneeId
      taskAssignerId
      taskAssigneeAssociateId
      createdAt
      owner
      creator
      group
      executionARN
      description
      date
      status
      taskName
      isDateReminder
      isNotifyOnCreation
      reminderDate
      updatedAt
      assigneeAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      assigner {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      assignee {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      id
      taskAssigneeId
      taskAssignerId
      taskAssigneeAssociateId
      createdAt
      owner
      creator
      group
      executionARN
      description
      date
      status
      taskName
      isDateReminder
      isNotifyOnCreation
      reminderDate
      updatedAt
      assigneeAssociate {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      assigner {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      assignee {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createTenant = /* GraphQL */ `
  mutation CreateTenant(
    $input: CreateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    createTenant(input: $input, condition: $condition) {
      id
      group
      createdAt
      companyName
      nameLog
      numberOfSeats
      logo
      accidentReport
      workmansComp
      dispatchNumber
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      zohoCrmAccountRecordId
      originationNumber
      timeZone
      locale
      trialExpDate
      firstInterestDateTime
      firstStartedTrialDateTime
      firstConvertedToPaidDateTime
      firstChurnedDateTime
      accountPremiumStatus
      accountCanceledNotes
      accountCanceledReason
      notes
      costStandard
      costBundle
      costPerformance
      costRostering
      costStaff
      costVehicles
      costMessaging
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      payOutstandingByDate
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      ownerUserId
      lastPaidPositiveInvoiceLineItemDateTime
      totalNumberOfMonthsPaidByTenant
      lifetimePaymentTotal
      averageMonthlyInvoiceTotal
      isTestingAccount
      calculatedOutstandingBalance
      bundleDeactivationAllowedAt
      performanceDeactivationAllowedAt
      rosteringDeactivationAllowedAt
      staffDeactivationAllowedAt
      vehiclesDeactivationAllowedAt
      automatedCoachingSendTime
      allowLibraryUpload
      coachingCustomMessage
      messageServiceProvider
      OriginationNumberOrderId
      OriginationNumberStatus
      customerStatus
      coachingFicoThresholdIssue
      coachingFicoThreshold
      coachingFicoThresholdPR
      coachingFicoThresholdKudo
      coachingFicoIssue
      coachingFicoCO
      coachingFicoPR
      coachingFicoKudo
      coachingDcrThresholdIssue
      coachingDcrThreshold
      coachingDcrThresholdPR
      coachingDcrThresholdKudo
      coachingDcrIssue
      coachingDcrCO
      coachingDcrPR
      coachingDcrKudo
      coachingDcDpmoThresholdIssue
      coachingDcDpmoThreshold
      coachingDcDpmoThresholdPR
      coachingDcDpmoThresholdKudo
      coachingDcDpmoIssue
      coachingDcDpmoCO
      coachingDcDpmoPR
      coachingDcDpmoKudo
      coachingDarThresholdIssue
      coachingDarThreshold
      coachingDarThresholdPR
      coachingDarThresholdKudo
      coachingDarIssue
      coachingDarCO
      coachingDarPR
      coachingDarKudo
      coachingDnrThresholdIssue
      coachingDnrThreshold
      coachingDnrThresholdPR
      coachingDnrThresholdKudo
      coachingDnrIssue
      coachingDnrCO
      coachingDnrPR
      coachingDnrKudo
      coachingDsbThresholdIssue
      coachingDsbThreshold
      coachingDsbThresholdPR
      coachingDsbThresholdKudo
      coachingDsbIssue
      coachingDsbCO
      coachingDsbPR
      coachingDsbKudo
      coachingSwcPodThresholdIssue
      coachingSwcPodThreshold
      coachingSwcPodThresholdKudo
      coachingSwcPodThresholdPR
      coachingSwcPodIssue
      coachingSwcPodCO
      coachingSwcPodPR
      coachingSwcPodKudo
      coachingSwcCcThresholdIssue
      coachingSwcCcThreshold
      coachingSwcCcThresholdKudo
      coachingSwcCcThresholdPR
      coachingSwcCcIssue
      coachingSwcCcCO
      coachingSwcCcPR
      coachingSwcCcKudo
      coachingSwcScThresholdIssue
      coachingSwcScThreshold
      coachingSwcScThresholdKudo
      coachingSwcScThresholdPR
      coachingSwcScIssue
      coachingSwcScCO
      coachingSwcScPR
      coachingSwcScKudo
      coachingSwcAdThresholdIssue
      coachingSwcAdThreshold
      coachingSwcAdThresholdKudo
      coachingSwcAdThresholdPR
      coachingSwcAdIssue
      coachingSwcAdCO
      coachingSwcAdPR
      coachingSwcAdKudo
      coachingSeatbeltOffThresholdIssue
      coachingSeatbeltOffThreshold
      coachingSeatbeltOffThresholdPR
      coachingSeatbeltOffThresholdKudo
      coachingSeatbeltOffIssue
      coachingSeatbeltOffCO
      coachingSeatbeltOffPR
      coachingSeatbeltOffKudo
      coachingSpeedingEventThresholdIssue
      coachingSpeedingEventThreshold
      coachingSpeedingEventThresholdPR
      coachingSpeedingEventThresholdKudo
      coachingSpeedingEventIssue
      coachingSpeedingEventCO
      coachingSpeedingEventPR
      coachingSpeedingEventKudo
      coachingDistractionsRateThresholdIssue
      coachingDistractionsRateThreshold
      coachingDistractionsRateThresholdPR
      coachingDistractionsRateThresholdKudo
      coachingDistractionsRateIssue
      coachingDistractionsRateCO
      coachingDistractionsRatePR
      coachingDistractionsRateKudo
      coachingFollowingDistanceRateThresholdIssue
      coachingFollowingDistanceRateThreshold
      coachingFollowingDistanceRateThresholdPR
      coachingFollowingDistanceRateThresholdKudo
      coachingFollowingDistanceRateIssue
      coachingFollowingDistanceRateCO
      coachingFollowingDistanceRatePR
      coachingFollowingDistanceRateKudo
      coachingSignSignalViolationsRateThresholdIssue
      coachingSignSignalViolationsRateThreshold
      coachingSignSignalViolationsRateThresholdPR
      coachingSignSignalViolationsRateThresholdKudo
      coachingSignSignalViolationsRateIssue
      coachingSignSignalViolationsRateCO
      coachingSignSignalViolationsRatePR
      coachingSignSignalViolationsRateKudo
      coachingOverallTierThresholdIssue
      coachingOverallTierThresholdKudo
      coachingOverallTierIssue
      coachingOverallTierKudo
      coachingOverallTierRatingIssue
      coachingOverallTierRatingKudo
      coachingConsecutiveTierThresholdIssue
      coachingConsecutiveTierThresholdKudo
      coachingConsecutiveTierIssue
      coachingConsecutiveTierKudo
      coachingConsecutiveTierRatingIssue
      coachingConsecutiveTierRatingKudo
      coachingPositiveFeedbackThresholdIssue
      coachingPositiveFeedbackThreshold
      coachingPositiveFeedbackThresholdPR
      coachingPositiveFeedbackThresholdKudo
      coachingPositiveFeedbackIssue
      coachingPositiveFeedbackCO
      coachingPositiveFeedbackPR
      coachingPositiveFeedbackKudo
      coachingDailyFicoThresholdIssue
      coachingDailyFicoThreshold
      coachingDailyFicoThresholdPR
      coachingDailyFicoThresholdKudo
      coachingDailyFicoIssue
      coachingDailyFicoCO
      coachingDailyFicoPR
      coachingDailyFicoKudo
      coachingSeatbeltThresholdIssue
      coachingSeatbeltThreshold
      coachingSeatbeltThresholdPR
      coachingSeatbeltThresholdKudo
      coachingSeatbeltIssue
      coachingSeatbeltCO
      coachingSeatbeltPR
      coachingSeatbeltKudo
      coachingSseIssue
      coachingSseCO
      coachingSsePR
      coachingSseKudo
      coachingSseThresholdIssue
      coachingSseThreshold
      coachingSseThresholdPR
      coachingSseThresholdKudo
      coachingDvcrsIssue
      coachingDvcrsCO
      coachingDvcrsPR
      coachingHarshBrakingRateThresholdIssue
      coachingHarshBrakingRateThreshold
      coachingHarshBrakingRateThresholdPR
      coachingHarshBrakingRateThresholdKudo
      coachingHarshBrakingRateIssue
      coachingHarshBrakingRateCO
      coachingHarshBrakingRatePR
      coachingHarshBrakingRateKudo
      coachingDaTierThresholdIssue
      coachingDaTierThresholdKudo
      coachingDaTierIssue
      coachingDaTierKudo
      coachingDaTierPR
      coachingDaTierCO
      coachingDaTierRatingIssue
      coachingDaTierRatingCO
      coachingDaTierRatingPR
      coachingDaTierRatingKudo
      coachingCdfScoreThresholdIssue
      coachingCdfScoreThreshold
      coachingCdfScoreThresholdPR
      coachingCdfScoreThresholdKudo
      coachingCdfScoreIssue
      coachingCdfScoreKudo
      coachingCdfScoreRatingIssue
      coachingCdfScoreCO
      coachingCdfScorePR
      coachingCdfScoreRatingKudo
      coachingCdfDpmoThresholdIssue
      coachingCdfDpmoThreshold
      coachingCdfDpmoThresholdPR
      coachingCdfDpmoThresholdKudo
      coachingCdfDpmoIssue
      coachingCdfDpmoKudo
      coachingCdfDpmoRatingIssue
      coachingCdfDpmoCO
      coachingCdfDpmoPR
      coachingCdfDpmoRatingKudo
      coachingHarshCorneringRateThresholdIssue
      coachingHarshCorneringRateThreshold
      coachingHarshCorneringRateThresholdPR
      coachingHarshCorneringRateThresholdKudo
      coachingHarshCorneringRateIssue
      coachingHarshCorneringRateCO
      coachingHarshCorneringRatePR
      coachingHarshCorneringRateKudo
      coachingPpsCompliancePercentThresholdIssue
      coachingPpsCompliancePercentThreshold
      coachingPpsCompliancePercentThresholdPR
      coachingPpsCompliancePercentThresholdKudo
      coachingPpsCompliancePercentIssue
      coachingPpsCompliancePercentCO
      coachingPpsCompliancePercentPR
      coachingPpsCompliancePercentKudo
      coachingPpsBreachesThresholdIssue
      coachingPpsBreachesThreshold
      coachingPpsBreachesThresholdPR
      coachingPpsBreachesThresholdKudo
      coachingPpsBreachesIssue
      coachingPpsBreachesCO
      coachingPpsBreachesPR
      coachingPpsBreachesKudo
      coachingDailyPpsCompliancePercentIssue
      coachingDailyPpsCompliancePercentThresholdIssue
      coachingDailyPpsCompliancePercentCO
      coachingDailyPpsCompliancePercentThreshold
      coachingDailyPpsCompliancePercentPR
      coachingDailyPpsCompliancePercentThresholdPR
      coachingDailyPpsCompliancePercentKudo
      coachingDailyPpsCompliancePercentThresholdKudo
      coachingDailyPpsMissingBrakeIssue
      coachingDailyPpsMissingBrakeThresholdIssue
      coachingDailyPpsMissingBrakeCO
      coachingDailyPpsMissingBrakeThreshold
      coachingDailyPpsMissingBrakePR
      coachingDailyPpsMissingBrakeThresholdPR
      coachingDailyPpsMissingBrakeKudo
      coachingDailyPpsMissingBrakeThresholdKudo
      coachingDailyPpsMissingGearIssue
      coachingDailyPpsMissingGearThresholdIssue
      coachingDailyPpsMissingGearCO
      coachingDailyPpsMissingGearThreshold
      coachingDailyPpsMissingGearPR
      coachingDailyPpsMissingGearThresholdPR
      coachingDailyPpsMissingGearKudo
      coachingDailyPpsMissingGearThresholdKudo
      coachingDailyComplianceRateThresholdIssue
      coachingDailyComplianceRateThreshold
      coachingDailyComplianceRateThresholdPR
      coachingDailyComplianceRateThresholdKudo
      coachingDailyComplianceRateIssue
      coachingDailyComplianceRateCO
      coachingDailyComplianceRatePR
      coachingDailyComplianceRateKudo
      coachingPsbThresholdIssue
      coachingPsbThreshold
      coachingPsbThresholdPR
      coachingPsbThresholdKudo
      coachingPsbIssue
      coachingPsbCO
      coachingPsbPR
      coachingPsbKudo
      coachingPsbRatingIssue
      coachingPsbRatingKudo
      coachingDaMishandledPackageIssue
      coachingDaMishandledPackageCO
      coachingDaMishandledPackageThresholdIssue
      coachingDaMishandledPackageThreshold
      coachingDaWasUnprofessionalIssue
      coachingDaWasUnprofessionalCO
      coachingDaWasUnprofessionalThresholdIssue
      coachingDaWasUnprofessionalThreshold
      coachingDaIgnoreInstructionsIssue
      coachingDaIgnoreInstructionsCO
      coachingDaIgnoreInstructionsThresholdIssue
      coachingDaIgnoreInstructionsThreshold
      coachingDeliveredToWrongAddressIssue
      coachingDeliveredToWrongAddressCO
      coachingDeliveredToWrongAddressThresholdIssue
      coachingDeliveredToWrongAddressThreshold
      coachingNeverReceivedDeliveryIssue
      coachingNeverReceivedDeliveryCO
      coachingNeverReceivedDeliveryThresholdIssue
      coachingNeverReceivedDeliveryThreshold
      coachingReceivedWrongItemIssue
      coachingReceivedWrongItemCO
      coachingReceivedWrongItemThresholdIssue
      coachingReceivedWrongItemThreshold
      coachingTraningRemainingIssue
      coachingTraningRemainingCO
      coachingTraningRemainingPR
      coachingCameraObstructionIssue
      coachingCameraObstructionCO
      coachingCameraObstructionThresholdIssue
      coachingCameraObstructionThreshold
      coachingDriverDistractionIssue
      coachingDriverDistractionCO
      coachingDriverDistractionThresholdIssue
      coachingDriverDistractionThreshold
      coachingDriverDrowsinessIssue
      coachingDriverDrowsinessCO
      coachingDriverDrowsinessThresholdIssue
      coachingDriverDrowsinessThreshold
      coachingDriverInitiatedIssue
      coachingDriverInitiatedCO
      coachingDriverInitiatedThresholdIssue
      coachingDriverInitiatedThreshold
      coachingDriverStarPR
      coachingDriverStarKudo
      coachingDriverStarThresholdPR
      coachingDriverStarThresholdKudo
      coachingFaceMaskComplianceIssue
      coachingFaceMaskComplianceCO
      coachingFaceMaskComplianceThresholdIssue
      coachingFaceMaskComplianceThreshold
      coachingFollowingDistanceIssue
      coachingFollowingDistanceCO
      coachingFollowingDistanceThresholdIssue
      coachingFollowingDistanceThreshold
      coachingHardAccelerationIssue
      coachingHardAccelerationCO
      coachingHardAccelerationThresholdIssue
      coachingHardAccelerationThreshold
      coachingHardBrakingIssue
      coachingHardBrakingCO
      coachingHardBrakingThresholdIssue
      coachingHardBrakingThreshold
      coachingHardTurnIssue
      coachingHardTurnCO
      coachingHardTurnThresholdIssue
      coachingHardTurnThreshold
      coachingHighGIssue
      coachingHighGCO
      coachingHighGThresholdIssue
      coachingHighGThreshold
      coachingLowImpactIssue
      coachingLowImpactCO
      coachingLowImpactThresholdIssue
      coachingLowImpactThreshold
      coachingSeatbeltComplianceIssue
      coachingSeatbeltComplianceCO
      coachingSeatbeltComplianceThresholdIssue
      coachingSeatbeltComplianceThreshold
      coachingSignViolationsIssue
      coachingSignViolationsCO
      coachingSignViolationsThresholdIssue
      coachingSignViolationsThreshold
      coachingSpeedingViolationsIssue
      coachingSpeedingViolationsCO
      coachingSpeedingViolationsThresholdIssue
      coachingSpeedingViolationsThreshold
      coachingTrafficLightViolationIssue
      coachingTrafficLightViolationCO
      coachingTrafficLightViolationThresholdIssue
      coachingTrafficLightViolationThreshold
      coachingUTurnIssue
      coachingUTurnCO
      coachingUTurnThresholdIssue
      coachingUTurnThreshold
      coachingWeavingIssue
      coachingWeavingCO
      coachingWeavingThresholdIssue
      coachingWeavingThreshold
      coachingDriverRankRange
      usesXLcoaching
      shortCode
      growSurfParticipantId
      growSurfReferrerEmail
      growSurfReferrerFullName
      growSurfReferredEmail
      growSurfReferredFullName
      growSurfReferralComplete
      growSurfReferredByEmailBackup
      growSurfReferredByFullNameBackup
      growSurfParticipantEmail
      growSurfParticipantFullName
      growSurfParticipantReferralComplete
      stripeCustomerId
      stripeBillingEmail
      driverReportDayRange
      permissionHeraAi
      permissionVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogsHeraAi
      featureEnabledVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogReview
      featureEnabledVehiclePhotoLogReview
      featureEnabledInventoryManagement
      featureAccessInventoryManagement
      permissionInventoryManagement
      featureAccessSchedulingAndRostering
      featureEnabledSchedulingAndRostering
      permissionSchedulingAndRostering
      featureAccessRosterChecklist
      featureEnabledRosterChecklist
      permissionRosterChecklist
      featureAccessCounselings
      featureEnabledCounselings
      permissionCounselings
      featureAccessAssociateApp
      featureEnabledAssociateApp
      permissionAssociateApp
      featureAccessCustomEmailSending
      featureEnabledCustomEmailSending
      featureAccessHeraMessenger2
      featureEnabledHeraMessenger2
      permissionHeraMessenger2
      featureAccessPhoneAutomation
      featureEnabledPhoneAutomation
      permissionPhoneAutomation
      featureAccessWirelessSupportSync
      featureEnabledWirelessSupportSync
      permissionWirelessSupportSync
      featureAccessFilesManagement
      featureEnabledFilesManagement
      featureAccessFilesSignatureRequest
      featureEnabledFilesSignatureRequest
      featureAccessAIChat
      featureEnabledAIChat
      permissionAIChat
      featureAccessAmazonChromePlugin
      featureEnabledAmazonChromePlugin
      permissionAmazonChromePlugin
      featureAccessHierarchicalPermissions
      featureEnabledHierarchicalPermissions
      permissionHierarchicalPermissions
      payrollProvider
      customerCheckedUserRolesDateTime
      featureAccessPayrollProvider
      featureEnabledPayrollProvider
      permissionPayrollProvider
      accountType
      customerType
      customerSubType
      accountCountry
      isTemporaryAccount
      allowParentData
      parentAccountId
      isTemplate
      templateTenantId
      miradoreApiKey
      miradoreSiteName
      odometerReadingMaxThreshold
      defaultCommunicationChannels
      companyScoreCardsByYearWeek {
        items {
          id
          group
          week
          year
          yearWeek
          overallNumeric
          overall
          safetyAndCompliance
          comprehensiveAudit
          safetyScore
          safeDriving
          safeDrivingText
          fico
          seatbeltOff
          seatbeltOffText
          speedingEvent
          speedingEventText
          dvcrCompliance
          dvcrComplianceText
          onTimeCompliance
          onTimeComplianceText
          complianceScoreText
          workingHoursCompliance
          workingHoursComplianceText
          workingSafetyComplianceDevice
          workingSafetyComplianceDeviceText
          dspAudit
          dspAuditText
          thirtyDaysNoticeText
          customerEscalationDefectDPMO
          customerEscalationDefectDPMOText
          team
          highPerformersShare
          highPerformersShareText
          lowPerformersShare
          lowPerformersShareText
          attritionRate
          attritionRateText
          quality
          pickupQuality
          deliveryCompletion
          deliveryCompletionText
          dcDpmo
          dcDpmoText
          deliveredAndReceived
          deliveredAndReceivedText
          standardWorkComplianceText
          photoOnDelivery
          photoOnDeliveryText
          contactCompliance
          contactComplianceText
          scanCompliance
          scanComplianceText
          attendedDeliveryAccuracy
          attendedDeliveryAccuracyText
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          distractionsRateText
          followingDistanceRateText
          signSignalViolationsRateText
          scorecardPdf
          podQualityPdf
          customerFeedbackPdf
          ppsCsv
          harshBrakingEvent
          harshCorneringEvent
          harshBrakingEventText
          harshCorneringEventText
          deliverySlotPerformance
          deliverySlotPerformanceText
          tenantId
          customerDeliveryExperience
          customerDeliveryFeedback
          customerDeliveryFeedbackText
          cdfDpmo
          cdfDpmoText
          breachOfContract
          tenuredWorkforce
          tenuredWorkforceText
          deliverySuccessBehaviors
          deliverySuccessBehaviorsText
          pickupSuccessBehaviors
          pickupSuccessBehaviorsText
          fleetExecution
          fleetExecutionText
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      textractjobs {
        items {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      invoices {
        items {
          id
          invoiceTenantId
          createdAt
          group
          month
          year
          invoiceTotal
          variableTotal
          invoiceSubTotal
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          paidByCustomerAmount
          averageActiveDriverCount
          status
          html
          cardLastFourCharged
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parentAccount {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      users {
        items {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueLists {
        items {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      premiumStatusHistory {
        items {
          id
          premiumStatusHistoryTenantId
          group
          accountPremiumStatus
          changeNotes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateTenant = /* GraphQL */ `
  mutation UpdateTenant(
    $input: UpdateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    updateTenant(input: $input, condition: $condition) {
      id
      group
      createdAt
      companyName
      nameLog
      numberOfSeats
      logo
      accidentReport
      workmansComp
      dispatchNumber
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      zohoCrmAccountRecordId
      originationNumber
      timeZone
      locale
      trialExpDate
      firstInterestDateTime
      firstStartedTrialDateTime
      firstConvertedToPaidDateTime
      firstChurnedDateTime
      accountPremiumStatus
      accountCanceledNotes
      accountCanceledReason
      notes
      costStandard
      costBundle
      costPerformance
      costRostering
      costStaff
      costVehicles
      costMessaging
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      payOutstandingByDate
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      ownerUserId
      lastPaidPositiveInvoiceLineItemDateTime
      totalNumberOfMonthsPaidByTenant
      lifetimePaymentTotal
      averageMonthlyInvoiceTotal
      isTestingAccount
      calculatedOutstandingBalance
      bundleDeactivationAllowedAt
      performanceDeactivationAllowedAt
      rosteringDeactivationAllowedAt
      staffDeactivationAllowedAt
      vehiclesDeactivationAllowedAt
      automatedCoachingSendTime
      allowLibraryUpload
      coachingCustomMessage
      messageServiceProvider
      OriginationNumberOrderId
      OriginationNumberStatus
      customerStatus
      coachingFicoThresholdIssue
      coachingFicoThreshold
      coachingFicoThresholdPR
      coachingFicoThresholdKudo
      coachingFicoIssue
      coachingFicoCO
      coachingFicoPR
      coachingFicoKudo
      coachingDcrThresholdIssue
      coachingDcrThreshold
      coachingDcrThresholdPR
      coachingDcrThresholdKudo
      coachingDcrIssue
      coachingDcrCO
      coachingDcrPR
      coachingDcrKudo
      coachingDcDpmoThresholdIssue
      coachingDcDpmoThreshold
      coachingDcDpmoThresholdPR
      coachingDcDpmoThresholdKudo
      coachingDcDpmoIssue
      coachingDcDpmoCO
      coachingDcDpmoPR
      coachingDcDpmoKudo
      coachingDarThresholdIssue
      coachingDarThreshold
      coachingDarThresholdPR
      coachingDarThresholdKudo
      coachingDarIssue
      coachingDarCO
      coachingDarPR
      coachingDarKudo
      coachingDnrThresholdIssue
      coachingDnrThreshold
      coachingDnrThresholdPR
      coachingDnrThresholdKudo
      coachingDnrIssue
      coachingDnrCO
      coachingDnrPR
      coachingDnrKudo
      coachingDsbThresholdIssue
      coachingDsbThreshold
      coachingDsbThresholdPR
      coachingDsbThresholdKudo
      coachingDsbIssue
      coachingDsbCO
      coachingDsbPR
      coachingDsbKudo
      coachingSwcPodThresholdIssue
      coachingSwcPodThreshold
      coachingSwcPodThresholdKudo
      coachingSwcPodThresholdPR
      coachingSwcPodIssue
      coachingSwcPodCO
      coachingSwcPodPR
      coachingSwcPodKudo
      coachingSwcCcThresholdIssue
      coachingSwcCcThreshold
      coachingSwcCcThresholdKudo
      coachingSwcCcThresholdPR
      coachingSwcCcIssue
      coachingSwcCcCO
      coachingSwcCcPR
      coachingSwcCcKudo
      coachingSwcScThresholdIssue
      coachingSwcScThreshold
      coachingSwcScThresholdKudo
      coachingSwcScThresholdPR
      coachingSwcScIssue
      coachingSwcScCO
      coachingSwcScPR
      coachingSwcScKudo
      coachingSwcAdThresholdIssue
      coachingSwcAdThreshold
      coachingSwcAdThresholdKudo
      coachingSwcAdThresholdPR
      coachingSwcAdIssue
      coachingSwcAdCO
      coachingSwcAdPR
      coachingSwcAdKudo
      coachingSeatbeltOffThresholdIssue
      coachingSeatbeltOffThreshold
      coachingSeatbeltOffThresholdPR
      coachingSeatbeltOffThresholdKudo
      coachingSeatbeltOffIssue
      coachingSeatbeltOffCO
      coachingSeatbeltOffPR
      coachingSeatbeltOffKudo
      coachingSpeedingEventThresholdIssue
      coachingSpeedingEventThreshold
      coachingSpeedingEventThresholdPR
      coachingSpeedingEventThresholdKudo
      coachingSpeedingEventIssue
      coachingSpeedingEventCO
      coachingSpeedingEventPR
      coachingSpeedingEventKudo
      coachingDistractionsRateThresholdIssue
      coachingDistractionsRateThreshold
      coachingDistractionsRateThresholdPR
      coachingDistractionsRateThresholdKudo
      coachingDistractionsRateIssue
      coachingDistractionsRateCO
      coachingDistractionsRatePR
      coachingDistractionsRateKudo
      coachingFollowingDistanceRateThresholdIssue
      coachingFollowingDistanceRateThreshold
      coachingFollowingDistanceRateThresholdPR
      coachingFollowingDistanceRateThresholdKudo
      coachingFollowingDistanceRateIssue
      coachingFollowingDistanceRateCO
      coachingFollowingDistanceRatePR
      coachingFollowingDistanceRateKudo
      coachingSignSignalViolationsRateThresholdIssue
      coachingSignSignalViolationsRateThreshold
      coachingSignSignalViolationsRateThresholdPR
      coachingSignSignalViolationsRateThresholdKudo
      coachingSignSignalViolationsRateIssue
      coachingSignSignalViolationsRateCO
      coachingSignSignalViolationsRatePR
      coachingSignSignalViolationsRateKudo
      coachingOverallTierThresholdIssue
      coachingOverallTierThresholdKudo
      coachingOverallTierIssue
      coachingOverallTierKudo
      coachingOverallTierRatingIssue
      coachingOverallTierRatingKudo
      coachingConsecutiveTierThresholdIssue
      coachingConsecutiveTierThresholdKudo
      coachingConsecutiveTierIssue
      coachingConsecutiveTierKudo
      coachingConsecutiveTierRatingIssue
      coachingConsecutiveTierRatingKudo
      coachingPositiveFeedbackThresholdIssue
      coachingPositiveFeedbackThreshold
      coachingPositiveFeedbackThresholdPR
      coachingPositiveFeedbackThresholdKudo
      coachingPositiveFeedbackIssue
      coachingPositiveFeedbackCO
      coachingPositiveFeedbackPR
      coachingPositiveFeedbackKudo
      coachingDailyFicoThresholdIssue
      coachingDailyFicoThreshold
      coachingDailyFicoThresholdPR
      coachingDailyFicoThresholdKudo
      coachingDailyFicoIssue
      coachingDailyFicoCO
      coachingDailyFicoPR
      coachingDailyFicoKudo
      coachingSeatbeltThresholdIssue
      coachingSeatbeltThreshold
      coachingSeatbeltThresholdPR
      coachingSeatbeltThresholdKudo
      coachingSeatbeltIssue
      coachingSeatbeltCO
      coachingSeatbeltPR
      coachingSeatbeltKudo
      coachingSseIssue
      coachingSseCO
      coachingSsePR
      coachingSseKudo
      coachingSseThresholdIssue
      coachingSseThreshold
      coachingSseThresholdPR
      coachingSseThresholdKudo
      coachingDvcrsIssue
      coachingDvcrsCO
      coachingDvcrsPR
      coachingHarshBrakingRateThresholdIssue
      coachingHarshBrakingRateThreshold
      coachingHarshBrakingRateThresholdPR
      coachingHarshBrakingRateThresholdKudo
      coachingHarshBrakingRateIssue
      coachingHarshBrakingRateCO
      coachingHarshBrakingRatePR
      coachingHarshBrakingRateKudo
      coachingDaTierThresholdIssue
      coachingDaTierThresholdKudo
      coachingDaTierIssue
      coachingDaTierKudo
      coachingDaTierPR
      coachingDaTierCO
      coachingDaTierRatingIssue
      coachingDaTierRatingCO
      coachingDaTierRatingPR
      coachingDaTierRatingKudo
      coachingCdfScoreThresholdIssue
      coachingCdfScoreThreshold
      coachingCdfScoreThresholdPR
      coachingCdfScoreThresholdKudo
      coachingCdfScoreIssue
      coachingCdfScoreKudo
      coachingCdfScoreRatingIssue
      coachingCdfScoreCO
      coachingCdfScorePR
      coachingCdfScoreRatingKudo
      coachingCdfDpmoThresholdIssue
      coachingCdfDpmoThreshold
      coachingCdfDpmoThresholdPR
      coachingCdfDpmoThresholdKudo
      coachingCdfDpmoIssue
      coachingCdfDpmoKudo
      coachingCdfDpmoRatingIssue
      coachingCdfDpmoCO
      coachingCdfDpmoPR
      coachingCdfDpmoRatingKudo
      coachingHarshCorneringRateThresholdIssue
      coachingHarshCorneringRateThreshold
      coachingHarshCorneringRateThresholdPR
      coachingHarshCorneringRateThresholdKudo
      coachingHarshCorneringRateIssue
      coachingHarshCorneringRateCO
      coachingHarshCorneringRatePR
      coachingHarshCorneringRateKudo
      coachingPpsCompliancePercentThresholdIssue
      coachingPpsCompliancePercentThreshold
      coachingPpsCompliancePercentThresholdPR
      coachingPpsCompliancePercentThresholdKudo
      coachingPpsCompliancePercentIssue
      coachingPpsCompliancePercentCO
      coachingPpsCompliancePercentPR
      coachingPpsCompliancePercentKudo
      coachingPpsBreachesThresholdIssue
      coachingPpsBreachesThreshold
      coachingPpsBreachesThresholdPR
      coachingPpsBreachesThresholdKudo
      coachingPpsBreachesIssue
      coachingPpsBreachesCO
      coachingPpsBreachesPR
      coachingPpsBreachesKudo
      coachingDailyPpsCompliancePercentIssue
      coachingDailyPpsCompliancePercentThresholdIssue
      coachingDailyPpsCompliancePercentCO
      coachingDailyPpsCompliancePercentThreshold
      coachingDailyPpsCompliancePercentPR
      coachingDailyPpsCompliancePercentThresholdPR
      coachingDailyPpsCompliancePercentKudo
      coachingDailyPpsCompliancePercentThresholdKudo
      coachingDailyPpsMissingBrakeIssue
      coachingDailyPpsMissingBrakeThresholdIssue
      coachingDailyPpsMissingBrakeCO
      coachingDailyPpsMissingBrakeThreshold
      coachingDailyPpsMissingBrakePR
      coachingDailyPpsMissingBrakeThresholdPR
      coachingDailyPpsMissingBrakeKudo
      coachingDailyPpsMissingBrakeThresholdKudo
      coachingDailyPpsMissingGearIssue
      coachingDailyPpsMissingGearThresholdIssue
      coachingDailyPpsMissingGearCO
      coachingDailyPpsMissingGearThreshold
      coachingDailyPpsMissingGearPR
      coachingDailyPpsMissingGearThresholdPR
      coachingDailyPpsMissingGearKudo
      coachingDailyPpsMissingGearThresholdKudo
      coachingDailyComplianceRateThresholdIssue
      coachingDailyComplianceRateThreshold
      coachingDailyComplianceRateThresholdPR
      coachingDailyComplianceRateThresholdKudo
      coachingDailyComplianceRateIssue
      coachingDailyComplianceRateCO
      coachingDailyComplianceRatePR
      coachingDailyComplianceRateKudo
      coachingPsbThresholdIssue
      coachingPsbThreshold
      coachingPsbThresholdPR
      coachingPsbThresholdKudo
      coachingPsbIssue
      coachingPsbCO
      coachingPsbPR
      coachingPsbKudo
      coachingPsbRatingIssue
      coachingPsbRatingKudo
      coachingDaMishandledPackageIssue
      coachingDaMishandledPackageCO
      coachingDaMishandledPackageThresholdIssue
      coachingDaMishandledPackageThreshold
      coachingDaWasUnprofessionalIssue
      coachingDaWasUnprofessionalCO
      coachingDaWasUnprofessionalThresholdIssue
      coachingDaWasUnprofessionalThreshold
      coachingDaIgnoreInstructionsIssue
      coachingDaIgnoreInstructionsCO
      coachingDaIgnoreInstructionsThresholdIssue
      coachingDaIgnoreInstructionsThreshold
      coachingDeliveredToWrongAddressIssue
      coachingDeliveredToWrongAddressCO
      coachingDeliveredToWrongAddressThresholdIssue
      coachingDeliveredToWrongAddressThreshold
      coachingNeverReceivedDeliveryIssue
      coachingNeverReceivedDeliveryCO
      coachingNeverReceivedDeliveryThresholdIssue
      coachingNeverReceivedDeliveryThreshold
      coachingReceivedWrongItemIssue
      coachingReceivedWrongItemCO
      coachingReceivedWrongItemThresholdIssue
      coachingReceivedWrongItemThreshold
      coachingTraningRemainingIssue
      coachingTraningRemainingCO
      coachingTraningRemainingPR
      coachingCameraObstructionIssue
      coachingCameraObstructionCO
      coachingCameraObstructionThresholdIssue
      coachingCameraObstructionThreshold
      coachingDriverDistractionIssue
      coachingDriverDistractionCO
      coachingDriverDistractionThresholdIssue
      coachingDriverDistractionThreshold
      coachingDriverDrowsinessIssue
      coachingDriverDrowsinessCO
      coachingDriverDrowsinessThresholdIssue
      coachingDriverDrowsinessThreshold
      coachingDriverInitiatedIssue
      coachingDriverInitiatedCO
      coachingDriverInitiatedThresholdIssue
      coachingDriverInitiatedThreshold
      coachingDriverStarPR
      coachingDriverStarKudo
      coachingDriverStarThresholdPR
      coachingDriverStarThresholdKudo
      coachingFaceMaskComplianceIssue
      coachingFaceMaskComplianceCO
      coachingFaceMaskComplianceThresholdIssue
      coachingFaceMaskComplianceThreshold
      coachingFollowingDistanceIssue
      coachingFollowingDistanceCO
      coachingFollowingDistanceThresholdIssue
      coachingFollowingDistanceThreshold
      coachingHardAccelerationIssue
      coachingHardAccelerationCO
      coachingHardAccelerationThresholdIssue
      coachingHardAccelerationThreshold
      coachingHardBrakingIssue
      coachingHardBrakingCO
      coachingHardBrakingThresholdIssue
      coachingHardBrakingThreshold
      coachingHardTurnIssue
      coachingHardTurnCO
      coachingHardTurnThresholdIssue
      coachingHardTurnThreshold
      coachingHighGIssue
      coachingHighGCO
      coachingHighGThresholdIssue
      coachingHighGThreshold
      coachingLowImpactIssue
      coachingLowImpactCO
      coachingLowImpactThresholdIssue
      coachingLowImpactThreshold
      coachingSeatbeltComplianceIssue
      coachingSeatbeltComplianceCO
      coachingSeatbeltComplianceThresholdIssue
      coachingSeatbeltComplianceThreshold
      coachingSignViolationsIssue
      coachingSignViolationsCO
      coachingSignViolationsThresholdIssue
      coachingSignViolationsThreshold
      coachingSpeedingViolationsIssue
      coachingSpeedingViolationsCO
      coachingSpeedingViolationsThresholdIssue
      coachingSpeedingViolationsThreshold
      coachingTrafficLightViolationIssue
      coachingTrafficLightViolationCO
      coachingTrafficLightViolationThresholdIssue
      coachingTrafficLightViolationThreshold
      coachingUTurnIssue
      coachingUTurnCO
      coachingUTurnThresholdIssue
      coachingUTurnThreshold
      coachingWeavingIssue
      coachingWeavingCO
      coachingWeavingThresholdIssue
      coachingWeavingThreshold
      coachingDriverRankRange
      usesXLcoaching
      shortCode
      growSurfParticipantId
      growSurfReferrerEmail
      growSurfReferrerFullName
      growSurfReferredEmail
      growSurfReferredFullName
      growSurfReferralComplete
      growSurfReferredByEmailBackup
      growSurfReferredByFullNameBackup
      growSurfParticipantEmail
      growSurfParticipantFullName
      growSurfParticipantReferralComplete
      stripeCustomerId
      stripeBillingEmail
      driverReportDayRange
      permissionHeraAi
      permissionVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogsHeraAi
      featureEnabledVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogReview
      featureEnabledVehiclePhotoLogReview
      featureEnabledInventoryManagement
      featureAccessInventoryManagement
      permissionInventoryManagement
      featureAccessSchedulingAndRostering
      featureEnabledSchedulingAndRostering
      permissionSchedulingAndRostering
      featureAccessRosterChecklist
      featureEnabledRosterChecklist
      permissionRosterChecklist
      featureAccessCounselings
      featureEnabledCounselings
      permissionCounselings
      featureAccessAssociateApp
      featureEnabledAssociateApp
      permissionAssociateApp
      featureAccessCustomEmailSending
      featureEnabledCustomEmailSending
      featureAccessHeraMessenger2
      featureEnabledHeraMessenger2
      permissionHeraMessenger2
      featureAccessPhoneAutomation
      featureEnabledPhoneAutomation
      permissionPhoneAutomation
      featureAccessWirelessSupportSync
      featureEnabledWirelessSupportSync
      permissionWirelessSupportSync
      featureAccessFilesManagement
      featureEnabledFilesManagement
      featureAccessFilesSignatureRequest
      featureEnabledFilesSignatureRequest
      featureAccessAIChat
      featureEnabledAIChat
      permissionAIChat
      featureAccessAmazonChromePlugin
      featureEnabledAmazonChromePlugin
      permissionAmazonChromePlugin
      featureAccessHierarchicalPermissions
      featureEnabledHierarchicalPermissions
      permissionHierarchicalPermissions
      payrollProvider
      customerCheckedUserRolesDateTime
      featureAccessPayrollProvider
      featureEnabledPayrollProvider
      permissionPayrollProvider
      accountType
      customerType
      customerSubType
      accountCountry
      isTemporaryAccount
      allowParentData
      parentAccountId
      isTemplate
      templateTenantId
      miradoreApiKey
      miradoreSiteName
      odometerReadingMaxThreshold
      defaultCommunicationChannels
      companyScoreCardsByYearWeek {
        items {
          id
          group
          week
          year
          yearWeek
          overallNumeric
          overall
          safetyAndCompliance
          comprehensiveAudit
          safetyScore
          safeDriving
          safeDrivingText
          fico
          seatbeltOff
          seatbeltOffText
          speedingEvent
          speedingEventText
          dvcrCompliance
          dvcrComplianceText
          onTimeCompliance
          onTimeComplianceText
          complianceScoreText
          workingHoursCompliance
          workingHoursComplianceText
          workingSafetyComplianceDevice
          workingSafetyComplianceDeviceText
          dspAudit
          dspAuditText
          thirtyDaysNoticeText
          customerEscalationDefectDPMO
          customerEscalationDefectDPMOText
          team
          highPerformersShare
          highPerformersShareText
          lowPerformersShare
          lowPerformersShareText
          attritionRate
          attritionRateText
          quality
          pickupQuality
          deliveryCompletion
          deliveryCompletionText
          dcDpmo
          dcDpmoText
          deliveredAndReceived
          deliveredAndReceivedText
          standardWorkComplianceText
          photoOnDelivery
          photoOnDeliveryText
          contactCompliance
          contactComplianceText
          scanCompliance
          scanComplianceText
          attendedDeliveryAccuracy
          attendedDeliveryAccuracyText
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          distractionsRateText
          followingDistanceRateText
          signSignalViolationsRateText
          scorecardPdf
          podQualityPdf
          customerFeedbackPdf
          ppsCsv
          harshBrakingEvent
          harshCorneringEvent
          harshBrakingEventText
          harshCorneringEventText
          deliverySlotPerformance
          deliverySlotPerformanceText
          tenantId
          customerDeliveryExperience
          customerDeliveryFeedback
          customerDeliveryFeedbackText
          cdfDpmo
          cdfDpmoText
          breachOfContract
          tenuredWorkforce
          tenuredWorkforceText
          deliverySuccessBehaviors
          deliverySuccessBehaviorsText
          pickupSuccessBehaviors
          pickupSuccessBehaviorsText
          fleetExecution
          fleetExecutionText
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      textractjobs {
        items {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      invoices {
        items {
          id
          invoiceTenantId
          createdAt
          group
          month
          year
          invoiceTotal
          variableTotal
          invoiceSubTotal
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          paidByCustomerAmount
          averageActiveDriverCount
          status
          html
          cardLastFourCharged
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parentAccount {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      users {
        items {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueLists {
        items {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      premiumStatusHistory {
        items {
          id
          premiumStatusHistoryTenantId
          group
          accountPremiumStatus
          changeNotes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteTenant = /* GraphQL */ `
  mutation DeleteTenant(
    $input: DeleteTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    deleteTenant(input: $input, condition: $condition) {
      id
      group
      createdAt
      companyName
      nameLog
      numberOfSeats
      logo
      accidentReport
      workmansComp
      dispatchNumber
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      zohoCrmAccountRecordId
      originationNumber
      timeZone
      locale
      trialExpDate
      firstInterestDateTime
      firstStartedTrialDateTime
      firstConvertedToPaidDateTime
      firstChurnedDateTime
      accountPremiumStatus
      accountCanceledNotes
      accountCanceledReason
      notes
      costStandard
      costBundle
      costPerformance
      costRostering
      costStaff
      costVehicles
      costMessaging
      discountPercent
      discountFixed
      discountPercentLabel
      discountFixedLabel
      payOutstandingByDate
      flatMonthlyBillingAmount
      flatMonthlyBillingLabel
      ownerUserId
      lastPaidPositiveInvoiceLineItemDateTime
      totalNumberOfMonthsPaidByTenant
      lifetimePaymentTotal
      averageMonthlyInvoiceTotal
      isTestingAccount
      calculatedOutstandingBalance
      bundleDeactivationAllowedAt
      performanceDeactivationAllowedAt
      rosteringDeactivationAllowedAt
      staffDeactivationAllowedAt
      vehiclesDeactivationAllowedAt
      automatedCoachingSendTime
      allowLibraryUpload
      coachingCustomMessage
      messageServiceProvider
      OriginationNumberOrderId
      OriginationNumberStatus
      customerStatus
      coachingFicoThresholdIssue
      coachingFicoThreshold
      coachingFicoThresholdPR
      coachingFicoThresholdKudo
      coachingFicoIssue
      coachingFicoCO
      coachingFicoPR
      coachingFicoKudo
      coachingDcrThresholdIssue
      coachingDcrThreshold
      coachingDcrThresholdPR
      coachingDcrThresholdKudo
      coachingDcrIssue
      coachingDcrCO
      coachingDcrPR
      coachingDcrKudo
      coachingDcDpmoThresholdIssue
      coachingDcDpmoThreshold
      coachingDcDpmoThresholdPR
      coachingDcDpmoThresholdKudo
      coachingDcDpmoIssue
      coachingDcDpmoCO
      coachingDcDpmoPR
      coachingDcDpmoKudo
      coachingDarThresholdIssue
      coachingDarThreshold
      coachingDarThresholdPR
      coachingDarThresholdKudo
      coachingDarIssue
      coachingDarCO
      coachingDarPR
      coachingDarKudo
      coachingDnrThresholdIssue
      coachingDnrThreshold
      coachingDnrThresholdPR
      coachingDnrThresholdKudo
      coachingDnrIssue
      coachingDnrCO
      coachingDnrPR
      coachingDnrKudo
      coachingDsbThresholdIssue
      coachingDsbThreshold
      coachingDsbThresholdPR
      coachingDsbThresholdKudo
      coachingDsbIssue
      coachingDsbCO
      coachingDsbPR
      coachingDsbKudo
      coachingSwcPodThresholdIssue
      coachingSwcPodThreshold
      coachingSwcPodThresholdKudo
      coachingSwcPodThresholdPR
      coachingSwcPodIssue
      coachingSwcPodCO
      coachingSwcPodPR
      coachingSwcPodKudo
      coachingSwcCcThresholdIssue
      coachingSwcCcThreshold
      coachingSwcCcThresholdKudo
      coachingSwcCcThresholdPR
      coachingSwcCcIssue
      coachingSwcCcCO
      coachingSwcCcPR
      coachingSwcCcKudo
      coachingSwcScThresholdIssue
      coachingSwcScThreshold
      coachingSwcScThresholdKudo
      coachingSwcScThresholdPR
      coachingSwcScIssue
      coachingSwcScCO
      coachingSwcScPR
      coachingSwcScKudo
      coachingSwcAdThresholdIssue
      coachingSwcAdThreshold
      coachingSwcAdThresholdKudo
      coachingSwcAdThresholdPR
      coachingSwcAdIssue
      coachingSwcAdCO
      coachingSwcAdPR
      coachingSwcAdKudo
      coachingSeatbeltOffThresholdIssue
      coachingSeatbeltOffThreshold
      coachingSeatbeltOffThresholdPR
      coachingSeatbeltOffThresholdKudo
      coachingSeatbeltOffIssue
      coachingSeatbeltOffCO
      coachingSeatbeltOffPR
      coachingSeatbeltOffKudo
      coachingSpeedingEventThresholdIssue
      coachingSpeedingEventThreshold
      coachingSpeedingEventThresholdPR
      coachingSpeedingEventThresholdKudo
      coachingSpeedingEventIssue
      coachingSpeedingEventCO
      coachingSpeedingEventPR
      coachingSpeedingEventKudo
      coachingDistractionsRateThresholdIssue
      coachingDistractionsRateThreshold
      coachingDistractionsRateThresholdPR
      coachingDistractionsRateThresholdKudo
      coachingDistractionsRateIssue
      coachingDistractionsRateCO
      coachingDistractionsRatePR
      coachingDistractionsRateKudo
      coachingFollowingDistanceRateThresholdIssue
      coachingFollowingDistanceRateThreshold
      coachingFollowingDistanceRateThresholdPR
      coachingFollowingDistanceRateThresholdKudo
      coachingFollowingDistanceRateIssue
      coachingFollowingDistanceRateCO
      coachingFollowingDistanceRatePR
      coachingFollowingDistanceRateKudo
      coachingSignSignalViolationsRateThresholdIssue
      coachingSignSignalViolationsRateThreshold
      coachingSignSignalViolationsRateThresholdPR
      coachingSignSignalViolationsRateThresholdKudo
      coachingSignSignalViolationsRateIssue
      coachingSignSignalViolationsRateCO
      coachingSignSignalViolationsRatePR
      coachingSignSignalViolationsRateKudo
      coachingOverallTierThresholdIssue
      coachingOverallTierThresholdKudo
      coachingOverallTierIssue
      coachingOverallTierKudo
      coachingOverallTierRatingIssue
      coachingOverallTierRatingKudo
      coachingConsecutiveTierThresholdIssue
      coachingConsecutiveTierThresholdKudo
      coachingConsecutiveTierIssue
      coachingConsecutiveTierKudo
      coachingConsecutiveTierRatingIssue
      coachingConsecutiveTierRatingKudo
      coachingPositiveFeedbackThresholdIssue
      coachingPositiveFeedbackThreshold
      coachingPositiveFeedbackThresholdPR
      coachingPositiveFeedbackThresholdKudo
      coachingPositiveFeedbackIssue
      coachingPositiveFeedbackCO
      coachingPositiveFeedbackPR
      coachingPositiveFeedbackKudo
      coachingDailyFicoThresholdIssue
      coachingDailyFicoThreshold
      coachingDailyFicoThresholdPR
      coachingDailyFicoThresholdKudo
      coachingDailyFicoIssue
      coachingDailyFicoCO
      coachingDailyFicoPR
      coachingDailyFicoKudo
      coachingSeatbeltThresholdIssue
      coachingSeatbeltThreshold
      coachingSeatbeltThresholdPR
      coachingSeatbeltThresholdKudo
      coachingSeatbeltIssue
      coachingSeatbeltCO
      coachingSeatbeltPR
      coachingSeatbeltKudo
      coachingSseIssue
      coachingSseCO
      coachingSsePR
      coachingSseKudo
      coachingSseThresholdIssue
      coachingSseThreshold
      coachingSseThresholdPR
      coachingSseThresholdKudo
      coachingDvcrsIssue
      coachingDvcrsCO
      coachingDvcrsPR
      coachingHarshBrakingRateThresholdIssue
      coachingHarshBrakingRateThreshold
      coachingHarshBrakingRateThresholdPR
      coachingHarshBrakingRateThresholdKudo
      coachingHarshBrakingRateIssue
      coachingHarshBrakingRateCO
      coachingHarshBrakingRatePR
      coachingHarshBrakingRateKudo
      coachingDaTierThresholdIssue
      coachingDaTierThresholdKudo
      coachingDaTierIssue
      coachingDaTierKudo
      coachingDaTierPR
      coachingDaTierCO
      coachingDaTierRatingIssue
      coachingDaTierRatingCO
      coachingDaTierRatingPR
      coachingDaTierRatingKudo
      coachingCdfScoreThresholdIssue
      coachingCdfScoreThreshold
      coachingCdfScoreThresholdPR
      coachingCdfScoreThresholdKudo
      coachingCdfScoreIssue
      coachingCdfScoreKudo
      coachingCdfScoreRatingIssue
      coachingCdfScoreCO
      coachingCdfScorePR
      coachingCdfScoreRatingKudo
      coachingCdfDpmoThresholdIssue
      coachingCdfDpmoThreshold
      coachingCdfDpmoThresholdPR
      coachingCdfDpmoThresholdKudo
      coachingCdfDpmoIssue
      coachingCdfDpmoKudo
      coachingCdfDpmoRatingIssue
      coachingCdfDpmoCO
      coachingCdfDpmoPR
      coachingCdfDpmoRatingKudo
      coachingHarshCorneringRateThresholdIssue
      coachingHarshCorneringRateThreshold
      coachingHarshCorneringRateThresholdPR
      coachingHarshCorneringRateThresholdKudo
      coachingHarshCorneringRateIssue
      coachingHarshCorneringRateCO
      coachingHarshCorneringRatePR
      coachingHarshCorneringRateKudo
      coachingPpsCompliancePercentThresholdIssue
      coachingPpsCompliancePercentThreshold
      coachingPpsCompliancePercentThresholdPR
      coachingPpsCompliancePercentThresholdKudo
      coachingPpsCompliancePercentIssue
      coachingPpsCompliancePercentCO
      coachingPpsCompliancePercentPR
      coachingPpsCompliancePercentKudo
      coachingPpsBreachesThresholdIssue
      coachingPpsBreachesThreshold
      coachingPpsBreachesThresholdPR
      coachingPpsBreachesThresholdKudo
      coachingPpsBreachesIssue
      coachingPpsBreachesCO
      coachingPpsBreachesPR
      coachingPpsBreachesKudo
      coachingDailyPpsCompliancePercentIssue
      coachingDailyPpsCompliancePercentThresholdIssue
      coachingDailyPpsCompliancePercentCO
      coachingDailyPpsCompliancePercentThreshold
      coachingDailyPpsCompliancePercentPR
      coachingDailyPpsCompliancePercentThresholdPR
      coachingDailyPpsCompliancePercentKudo
      coachingDailyPpsCompliancePercentThresholdKudo
      coachingDailyPpsMissingBrakeIssue
      coachingDailyPpsMissingBrakeThresholdIssue
      coachingDailyPpsMissingBrakeCO
      coachingDailyPpsMissingBrakeThreshold
      coachingDailyPpsMissingBrakePR
      coachingDailyPpsMissingBrakeThresholdPR
      coachingDailyPpsMissingBrakeKudo
      coachingDailyPpsMissingBrakeThresholdKudo
      coachingDailyPpsMissingGearIssue
      coachingDailyPpsMissingGearThresholdIssue
      coachingDailyPpsMissingGearCO
      coachingDailyPpsMissingGearThreshold
      coachingDailyPpsMissingGearPR
      coachingDailyPpsMissingGearThresholdPR
      coachingDailyPpsMissingGearKudo
      coachingDailyPpsMissingGearThresholdKudo
      coachingDailyComplianceRateThresholdIssue
      coachingDailyComplianceRateThreshold
      coachingDailyComplianceRateThresholdPR
      coachingDailyComplianceRateThresholdKudo
      coachingDailyComplianceRateIssue
      coachingDailyComplianceRateCO
      coachingDailyComplianceRatePR
      coachingDailyComplianceRateKudo
      coachingPsbThresholdIssue
      coachingPsbThreshold
      coachingPsbThresholdPR
      coachingPsbThresholdKudo
      coachingPsbIssue
      coachingPsbCO
      coachingPsbPR
      coachingPsbKudo
      coachingPsbRatingIssue
      coachingPsbRatingKudo
      coachingDaMishandledPackageIssue
      coachingDaMishandledPackageCO
      coachingDaMishandledPackageThresholdIssue
      coachingDaMishandledPackageThreshold
      coachingDaWasUnprofessionalIssue
      coachingDaWasUnprofessionalCO
      coachingDaWasUnprofessionalThresholdIssue
      coachingDaWasUnprofessionalThreshold
      coachingDaIgnoreInstructionsIssue
      coachingDaIgnoreInstructionsCO
      coachingDaIgnoreInstructionsThresholdIssue
      coachingDaIgnoreInstructionsThreshold
      coachingDeliveredToWrongAddressIssue
      coachingDeliveredToWrongAddressCO
      coachingDeliveredToWrongAddressThresholdIssue
      coachingDeliveredToWrongAddressThreshold
      coachingNeverReceivedDeliveryIssue
      coachingNeverReceivedDeliveryCO
      coachingNeverReceivedDeliveryThresholdIssue
      coachingNeverReceivedDeliveryThreshold
      coachingReceivedWrongItemIssue
      coachingReceivedWrongItemCO
      coachingReceivedWrongItemThresholdIssue
      coachingReceivedWrongItemThreshold
      coachingTraningRemainingIssue
      coachingTraningRemainingCO
      coachingTraningRemainingPR
      coachingCameraObstructionIssue
      coachingCameraObstructionCO
      coachingCameraObstructionThresholdIssue
      coachingCameraObstructionThreshold
      coachingDriverDistractionIssue
      coachingDriverDistractionCO
      coachingDriverDistractionThresholdIssue
      coachingDriverDistractionThreshold
      coachingDriverDrowsinessIssue
      coachingDriverDrowsinessCO
      coachingDriverDrowsinessThresholdIssue
      coachingDriverDrowsinessThreshold
      coachingDriverInitiatedIssue
      coachingDriverInitiatedCO
      coachingDriverInitiatedThresholdIssue
      coachingDriverInitiatedThreshold
      coachingDriverStarPR
      coachingDriverStarKudo
      coachingDriverStarThresholdPR
      coachingDriverStarThresholdKudo
      coachingFaceMaskComplianceIssue
      coachingFaceMaskComplianceCO
      coachingFaceMaskComplianceThresholdIssue
      coachingFaceMaskComplianceThreshold
      coachingFollowingDistanceIssue
      coachingFollowingDistanceCO
      coachingFollowingDistanceThresholdIssue
      coachingFollowingDistanceThreshold
      coachingHardAccelerationIssue
      coachingHardAccelerationCO
      coachingHardAccelerationThresholdIssue
      coachingHardAccelerationThreshold
      coachingHardBrakingIssue
      coachingHardBrakingCO
      coachingHardBrakingThresholdIssue
      coachingHardBrakingThreshold
      coachingHardTurnIssue
      coachingHardTurnCO
      coachingHardTurnThresholdIssue
      coachingHardTurnThreshold
      coachingHighGIssue
      coachingHighGCO
      coachingHighGThresholdIssue
      coachingHighGThreshold
      coachingLowImpactIssue
      coachingLowImpactCO
      coachingLowImpactThresholdIssue
      coachingLowImpactThreshold
      coachingSeatbeltComplianceIssue
      coachingSeatbeltComplianceCO
      coachingSeatbeltComplianceThresholdIssue
      coachingSeatbeltComplianceThreshold
      coachingSignViolationsIssue
      coachingSignViolationsCO
      coachingSignViolationsThresholdIssue
      coachingSignViolationsThreshold
      coachingSpeedingViolationsIssue
      coachingSpeedingViolationsCO
      coachingSpeedingViolationsThresholdIssue
      coachingSpeedingViolationsThreshold
      coachingTrafficLightViolationIssue
      coachingTrafficLightViolationCO
      coachingTrafficLightViolationThresholdIssue
      coachingTrafficLightViolationThreshold
      coachingUTurnIssue
      coachingUTurnCO
      coachingUTurnThresholdIssue
      coachingUTurnThreshold
      coachingWeavingIssue
      coachingWeavingCO
      coachingWeavingThresholdIssue
      coachingWeavingThreshold
      coachingDriverRankRange
      usesXLcoaching
      shortCode
      growSurfParticipantId
      growSurfReferrerEmail
      growSurfReferrerFullName
      growSurfReferredEmail
      growSurfReferredFullName
      growSurfReferralComplete
      growSurfReferredByEmailBackup
      growSurfReferredByFullNameBackup
      growSurfParticipantEmail
      growSurfParticipantFullName
      growSurfParticipantReferralComplete
      stripeCustomerId
      stripeBillingEmail
      driverReportDayRange
      permissionHeraAi
      permissionVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogsHeraAi
      featureEnabledVehiclePhotoLogsHeraAi
      featureAccessVehiclePhotoLogReview
      featureEnabledVehiclePhotoLogReview
      featureEnabledInventoryManagement
      featureAccessInventoryManagement
      permissionInventoryManagement
      featureAccessSchedulingAndRostering
      featureEnabledSchedulingAndRostering
      permissionSchedulingAndRostering
      featureAccessRosterChecklist
      featureEnabledRosterChecklist
      permissionRosterChecklist
      featureAccessCounselings
      featureEnabledCounselings
      permissionCounselings
      featureAccessAssociateApp
      featureEnabledAssociateApp
      permissionAssociateApp
      featureAccessCustomEmailSending
      featureEnabledCustomEmailSending
      featureAccessHeraMessenger2
      featureEnabledHeraMessenger2
      permissionHeraMessenger2
      featureAccessPhoneAutomation
      featureEnabledPhoneAutomation
      permissionPhoneAutomation
      featureAccessWirelessSupportSync
      featureEnabledWirelessSupportSync
      permissionWirelessSupportSync
      featureAccessFilesManagement
      featureEnabledFilesManagement
      featureAccessFilesSignatureRequest
      featureEnabledFilesSignatureRequest
      featureAccessAIChat
      featureEnabledAIChat
      permissionAIChat
      featureAccessAmazonChromePlugin
      featureEnabledAmazonChromePlugin
      permissionAmazonChromePlugin
      featureAccessHierarchicalPermissions
      featureEnabledHierarchicalPermissions
      permissionHierarchicalPermissions
      payrollProvider
      customerCheckedUserRolesDateTime
      featureAccessPayrollProvider
      featureEnabledPayrollProvider
      permissionPayrollProvider
      accountType
      customerType
      customerSubType
      accountCountry
      isTemporaryAccount
      allowParentData
      parentAccountId
      isTemplate
      templateTenantId
      miradoreApiKey
      miradoreSiteName
      odometerReadingMaxThreshold
      defaultCommunicationChannels
      companyScoreCardsByYearWeek {
        items {
          id
          group
          week
          year
          yearWeek
          overallNumeric
          overall
          safetyAndCompliance
          comprehensiveAudit
          safetyScore
          safeDriving
          safeDrivingText
          fico
          seatbeltOff
          seatbeltOffText
          speedingEvent
          speedingEventText
          dvcrCompliance
          dvcrComplianceText
          onTimeCompliance
          onTimeComplianceText
          complianceScoreText
          workingHoursCompliance
          workingHoursComplianceText
          workingSafetyComplianceDevice
          workingSafetyComplianceDeviceText
          dspAudit
          dspAuditText
          thirtyDaysNoticeText
          customerEscalationDefectDPMO
          customerEscalationDefectDPMOText
          team
          highPerformersShare
          highPerformersShareText
          lowPerformersShare
          lowPerformersShareText
          attritionRate
          attritionRateText
          quality
          pickupQuality
          deliveryCompletion
          deliveryCompletionText
          dcDpmo
          dcDpmoText
          deliveredAndReceived
          deliveredAndReceivedText
          standardWorkComplianceText
          photoOnDelivery
          photoOnDeliveryText
          contactCompliance
          contactComplianceText
          scanCompliance
          scanComplianceText
          attendedDeliveryAccuracy
          attendedDeliveryAccuracyText
          distractionsRate
          followingDistanceRate
          signSignalViolationsRate
          distractionsRateText
          followingDistanceRateText
          signSignalViolationsRateText
          scorecardPdf
          podQualityPdf
          customerFeedbackPdf
          ppsCsv
          harshBrakingEvent
          harshCorneringEvent
          harshBrakingEventText
          harshCorneringEventText
          deliverySlotPerformance
          deliverySlotPerformanceText
          tenantId
          customerDeliveryExperience
          customerDeliveryFeedback
          customerDeliveryFeedbackText
          cdfDpmo
          cdfDpmoText
          breachOfContract
          tenuredWorkforce
          tenuredWorkforceText
          deliverySuccessBehaviors
          deliverySuccessBehaviorsText
          pickupSuccessBehaviors
          pickupSuccessBehaviorsText
          fleetExecution
          fleetExecutionText
          createdBy
          updatedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      textractjobs {
        items {
          id
          textractJobTenantId
          group
          owner
          userId
          key
          fileName
          week
          year
          template
          jobId
          jobStatus
          type
          isProcessed
          isProcessedS
          results
          summaryTableResults
          timeZone
          tenantUsesXL
          tenantUsesXLS
          customerSubType
          metadataCreationDate
          metadataModificationDate
          metadataYear
          metadataWeek
          scoreCardFailedValidators
          date
          automatedCoachingSendTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      invoices {
        items {
          id
          invoiceTenantId
          createdAt
          group
          month
          year
          invoiceTotal
          variableTotal
          invoiceSubTotal
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          paidByCustomerAmount
          averageActiveDriverCount
          status
          html
          cardLastFourCharged
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messages {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      parentAccount {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      users {
        items {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueLists {
        items {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      premiumStatusHistory {
        items {
          id
          premiumStatusHistoryTenantId
          group
          accountPremiumStatus
          changeNotes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCoachingHistory = /* GraphQL */ `
  mutation CreateCoachingHistory(
    $input: CreateCoachingHistoryInput!
    $condition: ModelCoachingHistoryConditionInput
  ) {
    createCoachingHistory(input: $input, condition: $condition) {
      id
      group
      type
      importId
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCoachingHistory = /* GraphQL */ `
  mutation UpdateCoachingHistory(
    $input: UpdateCoachingHistoryInput!
    $condition: ModelCoachingHistoryConditionInput
  ) {
    updateCoachingHistory(input: $input, condition: $condition) {
      id
      group
      type
      importId
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCoachingHistory = /* GraphQL */ `
  mutation DeleteCoachingHistory(
    $input: DeleteCoachingHistoryInput!
    $condition: ModelCoachingHistoryConditionInput
  ) {
    deleteCoachingHistory(input: $input, condition: $condition) {
      id
      group
      type
      importId
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCoachingRecords = /* GraphQL */ `
  mutation CreateCoachingRecords(
    $input: CreateCoachingRecordsInput!
    $condition: ModelCoachingRecordsConditionInput
  ) {
    createCoachingRecords(input: $input, condition: $condition) {
      id
      group
      importId
      type
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCoachingRecords = /* GraphQL */ `
  mutation UpdateCoachingRecords(
    $input: UpdateCoachingRecordsInput!
    $condition: ModelCoachingRecordsConditionInput
  ) {
    updateCoachingRecords(input: $input, condition: $condition) {
      id
      group
      importId
      type
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCoachingRecords = /* GraphQL */ `
  mutation DeleteCoachingRecords(
    $input: DeleteCoachingRecordsInput!
    $condition: ModelCoachingRecordsConditionInput
  ) {
    deleteCoachingRecords(input: $input, condition: $condition) {
      id
      group
      importId
      type
      results
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCustomLists = /* GraphQL */ `
  mutation CreateCustomLists(
    $input: CreateCustomListsInput!
    $condition: ModelCustomListsConditionInput
  ) {
    createCustomLists(input: $input, condition: $condition) {
      id
      group
      type
      enabledRecordTemplates
      listCategory
      listName
      listDisplay
      canDeleteAllOptions
      canUseHeraAiPrompts
      allowAlternateImportValues
      createdAt
      updatedAt
      options {
        items {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCustomLists = /* GraphQL */ `
  mutation UpdateCustomLists(
    $input: UpdateCustomListsInput!
    $condition: ModelCustomListsConditionInput
  ) {
    updateCustomLists(input: $input, condition: $condition) {
      id
      group
      type
      enabledRecordTemplates
      listCategory
      listName
      listDisplay
      canDeleteAllOptions
      canUseHeraAiPrompts
      allowAlternateImportValues
      createdAt
      updatedAt
      options {
        items {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCustomLists = /* GraphQL */ `
  mutation DeleteCustomLists(
    $input: DeleteCustomListsInput!
    $condition: ModelCustomListsConditionInput
  ) {
    deleteCustomLists(input: $input, condition: $condition) {
      id
      group
      type
      enabledRecordTemplates
      listCategory
      listName
      listDisplay
      canDeleteAllOptions
      canUseHeraAiPrompts
      allowAlternateImportValues
      createdAt
      updatedAt
      options {
        items {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createOptionsCustomLists = /* GraphQL */ `
  mutation CreateOptionsCustomLists(
    $input: CreateOptionsCustomListsInput!
    $condition: ModelOptionsCustomListsConditionInput
  ) {
    createOptionsCustomLists(input: $input, condition: $condition) {
      id
      optionsCustomListsCustomListsId
      group
      order
      option
      default
      isEnabled
      isCustom
      usedFor
      daysCount
      canBeEdited
      canBeDeleted
      canBeReorder
      pillColor
      recordTemplateJson
      statusType
      driverReportSetting
      heraAiPrompt
      isDefaultForSections
      isHiddenForSections
      alternateImportValues
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselingTypes {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      issues {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRouteParkingSpace {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routes {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelperStatus {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeParkingSpace {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      previousRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      currentRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      customLists {
        id
        group
        type
        enabledRecordTemplates
        listCategory
        listName
        listDisplay
        canDeleteAllOptions
        canUseHeraAiPrompts
        allowAlternateImportValues
        createdAt
        updatedAt
        options {
          nextToken
          __typename
        }
        __typename
      }
      associates {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicles {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      parkingSpace {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      companies {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      __typename
    }
  }
`;
export const updateOptionsCustomLists = /* GraphQL */ `
  mutation UpdateOptionsCustomLists(
    $input: UpdateOptionsCustomListsInput!
    $condition: ModelOptionsCustomListsConditionInput
  ) {
    updateOptionsCustomLists(input: $input, condition: $condition) {
      id
      optionsCustomListsCustomListsId
      group
      order
      option
      default
      isEnabled
      isCustom
      usedFor
      daysCount
      canBeEdited
      canBeDeleted
      canBeReorder
      pillColor
      recordTemplateJson
      statusType
      driverReportSetting
      heraAiPrompt
      isDefaultForSections
      isHiddenForSections
      alternateImportValues
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselingTypes {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      issues {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRouteParkingSpace {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routes {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelperStatus {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeParkingSpace {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      previousRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      currentRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      customLists {
        id
        group
        type
        enabledRecordTemplates
        listCategory
        listName
        listDisplay
        canDeleteAllOptions
        canUseHeraAiPrompts
        allowAlternateImportValues
        createdAt
        updatedAt
        options {
          nextToken
          __typename
        }
        __typename
      }
      associates {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicles {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      parkingSpace {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      companies {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      __typename
    }
  }
`;
export const deleteOptionsCustomLists = /* GraphQL */ `
  mutation DeleteOptionsCustomLists(
    $input: DeleteOptionsCustomListsInput!
    $condition: ModelOptionsCustomListsConditionInput
  ) {
    deleteOptionsCustomLists(input: $input, condition: $condition) {
      id
      optionsCustomListsCustomListsId
      group
      order
      option
      default
      isEnabled
      isCustom
      usedFor
      daysCount
      canBeEdited
      canBeDeleted
      canBeReorder
      pillColor
      recordTemplateJson
      statusType
      driverReportSetting
      heraAiPrompt
      isDefaultForSections
      isHiddenForSections
      alternateImportValues
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselings {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counselingTypes {
        items {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      issues {
        items {
          id
          infractionTypeId
          infractionStaffId
          infractionRouteId
          infractionCounselingId
          group
          infractionType
          comment
          date
          time
          staffId
          station
          trackingNumber
          infractionTier
          infractionDescription
          appealDate
          resolvedDate
          appealStatus
          appealNotes
          miscNotes
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      kudos {
        items {
          id
          kudoTypeId
          kudoRouteId
          kudoStaffId
          group
          kudoType
          notes
          date
          time
          staffId
          createdFrom
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      replaceByRouteParkingSpace {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routes {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeHelperStatus {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      routeParkingSpace {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      previousRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      currentRouteStatusHistory {
        items {
          id
          routeStatusRouteId
          routeStatusAssociateId
          routeStatusReplaceByRouteId
          routeStatusPreviousStatusId
          routeStatusCurrentStatusId
          group
          associateType
          reason
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      customLists {
        id
        group
        type
        enabledRecordTemplates
        listCategory
        listName
        listDisplay
        canDeleteAllOptions
        canUseHeraAiPrompts
        allowAlternateImportValues
        createdAt
        updatedAt
        options {
          nextToken
          __typename
        }
        __typename
      }
      associates {
        items {
          id
          optionsCustomListsStaffStaffId
          optionsCustomListsStaffOptionCustomListId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicles {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      parkingSpace {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      companies {
        items {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      __typename
    }
  }
`;
export const createOptionsCustomListsStaff = /* GraphQL */ `
  mutation CreateOptionsCustomListsStaff(
    $input: CreateOptionsCustomListsStaffInput!
    $condition: ModelOptionsCustomListsStaffConditionInput
  ) {
    createOptionsCustomListsStaff(input: $input, condition: $condition) {
      id
      optionsCustomListsStaffStaffId
      optionsCustomListsStaffOptionCustomListId
      group
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateOptionsCustomListsStaff = /* GraphQL */ `
  mutation UpdateOptionsCustomListsStaff(
    $input: UpdateOptionsCustomListsStaffInput!
    $condition: ModelOptionsCustomListsStaffConditionInput
  ) {
    updateOptionsCustomListsStaff(input: $input, condition: $condition) {
      id
      optionsCustomListsStaffStaffId
      optionsCustomListsStaffOptionCustomListId
      group
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteOptionsCustomListsStaff = /* GraphQL */ `
  mutation DeleteOptionsCustomListsStaff(
    $input: DeleteOptionsCustomListsStaffInput!
    $condition: ModelOptionsCustomListsStaffConditionInput
  ) {
    deleteOptionsCustomListsStaff(input: $input, condition: $condition) {
      id
      optionsCustomListsStaffStaffId
      optionsCustomListsStaffOptionCustomListId
      group
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      optionCustomList {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createUniform = /* GraphQL */ `
  mutation CreateUniform(
    $input: CreateUniformInput!
    $condition: ModelUniformConditionInput
  ) {
    createUniform(input: $input, condition: $condition) {
      id
      uniformSizeId
      uniformStaffId
      uniformUniformTypeId
      group
      qty
      issueDate
      returnedDate
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      uniformType {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      size {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateUniform = /* GraphQL */ `
  mutation UpdateUniform(
    $input: UpdateUniformInput!
    $condition: ModelUniformConditionInput
  ) {
    updateUniform(input: $input, condition: $condition) {
      id
      uniformSizeId
      uniformStaffId
      uniformUniformTypeId
      group
      qty
      issueDate
      returnedDate
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      uniformType {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      size {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteUniform = /* GraphQL */ `
  mutation DeleteUniform(
    $input: DeleteUniformInput!
    $condition: ModelUniformConditionInput
  ) {
    deleteUniform(input: $input, condition: $condition) {
      id
      uniformSizeId
      uniformStaffId
      uniformUniformTypeId
      group
      qty
      issueDate
      returnedDate
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      uniformType {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      size {
        id
        valueListItemValueListId
        group
        value
        custom
        hidden
        deleted
        driverReportSetting
        createdAt
        updatedAt
        uniformTypes {
          nextToken
          __typename
        }
        uniformSizes {
          nextToken
          __typename
        }
        valueList {
          id
          valueListTenantId
          group
          key
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      userTenantId
      group
      cognitoSub
      firstName
      lastName
      phone
      email
      notificationEmailAddress
      notificationSmsNumber
      receiveNotificationInApp
      receiveNotificationBySms
      receiveNotificationByEmail
      badgeCounterPreferences
      emailVerified
      role
      isCreator
      receiveSmsTaskReminders
      receiveEmailTaskReminders
      receiveSmsTaskAssignments
      receiveEmailTaskAssignments
      permissionLogin
      permissionFullAccess
      permissionDocuments
      permissionManageCounselings
      permissionDeleteCounselings
      permissionAccidents
      permissionInjuries
      permissionDrugTests
      permissionDailyRostering
      permissionMessenger
      permissionPerformanceCoaching
      permissionDAManagement
      permissionCustomLists
      permissionVehiclePhotoLogs
      permissionChecklistsAndVehiclePhotoLogs
      permissionManageLabels
      permissionVehicleManagement
      permissionTasksReports
      permissionMessageTemplate
      permissionCompanySettingsRosterChecklistTemplates
      permissionCompanyDevices
      permissionLocationDataFromCompanyDevices
      permissionCompanySettingsSchedulingRostering
      permissionVehicleImages
      permissionVehicleRelatedDocuments
      permissionOtherFiles
      permissionAmazonChromePlugin
      permissionAIChat
      permissionPhoneAutomation
      permissionPayrollProvider
      permissionInventoryManagement
      permissionVehiclePhotoLogsModule
      permissionVehiclePhotoLogReview
      reportsToUserId
      samePersonAsStaffId
      permissionDocumentsScope
      permissionManageCounselingsScope
      permissionAccidentsScope
      permissionInjuriesScope
      permissionDrugTestsScope
      permissionPerformanceCoachingScope
      permissionMessengerScope
      rolePermissionOverrides
      zohoCrmContactRecordId
      lastLogin
      emailAddedToSuppressionListDateTime
      createdAt
      updatedAt
      accidentsVerified {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injuriesCompletedBy {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesSent {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      resourcesUsage {
        items {
          id
          userInstanceId
          resourceUsageUserId
          resourceIdentifier
          group
          resourceType
          inUseAsOfDateTime
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignerTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      userNotification {
        items {
          id
          group
          title
          description
          expirationTTL
          notificationType
          isRead
          payload
          createdAt
          eventDispatchedAt
          userId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      subscribedDevices {
        items {
          id
          group
          subscriptionData
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      completedReminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesRead {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      userTenantId
      group
      cognitoSub
      firstName
      lastName
      phone
      email
      notificationEmailAddress
      notificationSmsNumber
      receiveNotificationInApp
      receiveNotificationBySms
      receiveNotificationByEmail
      badgeCounterPreferences
      emailVerified
      role
      isCreator
      receiveSmsTaskReminders
      receiveEmailTaskReminders
      receiveSmsTaskAssignments
      receiveEmailTaskAssignments
      permissionLogin
      permissionFullAccess
      permissionDocuments
      permissionManageCounselings
      permissionDeleteCounselings
      permissionAccidents
      permissionInjuries
      permissionDrugTests
      permissionDailyRostering
      permissionMessenger
      permissionPerformanceCoaching
      permissionDAManagement
      permissionCustomLists
      permissionVehiclePhotoLogs
      permissionChecklistsAndVehiclePhotoLogs
      permissionManageLabels
      permissionVehicleManagement
      permissionTasksReports
      permissionMessageTemplate
      permissionCompanySettingsRosterChecklistTemplates
      permissionCompanyDevices
      permissionLocationDataFromCompanyDevices
      permissionCompanySettingsSchedulingRostering
      permissionVehicleImages
      permissionVehicleRelatedDocuments
      permissionOtherFiles
      permissionAmazonChromePlugin
      permissionAIChat
      permissionPhoneAutomation
      permissionPayrollProvider
      permissionInventoryManagement
      permissionVehiclePhotoLogsModule
      permissionVehiclePhotoLogReview
      reportsToUserId
      samePersonAsStaffId
      permissionDocumentsScope
      permissionManageCounselingsScope
      permissionAccidentsScope
      permissionInjuriesScope
      permissionDrugTestsScope
      permissionPerformanceCoachingScope
      permissionMessengerScope
      rolePermissionOverrides
      zohoCrmContactRecordId
      lastLogin
      emailAddedToSuppressionListDateTime
      createdAt
      updatedAt
      accidentsVerified {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injuriesCompletedBy {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesSent {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      resourcesUsage {
        items {
          id
          userInstanceId
          resourceUsageUserId
          resourceIdentifier
          group
          resourceType
          inUseAsOfDateTime
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignerTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      userNotification {
        items {
          id
          group
          title
          description
          expirationTTL
          notificationType
          isRead
          payload
          createdAt
          eventDispatchedAt
          userId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      subscribedDevices {
        items {
          id
          group
          subscriptionData
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      completedReminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesRead {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      userTenantId
      group
      cognitoSub
      firstName
      lastName
      phone
      email
      notificationEmailAddress
      notificationSmsNumber
      receiveNotificationInApp
      receiveNotificationBySms
      receiveNotificationByEmail
      badgeCounterPreferences
      emailVerified
      role
      isCreator
      receiveSmsTaskReminders
      receiveEmailTaskReminders
      receiveSmsTaskAssignments
      receiveEmailTaskAssignments
      permissionLogin
      permissionFullAccess
      permissionDocuments
      permissionManageCounselings
      permissionDeleteCounselings
      permissionAccidents
      permissionInjuries
      permissionDrugTests
      permissionDailyRostering
      permissionMessenger
      permissionPerformanceCoaching
      permissionDAManagement
      permissionCustomLists
      permissionVehiclePhotoLogs
      permissionChecklistsAndVehiclePhotoLogs
      permissionManageLabels
      permissionVehicleManagement
      permissionTasksReports
      permissionMessageTemplate
      permissionCompanySettingsRosterChecklistTemplates
      permissionCompanyDevices
      permissionLocationDataFromCompanyDevices
      permissionCompanySettingsSchedulingRostering
      permissionVehicleImages
      permissionVehicleRelatedDocuments
      permissionOtherFiles
      permissionAmazonChromePlugin
      permissionAIChat
      permissionPhoneAutomation
      permissionPayrollProvider
      permissionInventoryManagement
      permissionVehiclePhotoLogsModule
      permissionVehiclePhotoLogReview
      reportsToUserId
      samePersonAsStaffId
      permissionDocumentsScope
      permissionManageCounselingsScope
      permissionAccidentsScope
      permissionInjuriesScope
      permissionDrugTestsScope
      permissionPerformanceCoachingScope
      permissionMessengerScope
      rolePermissionOverrides
      zohoCrmContactRecordId
      lastLogin
      emailAddedToSuppressionListDateTime
      createdAt
      updatedAt
      accidentsVerified {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      counseling {
        id
        counselingUserId
        counselingStaffId
        counselingSeverityId
        group
        date
        refusedToSign
        refusedByHeraUserId
        refusedToSignDateTime
        refusedByHeraUserExplanation
        signatureAcknowledge
        signature
        counselingNotes
        internalStaffNotes
        employeeNotes
        correctiveActionSummary
        priorDiscussionSummary
        consequencesOfFailure
        dateSent
        status
        scheduledToSendAt
        scheduledJobId
        dateSigned
        tenantId
        counselingTypeId
        createdFrom
        operationStatus
        createdAt
        updatedAt
        images {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        severity {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        type {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      injuriesCompletedBy {
        items {
          id
          injuryStaffId
          injuryCompletedByUserId
          group
          createdAt
          caseNumber
          injuryDate
          injuryTime
          injuryTimeIsUnknown
          timeStaffStartedWork
          completedBy
          completedByTitle
          completedByPhone
          driverHireDate
          driverDOB
          driverGender
          driverAddress
          driverCity
          driverState
          driverZip
          physicianName
          physicianFacility
          physicianAddress
          physicianCity
          physicianState
          physicianZip
          wasTreatedInER
          wasHospitalizedOvernight
          descriptionBeforeAccident
          descriptionInjury
          descriptionIncident
          descriptionDirectHarmCause
          injuryType
          notes
          dateOfDeath
          caseNumberFromLog
          staffId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesSent {
        items {
          id
          senderId
          staffId
          userId
          contactId
          messageRouteId
          messageTenantId
          messageAttachmentId
          messageReplaceByRouteId
          carrierMessageId
          group
          createdAt
          deviceId
          messageType
          channelType
          destinationNumber
          deviceDestinationNumber
          destinationEmail
          subject
          bodyText
          bodyHtml
          senderName
          smsStatus
          smsSendInformation
          deviceSmsStatus
          deviceSmsSendInformation
          emailStatus
          emailSendInformation
          inAppMessageStatus
          inAppMessageSendInformation
          phoneStatus
          phoneSendInformation
          sendbirdId
          isReadS
          sentBy
          sentAt
          linkExpiryDate
          attachmentLink
          contentType
          owner
          destinationName
          hasParts
          deviceAssociateId
          sendbirdTs
          rosterChecklistSubjectId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      resourcesUsage {
        items {
          id
          userInstanceId
          resourceUsageUserId
          resourceIdentifier
          group
          resourceType
          inUseAsOfDateTime
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignerTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assigneeTasks {
        items {
          id
          taskAssigneeId
          taskAssignerId
          taskAssigneeAssociateId
          createdAt
          owner
          creator
          group
          executionARN
          description
          date
          status
          taskName
          isDateReminder
          isNotifyOnCreation
          reminderDate
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      userNotification {
        items {
          id
          group
          title
          description
          expirationTTL
          notificationType
          isRead
          payload
          createdAt
          eventDispatchedAt
          userId
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      subscribedDevices {
        items {
          id
          group
          subscriptionData
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      completedReminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messagesRead {
        items {
          id
          userID
          messageID
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      messageReadStatus {
        items {
          id
          userID
          staffID
          deviceID
          group
          readUpToDateTime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserNotification = /* GraphQL */ `
  mutation CreateUserNotification(
    $input: CreateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    createUserNotification(input: $input, condition: $condition) {
      id
      group
      title
      description
      expirationTTL
      notificationType
      isRead
      payload
      createdAt
      eventDispatchedAt
      userId
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateUserNotification = /* GraphQL */ `
  mutation UpdateUserNotification(
    $input: UpdateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    updateUserNotification(input: $input, condition: $condition) {
      id
      group
      title
      description
      expirationTTL
      notificationType
      isRead
      payload
      createdAt
      eventDispatchedAt
      userId
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserNotification = /* GraphQL */ `
  mutation DeleteUserNotification(
    $input: DeleteUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    deleteUserNotification(input: $input, condition: $condition) {
      id
      group
      title
      description
      expirationTTL
      notificationType
      isRead
      payload
      createdAt
      eventDispatchedAt
      userId
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createSubscribedDevices = /* GraphQL */ `
  mutation CreateSubscribedDevices(
    $input: CreateSubscribedDevicesInput!
    $condition: ModelSubscribedDevicesConditionInput
  ) {
    createSubscribedDevices(input: $input, condition: $condition) {
      id
      group
      subscriptionData
      userId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateSubscribedDevices = /* GraphQL */ `
  mutation UpdateSubscribedDevices(
    $input: UpdateSubscribedDevicesInput!
    $condition: ModelSubscribedDevicesConditionInput
  ) {
    updateSubscribedDevices(input: $input, condition: $condition) {
      id
      group
      subscriptionData
      userId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteSubscribedDevices = /* GraphQL */ `
  mutation DeleteSubscribedDevices(
    $input: DeleteSubscribedDevicesInput!
    $condition: ModelSubscribedDevicesConditionInput
  ) {
    deleteSubscribedDevices(input: $input, condition: $condition) {
      id
      group
      subscriptionData
      userId
      createdAt
      updatedAt
      user {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createValueList = /* GraphQL */ `
  mutation CreateValueList(
    $input: CreateValueListInput!
    $condition: ModelValueListConditionInput
  ) {
    createValueList(input: $input, condition: $condition) {
      id
      valueListTenantId
      group
      key
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      items {
        items {
          id
          valueListItemValueListId
          group
          value
          custom
          hidden
          deleted
          driverReportSetting
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateValueList = /* GraphQL */ `
  mutation UpdateValueList(
    $input: UpdateValueListInput!
    $condition: ModelValueListConditionInput
  ) {
    updateValueList(input: $input, condition: $condition) {
      id
      valueListTenantId
      group
      key
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      items {
        items {
          id
          valueListItemValueListId
          group
          value
          custom
          hidden
          deleted
          driverReportSetting
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteValueList = /* GraphQL */ `
  mutation DeleteValueList(
    $input: DeleteValueListInput!
    $condition: ModelValueListConditionInput
  ) {
    deleteValueList(input: $input, condition: $condition) {
      id
      valueListTenantId
      group
      key
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      items {
        items {
          id
          valueListItemValueListId
          group
          value
          custom
          hidden
          deleted
          driverReportSetting
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createValueListItem = /* GraphQL */ `
  mutation CreateValueListItem(
    $input: CreateValueListItemInput!
    $condition: ModelValueListItemConditionInput
  ) {
    createValueListItem(input: $input, condition: $condition) {
      id
      valueListItemValueListId
      group
      value
      custom
      hidden
      deleted
      driverReportSetting
      createdAt
      updatedAt
      uniformTypes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uniformSizes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueList {
        id
        valueListTenantId
        group
        key
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateValueListItem = /* GraphQL */ `
  mutation UpdateValueListItem(
    $input: UpdateValueListItemInput!
    $condition: ModelValueListItemConditionInput
  ) {
    updateValueListItem(input: $input, condition: $condition) {
      id
      valueListItemValueListId
      group
      value
      custom
      hidden
      deleted
      driverReportSetting
      createdAt
      updatedAt
      uniformTypes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uniformSizes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueList {
        id
        valueListTenantId
        group
        key
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteValueListItem = /* GraphQL */ `
  mutation DeleteValueListItem(
    $input: DeleteValueListItemInput!
    $condition: ModelValueListItemConditionInput
  ) {
    deleteValueListItem(input: $input, condition: $condition) {
      id
      valueListItemValueListId
      group
      value
      custom
      hidden
      deleted
      driverReportSetting
      createdAt
      updatedAt
      uniformTypes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uniformSizes {
        items {
          id
          uniformSizeId
          uniformStaffId
          uniformUniformTypeId
          group
          qty
          issueDate
          returnedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      valueList {
        id
        valueListTenantId
        group
        key
        createdAt
        updatedAt
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        items {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createVehicle = /* GraphQL */ `
  mutation CreateVehicle(
    $input: CreateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    createVehicle(input: $input, condition: $condition) {
      id
      vehicleDeviceId
      vehicleDevice2Id
      vehicleCompanyId
      vehicleParkingSpaceId
      vehicleVehicleTypeId
      group
      name
      vehicle
      type
      state
      licensePlateExp
      dateStart
      dateEnd
      ownership
      provider
      otherProvider
      category
      vin
      make
      model
      year
      rentalAgreementNumber
      images
      rentalContracts
      accidentReports
      licensePlate
      mileage
      gasCard
      status
      statusReason
      notes
      lastOdometerReadingDate
      overTenThousandPounds
      customDeliveryVan
      tollPassId
      assignedDeviceName
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceRecords {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      odometerReadings {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      device2 {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      mentionedInNotes {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replacedRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultStaff {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff2 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff3 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleType {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      company {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicleRecordHistory {
        items {
          id
          vehicleId
          group
          changeType
          date
          changes
          statusChangeReason
          userId
          userFirstName
          userLastName
          userEmail
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      reminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vehicleStatusHistory {
        items {
          id
          vehicleStatusVehicleId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicle = /* GraphQL */ `
  mutation UpdateVehicle(
    $input: UpdateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    updateVehicle(input: $input, condition: $condition) {
      id
      vehicleDeviceId
      vehicleDevice2Id
      vehicleCompanyId
      vehicleParkingSpaceId
      vehicleVehicleTypeId
      group
      name
      vehicle
      type
      state
      licensePlateExp
      dateStart
      dateEnd
      ownership
      provider
      otherProvider
      category
      vin
      make
      model
      year
      rentalAgreementNumber
      images
      rentalContracts
      accidentReports
      licensePlate
      mileage
      gasCard
      status
      statusReason
      notes
      lastOdometerReadingDate
      overTenThousandPounds
      customDeliveryVan
      tollPassId
      assignedDeviceName
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceRecords {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      odometerReadings {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      device2 {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      mentionedInNotes {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replacedRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultStaff {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff2 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff3 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleType {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      company {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicleRecordHistory {
        items {
          id
          vehicleId
          group
          changeType
          date
          changes
          statusChangeReason
          userId
          userFirstName
          userLastName
          userEmail
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      reminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vehicleStatusHistory {
        items {
          id
          vehicleStatusVehicleId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicle = /* GraphQL */ `
  mutation DeleteVehicle(
    $input: DeleteVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    deleteVehicle(input: $input, condition: $condition) {
      id
      vehicleDeviceId
      vehicleDevice2Id
      vehicleCompanyId
      vehicleParkingSpaceId
      vehicleVehicleTypeId
      group
      name
      vehicle
      type
      state
      licensePlateExp
      dateStart
      dateEnd
      ownership
      provider
      otherProvider
      category
      vin
      make
      model
      year
      rentalAgreementNumber
      images
      rentalContracts
      accidentReports
      licensePlate
      mileage
      gasCard
      status
      statusReason
      notes
      lastOdometerReadingDate
      overTenThousandPounds
      customDeliveryVan
      tollPassId
      assignedDeviceName
      createdAt
      updatedAt
      accidents {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      maintenanceRecords {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleDamage {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      odometerReadings {
        items {
          id
          accidentVehicleId
          accidentStaffId
          accidentVerifiedById
          accidentMaintenanceVehicleId
          accidentDamageVehicleId
          accidentOdometerReadingVehicleId
          accidentVehicleDamageRouteId
          accidentOptionCustomListId
          accidentCreatedByUserId
          group
          atFault
          drugTestDate
          drugTestResult
          accidentDate
          accidentType
          associateStatement
          witnessName
          witnessStatement
          address
          addressCity
          addressState
          addressZip
          fileName
          verifiedDate
          notes
          insuranceClaimNumber
          policeDepartment
          policeOfficerName
          policeReportNumber
          staffId
          vehicleId
          vehicleHistoryType
          services
          location
          maintenanceStatus
          maintenanceDateCompleted
          mileageAsOfMaintenance
          mileage
          time
          damage
          damageSeverity
          vehicleDamageDate
          odometerDate
          odometerType
          costOfServices
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      device {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      device2 {
        id
        group
        deviceName
        phoneNumber
        carrier
        status
        imei
        notes
        deviceType
        deviceOperatingSystem
        deviceEnrollmentDate
        deviceICCID
        deviceSoftwareUpdateStatus
        deviceMiradoreId
        deviceCarrierValueListItemId
        wirelessSupportConnection
        deviceNameMiradore
        latestLastPing
        latestBattery
        deviceLastMessageTimestamp
        deviceLastMessage
        model
        manufacturer
        createdAt
        updatedAt
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        vehicle {
          nextToken
          scannedCount
          __typename
        }
        vehicle2 {
          nextToken
          scannedCount
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      dailyLogs {
        items {
          id
          dailyLogVehicleId
          dailyLogTakenByUserId
          dailyLogRosteredDayId
          dailyLogCreatedByUserId
          dailyLogTakenByAssociateId
          dailyLogCreationLinkSentByUserId
          dailyLogCreationLinkAssociateId
          reviewedByUserId
          group
          type
          date
          notes
          vehicleId
          creationLinkSentDateTime
          specificPhotos
          status
          flaggedAt
          flaggedByUserId
          reviewedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      documents {
        items {
          id
          documentStaffId
          documentRouteId
          documentVehicleId
          documentIncidentId
          documentInfractionId
          documentImageCounselingId
          documentImagevehicleDamageId
          documentOptionCustomListsId
          documentMaintenanceId
          documentReplaceByRouteId
          documentInjuryId
          documentDailyLogId
          documentShortenUrlId
          documentTakenByUserId
          documentTakenByAssociateId
          documentRosterChecklistSubjectItemId
          documentSchedulingRequestId
          group
          name
          key
          type
          uploadDate
          notes
          documentDate
          isDocVisibleToAssociate
          folderPath
          operationStatus
          externalDocId
          aiSubmissionDateTime
          aiResponseDateTime
          aiResponse
          aiResponseStatus
          aiIssues
          aiResponseAcknowledgedDateTime
          aiResponseFeedback
          aiDeterminedOdometerReadingValue
          aiResponseAcknowledgedBy
          aiSubmittedPrompt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      mentionedInNotes {
        items {
          id
          vehicleMentionNoteId
          vehicleMentionVehicleId
          group
          date
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      replacedRoutes {
        items {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      route {
        items {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      labels {
        items {
          id
          labelId
          staffId
          vehicleId
          group
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultStaff {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff2 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      defaultStaff3 {
        items {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        scannedCount
        __typename
      }
      vehicleType {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      company {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      parkingSpace {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicleRecordHistory {
        items {
          id
          vehicleId
          group
          changeType
          date
          changes
          statusChangeReason
          userId
          userFirstName
          userLastName
          userEmail
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      reminders {
        items {
          id
          vehicleMaintenanceReminderVehicleId
          vehicleMaintenanceReminderCompletedById
          group
          dueByDate
          dueByMileage
          services
          status
          vehicleId
          dueBySort
          dateCompleted
          userId
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vehicleStatusHistory {
        items {
          id
          vehicleStatusVehicleId
          group
          reason
          date
          previousStatus
          currentStatus
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createVehicleHistory = /* GraphQL */ `
  mutation CreateVehicleHistory(
    $input: CreateVehicleHistoryInput!
    $condition: ModelVehicleHistoryConditionInput
  ) {
    createVehicleHistory(input: $input, condition: $condition) {
      id
      vehicleId
      group
      changeType
      date
      changes
      statusChangeReason
      userId
      userFirstName
      userLastName
      userEmail
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicleHistory = /* GraphQL */ `
  mutation UpdateVehicleHistory(
    $input: UpdateVehicleHistoryInput!
    $condition: ModelVehicleHistoryConditionInput
  ) {
    updateVehicleHistory(input: $input, condition: $condition) {
      id
      vehicleId
      group
      changeType
      date
      changes
      statusChangeReason
      userId
      userFirstName
      userLastName
      userEmail
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicleHistory = /* GraphQL */ `
  mutation DeleteVehicleHistory(
    $input: DeleteVehicleHistoryInput!
    $condition: ModelVehicleHistoryConditionInput
  ) {
    deleteVehicleHistory(input: $input, condition: $condition) {
      id
      vehicleId
      group
      changeType
      date
      changes
      statusChangeReason
      userId
      userFirstName
      userLastName
      userEmail
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createVehicleMaintenanceReminder = /* GraphQL */ `
  mutation CreateVehicleMaintenanceReminder(
    $input: CreateVehicleMaintenanceReminderInput!
    $condition: ModelVehicleMaintenanceReminderConditionInput
  ) {
    createVehicleMaintenanceReminder(input: $input, condition: $condition) {
      id
      vehicleMaintenanceReminderVehicleId
      vehicleMaintenanceReminderCompletedById
      group
      dueByDate
      dueByMileage
      services
      status
      vehicleId
      dueBySort
      dateCompleted
      userId
      notes
      createdAt
      updatedAt
      completedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicleMaintenanceReminder = /* GraphQL */ `
  mutation UpdateVehicleMaintenanceReminder(
    $input: UpdateVehicleMaintenanceReminderInput!
    $condition: ModelVehicleMaintenanceReminderConditionInput
  ) {
    updateVehicleMaintenanceReminder(input: $input, condition: $condition) {
      id
      vehicleMaintenanceReminderVehicleId
      vehicleMaintenanceReminderCompletedById
      group
      dueByDate
      dueByMileage
      services
      status
      vehicleId
      dueBySort
      dateCompleted
      userId
      notes
      createdAt
      updatedAt
      completedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicleMaintenanceReminder = /* GraphQL */ `
  mutation DeleteVehicleMaintenanceReminder(
    $input: DeleteVehicleMaintenanceReminderInput!
    $condition: ModelVehicleMaintenanceReminderConditionInput
  ) {
    deleteVehicleMaintenanceReminder(input: $input, condition: $condition) {
      id
      vehicleMaintenanceReminderVehicleId
      vehicleMaintenanceReminderCompletedById
      group
      dueByDate
      dueByMileage
      services
      status
      vehicleId
      dueBySort
      dateCompleted
      userId
      notes
      createdAt
      updatedAt
      completedBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createVehicleStatus = /* GraphQL */ `
  mutation CreateVehicleStatus(
    $input: CreateVehicleStatusInput!
    $condition: ModelVehicleStatusConditionInput
  ) {
    createVehicleStatus(input: $input, condition: $condition) {
      id
      vehicleStatusVehicleId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicleStatus = /* GraphQL */ `
  mutation UpdateVehicleStatus(
    $input: UpdateVehicleStatusInput!
    $condition: ModelVehicleStatusConditionInput
  ) {
    updateVehicleStatus(input: $input, condition: $condition) {
      id
      vehicleStatusVehicleId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicleStatus = /* GraphQL */ `
  mutation DeleteVehicleStatus(
    $input: DeleteVehicleStatusInput!
    $condition: ModelVehicleStatusConditionInput
  ) {
    deleteVehicleStatus(input: $input, condition: $condition) {
      id
      vehicleStatusVehicleId
      group
      reason
      date
      previousStatus
      currentStatus
      createdAt
      updatedAt
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createRouteStaffRescuer = /* GraphQL */ `
  mutation CreateRouteStaffRescuer(
    $input: CreateRouteStaffRescuerInput!
    $condition: ModelRouteStaffRescuerConditionInput
  ) {
    createRouteStaffRescuer(input: $input, condition: $condition) {
      id
      routeId
      staffId
      group
      startTime
      endTime
      totalRescuedPackages
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateRouteStaffRescuer = /* GraphQL */ `
  mutation UpdateRouteStaffRescuer(
    $input: UpdateRouteStaffRescuerInput!
    $condition: ModelRouteStaffRescuerConditionInput
  ) {
    updateRouteStaffRescuer(input: $input, condition: $condition) {
      id
      routeId
      staffId
      group
      startTime
      endTime
      totalRescuedPackages
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteRouteStaffRescuer = /* GraphQL */ `
  mutation DeleteRouteStaffRescuer(
    $input: DeleteRouteStaffRescuerInput!
    $condition: ModelRouteStaffRescuerConditionInput
  ) {
    deleteRouteStaffRescuer(input: $input, condition: $condition) {
      id
      routeId
      staffId
      group
      startTime
      endTime
      totalRescuedPackages
      createdAt
      updatedAt
      route {
        id
        routeDailyRosterId
        routeDeviceId
        routeStaffId
        routeVehicleId
        routeRescuerId
        routeParkingSpaceId
        routeHelperId
        routeStatusId
        routeHelperStatusId
        group
        notes
        routeNumber
        staging
        previousStatus
        statusChangedTime
        standby
        time
        isNotActive
        messageSentTime
        messageSentError
        receivedAnnouncement
        rescued
        helperUpdatedDateTime
        totalStops
        totalPackages
        completedStops
        completedPackages
        undeliveredPackagesTotal
        undeliveredPackagesBusinessClose
        undeliveredPackagesUnableToAccess
        undeliveredPackagesOtherAWS
        pickUpReturnPackage
        additionalPackagesFromRescue
        splitWithRosterAssignment
        additionalPackagesFromSplit
        firstStopTime
        lastStopTime
        daWorkStartTime
        daWorkEndTime
        daRouteStartTime
        daRouteEndTime
        rtsTime
        lunchStartTime
        lunchEndTime
        inspectionFueled
        inspectionCleaned
        inspectionFlashers
        inspectionCreditCard
        inspectionKeys
        inspectionDeviceCharger
        inspectionDeviceBattery
        inspectionNotes
        requiredVehicleTypeString
        expectedDurationHrs
        lastBulkUploadDate
        updatedAt
        createdAt
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        dailyRoster {
          id
          dailyRosterAttachmentId
          group
          notesDate
          lastStandUpSentTime
          userId
          creationRoute
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        document {
          nextToken
          scannedCount
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        rescuer {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        helper {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        rosterChecklistSubjects {
          nextToken
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        status {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        helperStatus {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        rescuers {
          nextToken
          __typename
        }
        __typename
      }
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMessageReader = /* GraphQL */ `
  mutation CreateMessageReader(
    $input: CreateMessageReaderInput!
    $condition: ModelMessageReaderConditionInput
  ) {
    createMessageReader(input: $input, condition: $condition) {
      id
      userID
      messageID
      group
      createdAt
      updatedAt
      message {
        id
        senderId
        staffId
        userId
        contactId
        messageRouteId
        messageTenantId
        messageAttachmentId
        messageReplaceByRouteId
        carrierMessageId
        group
        createdAt
        deviceId
        messageType
        channelType
        destinationNumber
        deviceDestinationNumber
        destinationEmail
        subject
        bodyText
        bodyHtml
        senderName
        smsStatus
        smsSendInformation
        deviceSmsStatus
        deviceSmsSendInformation
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        sendbirdId
        isReadS
        sentBy
        sentAt
        linkExpiryDate
        attachmentLink
        contentType
        owner
        destinationName
        hasParts
        deviceAssociateId
        sendbirdTs
        rosterChecklistSubjectId
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        deviceAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubject {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        sender {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        isReadBy {
          nextToken
          __typename
        }
        __typename
      }
      readBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateMessageReader = /* GraphQL */ `
  mutation UpdateMessageReader(
    $input: UpdateMessageReaderInput!
    $condition: ModelMessageReaderConditionInput
  ) {
    updateMessageReader(input: $input, condition: $condition) {
      id
      userID
      messageID
      group
      createdAt
      updatedAt
      message {
        id
        senderId
        staffId
        userId
        contactId
        messageRouteId
        messageTenantId
        messageAttachmentId
        messageReplaceByRouteId
        carrierMessageId
        group
        createdAt
        deviceId
        messageType
        channelType
        destinationNumber
        deviceDestinationNumber
        destinationEmail
        subject
        bodyText
        bodyHtml
        senderName
        smsStatus
        smsSendInformation
        deviceSmsStatus
        deviceSmsSendInformation
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        sendbirdId
        isReadS
        sentBy
        sentAt
        linkExpiryDate
        attachmentLink
        contentType
        owner
        destinationName
        hasParts
        deviceAssociateId
        sendbirdTs
        rosterChecklistSubjectId
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        deviceAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubject {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        sender {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        isReadBy {
          nextToken
          __typename
        }
        __typename
      }
      readBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteMessageReader = /* GraphQL */ `
  mutation DeleteMessageReader(
    $input: DeleteMessageReaderInput!
    $condition: ModelMessageReaderConditionInput
  ) {
    deleteMessageReader(input: $input, condition: $condition) {
      id
      userID
      messageID
      group
      createdAt
      updatedAt
      message {
        id
        senderId
        staffId
        userId
        contactId
        messageRouteId
        messageTenantId
        messageAttachmentId
        messageReplaceByRouteId
        carrierMessageId
        group
        createdAt
        deviceId
        messageType
        channelType
        destinationNumber
        deviceDestinationNumber
        destinationEmail
        subject
        bodyText
        bodyHtml
        senderName
        smsStatus
        smsSendInformation
        deviceSmsStatus
        deviceSmsSendInformation
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        sendbirdId
        isReadS
        sentBy
        sentAt
        linkExpiryDate
        attachmentLink
        contentType
        owner
        destinationName
        hasParts
        deviceAssociateId
        sendbirdTs
        rosterChecklistSubjectId
        updatedAt
        attachment {
          id
          group
          createdAt
          s3Key
          expirationDate
          expirationTTL
          contentType
          fileSize
          updatedAt
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        replaceByRoute {
          id
          replaceByRouteStaffId
          replaceByRouteRouteId
          replaceByRouteStatusId
          replaceByRouteDeviceId
          replaceByRouteVehicleId
          replaceByRouteDailyRosterId
          replaceByRouteParkingSpaceId
          group
          notes
          createdAt
          routeNumber
          staging
          helperStatus
          isNotActive
          standby
          time
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          lastBulkUploadDate
          updatedAt
          __typename
        }
        route {
          id
          routeDailyRosterId
          routeDeviceId
          routeStaffId
          routeVehicleId
          routeRescuerId
          routeParkingSpaceId
          routeHelperId
          routeStatusId
          routeHelperStatusId
          group
          notes
          routeNumber
          staging
          previousStatus
          statusChangedTime
          standby
          time
          isNotActive
          messageSentTime
          messageSentError
          receivedAnnouncement
          rescued
          helperUpdatedDateTime
          totalStops
          totalPackages
          completedStops
          completedPackages
          undeliveredPackagesTotal
          undeliveredPackagesBusinessClose
          undeliveredPackagesUnableToAccess
          undeliveredPackagesOtherAWS
          pickUpReturnPackage
          additionalPackagesFromRescue
          splitWithRosterAssignment
          additionalPackagesFromSplit
          firstStopTime
          lastStopTime
          daWorkStartTime
          daWorkEndTime
          daRouteStartTime
          daRouteEndTime
          rtsTime
          lunchStartTime
          lunchEndTime
          inspectionFueled
          inspectionCleaned
          inspectionFlashers
          inspectionCreditCard
          inspectionKeys
          inspectionDeviceCharger
          inspectionDeviceBattery
          inspectionNotes
          requiredVehicleTypeString
          expectedDurationHrs
          lastBulkUploadDate
          updatedAt
          createdAt
          __typename
        }
        staff {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        deviceAssociate {
          id
          staffDefaultVehicleId
          staffDefaultVehicle2Id
          staffDefaultVehicle3Id
          group
          transporterId
          firstName
          lastName
          alternateNames
          phone
          email
          keyFocusArea
          coachingOpportunity
          status
          dlExpiration
          vehicleReport
          gasCardPin
          dob
          gender
          pronouns
          assignedLead
          isALead
          reportsToStaffId
          hourlyStatus
          hireDate
          terminationDate
          finalCheckIssueDate
          returnedUniform
          latestScorecard
          smsLastMessageTimestamp
          smsLastMessage
          vehicleType
          photo
          onboardingPinned
          netradyneDriverId
          heraScore
          heraRank
          prevHeraRank
          receiveTextMessages
          receiveTextMessagesChangeLog
          receiveEmailMessages
          receiveEmailMessagesChangeLog
          notes
          onboardingNotes
          customDeliveryVan
          authorizedLBS
          preferredDaysOff
          emailAddedToSuppressionListDateTime
          timesRescuerCounter
          timesRescuedCounter
          scoreCardsFantasticConsecutiveCounter
          scoreCardsFantasticCounter
          nickname
          overrideDisplayName
          displayName
          payrollProviderExternalId
          createdAt
          updatedAt
          __typename
        }
        rosterChecklistSubject {
          id
          notesDate
          group
          inactive
          staffId
          userId
          rosterChecklistId
          routeId
          replaceByRouteId
          dailyRosterId
          simpleItemsCompleted
          vehicleItemsCompleted
          flaggedAt
          flaggedByUserId
          itemsInProgressCounterCache
          itemsUnderReviewCounterCache
          itemsReviewedCounterCache
          status
          createdAt
          updatedAt
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        sender {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        user {
          id
          userTenantId
          group
          cognitoSub
          firstName
          lastName
          phone
          email
          notificationEmailAddress
          notificationSmsNumber
          receiveNotificationInApp
          receiveNotificationBySms
          receiveNotificationByEmail
          badgeCounterPreferences
          emailVerified
          role
          isCreator
          receiveSmsTaskReminders
          receiveEmailTaskReminders
          receiveSmsTaskAssignments
          receiveEmailTaskAssignments
          permissionLogin
          permissionFullAccess
          permissionDocuments
          permissionManageCounselings
          permissionDeleteCounselings
          permissionAccidents
          permissionInjuries
          permissionDrugTests
          permissionDailyRostering
          permissionMessenger
          permissionPerformanceCoaching
          permissionDAManagement
          permissionCustomLists
          permissionVehiclePhotoLogs
          permissionChecklistsAndVehiclePhotoLogs
          permissionManageLabels
          permissionVehicleManagement
          permissionTasksReports
          permissionMessageTemplate
          permissionCompanySettingsRosterChecklistTemplates
          permissionCompanyDevices
          permissionLocationDataFromCompanyDevices
          permissionCompanySettingsSchedulingRostering
          permissionVehicleImages
          permissionVehicleRelatedDocuments
          permissionOtherFiles
          permissionAmazonChromePlugin
          permissionAIChat
          permissionPhoneAutomation
          permissionPayrollProvider
          permissionInventoryManagement
          permissionVehiclePhotoLogsModule
          permissionVehiclePhotoLogReview
          reportsToUserId
          samePersonAsStaffId
          permissionDocumentsScope
          permissionManageCounselingsScope
          permissionAccidentsScope
          permissionInjuriesScope
          permissionDrugTestsScope
          permissionPerformanceCoachingScope
          permissionMessengerScope
          rolePermissionOverrides
          zohoCrmContactRecordId
          lastLogin
          emailAddedToSuppressionListDateTime
          createdAt
          updatedAt
          __typename
        }
        isReadBy {
          nextToken
          __typename
        }
        __typename
      }
      readBy {
        id
        userTenantId
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        notificationEmailAddress
        notificationSmsNumber
        receiveNotificationInApp
        receiveNotificationBySms
        receiveNotificationByEmail
        badgeCounterPreferences
        emailVerified
        role
        isCreator
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionManageCounselings
        permissionDeleteCounselings
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionDAManagement
        permissionCustomLists
        permissionVehiclePhotoLogs
        permissionChecklistsAndVehiclePhotoLogs
        permissionManageLabels
        permissionVehicleManagement
        permissionTasksReports
        permissionMessageTemplate
        permissionCompanySettingsRosterChecklistTemplates
        permissionCompanyDevices
        permissionLocationDataFromCompanyDevices
        permissionCompanySettingsSchedulingRostering
        permissionVehicleImages
        permissionVehicleRelatedDocuments
        permissionOtherFiles
        permissionAmazonChromePlugin
        permissionAIChat
        permissionPhoneAutomation
        permissionPayrollProvider
        permissionInventoryManagement
        permissionVehiclePhotoLogsModule
        permissionVehiclePhotoLogReview
        reportsToUserId
        samePersonAsStaffId
        permissionDocumentsScope
        permissionManageCounselingsScope
        permissionAccidentsScope
        permissionInjuriesScope
        permissionDrugTestsScope
        permissionPerformanceCoachingScope
        permissionMessengerScope
        rolePermissionOverrides
        zohoCrmContactRecordId
        lastLogin
        emailAddedToSuppressionListDateTime
        createdAt
        updatedAt
        accidentsVerified {
          nextToken
          scannedCount
          __typename
        }
        counseling {
          id
          counselingUserId
          counselingStaffId
          counselingSeverityId
          group
          date
          refusedToSign
          refusedByHeraUserId
          refusedToSignDateTime
          refusedByHeraUserExplanation
          signatureAcknowledge
          signature
          counselingNotes
          internalStaffNotes
          employeeNotes
          correctiveActionSummary
          priorDiscussionSummary
          consequencesOfFailure
          dateSent
          status
          scheduledToSendAt
          scheduledJobId
          dateSigned
          tenantId
          counselingTypeId
          createdFrom
          operationStatus
          createdAt
          updatedAt
          __typename
        }
        injuriesCompletedBy {
          nextToken
          __typename
        }
        messagesSent {
          nextToken
          __typename
        }
        resourcesUsage {
          nextToken
          __typename
        }
        assignerTasks {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        tenant {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        userNotification {
          nextToken
          __typename
        }
        subscribedDevices {
          nextToken
          __typename
        }
        completedReminders {
          nextToken
          __typename
        }
        messagesRead {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMessageReadStatus = /* GraphQL */ `
  mutation CreateMessageReadStatus(
    $input: CreateMessageReadStatusInput!
    $condition: ModelMessageReadStatusConditionInput
  ) {
    createMessageReadStatus(input: $input, condition: $condition) {
      id
      userID
      staffID
      deviceID
      group
      readUpToDateTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessageReadStatus = /* GraphQL */ `
  mutation UpdateMessageReadStatus(
    $input: UpdateMessageReadStatusInput!
    $condition: ModelMessageReadStatusConditionInput
  ) {
    updateMessageReadStatus(input: $input, condition: $condition) {
      id
      userID
      staffID
      deviceID
      group
      readUpToDateTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessageReadStatus = /* GraphQL */ `
  mutation DeleteMessageReadStatus(
    $input: DeleteMessageReadStatusInput!
    $condition: ModelMessageReadStatusConditionInput
  ) {
    deleteMessageReadStatus(input: $input, condition: $condition) {
      id
      userID
      staffID
      deviceID
      group
      readUpToDateTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPremiumStatusHistory = /* GraphQL */ `
  mutation CreatePremiumStatusHistory(
    $input: CreatePremiumStatusHistoryInput!
    $condition: ModelPremiumStatusHistoryConditionInput
  ) {
    createPremiumStatusHistory(input: $input, condition: $condition) {
      id
      premiumStatusHistoryTenantId
      group
      accountPremiumStatus
      changeNotes
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updatePremiumStatusHistory = /* GraphQL */ `
  mutation UpdatePremiumStatusHistory(
    $input: UpdatePremiumStatusHistoryInput!
    $condition: ModelPremiumStatusHistoryConditionInput
  ) {
    updatePremiumStatusHistory(input: $input, condition: $condition) {
      id
      premiumStatusHistoryTenantId
      group
      accountPremiumStatus
      changeNotes
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deletePremiumStatusHistory = /* GraphQL */ `
  mutation DeletePremiumStatusHistory(
    $input: DeletePremiumStatusHistoryInput!
    $condition: ModelPremiumStatusHistoryConditionInput
  ) {
    deletePremiumStatusHistory(input: $input, condition: $condition) {
      id
      premiumStatusHistoryTenantId
      group
      accountPremiumStatus
      changeNotes
      createdAt
      updatedAt
      tenant {
        id
        group
        createdAt
        companyName
        nameLog
        numberOfSeats
        logo
        accidentReport
        workmansComp
        dispatchNumber
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        zohoCrmAccountRecordId
        originationNumber
        timeZone
        locale
        trialExpDate
        firstInterestDateTime
        firstStartedTrialDateTime
        firstConvertedToPaidDateTime
        firstChurnedDateTime
        accountPremiumStatus
        accountCanceledNotes
        accountCanceledReason
        notes
        costStandard
        costBundle
        costPerformance
        costRostering
        costStaff
        costVehicles
        costMessaging
        discountPercent
        discountFixed
        discountPercentLabel
        discountFixedLabel
        payOutstandingByDate
        flatMonthlyBillingAmount
        flatMonthlyBillingLabel
        ownerUserId
        lastPaidPositiveInvoiceLineItemDateTime
        totalNumberOfMonthsPaidByTenant
        lifetimePaymentTotal
        averageMonthlyInvoiceTotal
        isTestingAccount
        calculatedOutstandingBalance
        bundleDeactivationAllowedAt
        performanceDeactivationAllowedAt
        rosteringDeactivationAllowedAt
        staffDeactivationAllowedAt
        vehiclesDeactivationAllowedAt
        automatedCoachingSendTime
        allowLibraryUpload
        coachingCustomMessage
        messageServiceProvider
        OriginationNumberOrderId
        OriginationNumberStatus
        customerStatus
        coachingFicoThresholdIssue
        coachingFicoThreshold
        coachingFicoThresholdPR
        coachingFicoThresholdKudo
        coachingFicoIssue
        coachingFicoCO
        coachingFicoPR
        coachingFicoKudo
        coachingDcrThresholdIssue
        coachingDcrThreshold
        coachingDcrThresholdPR
        coachingDcrThresholdKudo
        coachingDcrIssue
        coachingDcrCO
        coachingDcrPR
        coachingDcrKudo
        coachingDcDpmoThresholdIssue
        coachingDcDpmoThreshold
        coachingDcDpmoThresholdPR
        coachingDcDpmoThresholdKudo
        coachingDcDpmoIssue
        coachingDcDpmoCO
        coachingDcDpmoPR
        coachingDcDpmoKudo
        coachingDarThresholdIssue
        coachingDarThreshold
        coachingDarThresholdPR
        coachingDarThresholdKudo
        coachingDarIssue
        coachingDarCO
        coachingDarPR
        coachingDarKudo
        coachingDnrThresholdIssue
        coachingDnrThreshold
        coachingDnrThresholdPR
        coachingDnrThresholdKudo
        coachingDnrIssue
        coachingDnrCO
        coachingDnrPR
        coachingDnrKudo
        coachingDsbThresholdIssue
        coachingDsbThreshold
        coachingDsbThresholdPR
        coachingDsbThresholdKudo
        coachingDsbIssue
        coachingDsbCO
        coachingDsbPR
        coachingDsbKudo
        coachingSwcPodThresholdIssue
        coachingSwcPodThreshold
        coachingSwcPodThresholdKudo
        coachingSwcPodThresholdPR
        coachingSwcPodIssue
        coachingSwcPodCO
        coachingSwcPodPR
        coachingSwcPodKudo
        coachingSwcCcThresholdIssue
        coachingSwcCcThreshold
        coachingSwcCcThresholdKudo
        coachingSwcCcThresholdPR
        coachingSwcCcIssue
        coachingSwcCcCO
        coachingSwcCcPR
        coachingSwcCcKudo
        coachingSwcScThresholdIssue
        coachingSwcScThreshold
        coachingSwcScThresholdKudo
        coachingSwcScThresholdPR
        coachingSwcScIssue
        coachingSwcScCO
        coachingSwcScPR
        coachingSwcScKudo
        coachingSwcAdThresholdIssue
        coachingSwcAdThreshold
        coachingSwcAdThresholdKudo
        coachingSwcAdThresholdPR
        coachingSwcAdIssue
        coachingSwcAdCO
        coachingSwcAdPR
        coachingSwcAdKudo
        coachingSeatbeltOffThresholdIssue
        coachingSeatbeltOffThreshold
        coachingSeatbeltOffThresholdPR
        coachingSeatbeltOffThresholdKudo
        coachingSeatbeltOffIssue
        coachingSeatbeltOffCO
        coachingSeatbeltOffPR
        coachingSeatbeltOffKudo
        coachingSpeedingEventThresholdIssue
        coachingSpeedingEventThreshold
        coachingSpeedingEventThresholdPR
        coachingSpeedingEventThresholdKudo
        coachingSpeedingEventIssue
        coachingSpeedingEventCO
        coachingSpeedingEventPR
        coachingSpeedingEventKudo
        coachingDistractionsRateThresholdIssue
        coachingDistractionsRateThreshold
        coachingDistractionsRateThresholdPR
        coachingDistractionsRateThresholdKudo
        coachingDistractionsRateIssue
        coachingDistractionsRateCO
        coachingDistractionsRatePR
        coachingDistractionsRateKudo
        coachingFollowingDistanceRateThresholdIssue
        coachingFollowingDistanceRateThreshold
        coachingFollowingDistanceRateThresholdPR
        coachingFollowingDistanceRateThresholdKudo
        coachingFollowingDistanceRateIssue
        coachingFollowingDistanceRateCO
        coachingFollowingDistanceRatePR
        coachingFollowingDistanceRateKudo
        coachingSignSignalViolationsRateThresholdIssue
        coachingSignSignalViolationsRateThreshold
        coachingSignSignalViolationsRateThresholdPR
        coachingSignSignalViolationsRateThresholdKudo
        coachingSignSignalViolationsRateIssue
        coachingSignSignalViolationsRateCO
        coachingSignSignalViolationsRatePR
        coachingSignSignalViolationsRateKudo
        coachingOverallTierThresholdIssue
        coachingOverallTierThresholdKudo
        coachingOverallTierIssue
        coachingOverallTierKudo
        coachingOverallTierRatingIssue
        coachingOverallTierRatingKudo
        coachingConsecutiveTierThresholdIssue
        coachingConsecutiveTierThresholdKudo
        coachingConsecutiveTierIssue
        coachingConsecutiveTierKudo
        coachingConsecutiveTierRatingIssue
        coachingConsecutiveTierRatingKudo
        coachingPositiveFeedbackThresholdIssue
        coachingPositiveFeedbackThreshold
        coachingPositiveFeedbackThresholdPR
        coachingPositiveFeedbackThresholdKudo
        coachingPositiveFeedbackIssue
        coachingPositiveFeedbackCO
        coachingPositiveFeedbackPR
        coachingPositiveFeedbackKudo
        coachingDailyFicoThresholdIssue
        coachingDailyFicoThreshold
        coachingDailyFicoThresholdPR
        coachingDailyFicoThresholdKudo
        coachingDailyFicoIssue
        coachingDailyFicoCO
        coachingDailyFicoPR
        coachingDailyFicoKudo
        coachingSeatbeltThresholdIssue
        coachingSeatbeltThreshold
        coachingSeatbeltThresholdPR
        coachingSeatbeltThresholdKudo
        coachingSeatbeltIssue
        coachingSeatbeltCO
        coachingSeatbeltPR
        coachingSeatbeltKudo
        coachingSseIssue
        coachingSseCO
        coachingSsePR
        coachingSseKudo
        coachingSseThresholdIssue
        coachingSseThreshold
        coachingSseThresholdPR
        coachingSseThresholdKudo
        coachingDvcrsIssue
        coachingDvcrsCO
        coachingDvcrsPR
        coachingHarshBrakingRateThresholdIssue
        coachingHarshBrakingRateThreshold
        coachingHarshBrakingRateThresholdPR
        coachingHarshBrakingRateThresholdKudo
        coachingHarshBrakingRateIssue
        coachingHarshBrakingRateCO
        coachingHarshBrakingRatePR
        coachingHarshBrakingRateKudo
        coachingDaTierThresholdIssue
        coachingDaTierThresholdKudo
        coachingDaTierIssue
        coachingDaTierKudo
        coachingDaTierPR
        coachingDaTierCO
        coachingDaTierRatingIssue
        coachingDaTierRatingCO
        coachingDaTierRatingPR
        coachingDaTierRatingKudo
        coachingCdfScoreThresholdIssue
        coachingCdfScoreThreshold
        coachingCdfScoreThresholdPR
        coachingCdfScoreThresholdKudo
        coachingCdfScoreIssue
        coachingCdfScoreKudo
        coachingCdfScoreRatingIssue
        coachingCdfScoreCO
        coachingCdfScorePR
        coachingCdfScoreRatingKudo
        coachingCdfDpmoThresholdIssue
        coachingCdfDpmoThreshold
        coachingCdfDpmoThresholdPR
        coachingCdfDpmoThresholdKudo
        coachingCdfDpmoIssue
        coachingCdfDpmoKudo
        coachingCdfDpmoRatingIssue
        coachingCdfDpmoCO
        coachingCdfDpmoPR
        coachingCdfDpmoRatingKudo
        coachingHarshCorneringRateThresholdIssue
        coachingHarshCorneringRateThreshold
        coachingHarshCorneringRateThresholdPR
        coachingHarshCorneringRateThresholdKudo
        coachingHarshCorneringRateIssue
        coachingHarshCorneringRateCO
        coachingHarshCorneringRatePR
        coachingHarshCorneringRateKudo
        coachingPpsCompliancePercentThresholdIssue
        coachingPpsCompliancePercentThreshold
        coachingPpsCompliancePercentThresholdPR
        coachingPpsCompliancePercentThresholdKudo
        coachingPpsCompliancePercentIssue
        coachingPpsCompliancePercentCO
        coachingPpsCompliancePercentPR
        coachingPpsCompliancePercentKudo
        coachingPpsBreachesThresholdIssue
        coachingPpsBreachesThreshold
        coachingPpsBreachesThresholdPR
        coachingPpsBreachesThresholdKudo
        coachingPpsBreachesIssue
        coachingPpsBreachesCO
        coachingPpsBreachesPR
        coachingPpsBreachesKudo
        coachingDailyPpsCompliancePercentIssue
        coachingDailyPpsCompliancePercentThresholdIssue
        coachingDailyPpsCompliancePercentCO
        coachingDailyPpsCompliancePercentThreshold
        coachingDailyPpsCompliancePercentPR
        coachingDailyPpsCompliancePercentThresholdPR
        coachingDailyPpsCompliancePercentKudo
        coachingDailyPpsCompliancePercentThresholdKudo
        coachingDailyPpsMissingBrakeIssue
        coachingDailyPpsMissingBrakeThresholdIssue
        coachingDailyPpsMissingBrakeCO
        coachingDailyPpsMissingBrakeThreshold
        coachingDailyPpsMissingBrakePR
        coachingDailyPpsMissingBrakeThresholdPR
        coachingDailyPpsMissingBrakeKudo
        coachingDailyPpsMissingBrakeThresholdKudo
        coachingDailyPpsMissingGearIssue
        coachingDailyPpsMissingGearThresholdIssue
        coachingDailyPpsMissingGearCO
        coachingDailyPpsMissingGearThreshold
        coachingDailyPpsMissingGearPR
        coachingDailyPpsMissingGearThresholdPR
        coachingDailyPpsMissingGearKudo
        coachingDailyPpsMissingGearThresholdKudo
        coachingDailyComplianceRateThresholdIssue
        coachingDailyComplianceRateThreshold
        coachingDailyComplianceRateThresholdPR
        coachingDailyComplianceRateThresholdKudo
        coachingDailyComplianceRateIssue
        coachingDailyComplianceRateCO
        coachingDailyComplianceRatePR
        coachingDailyComplianceRateKudo
        coachingPsbThresholdIssue
        coachingPsbThreshold
        coachingPsbThresholdPR
        coachingPsbThresholdKudo
        coachingPsbIssue
        coachingPsbCO
        coachingPsbPR
        coachingPsbKudo
        coachingPsbRatingIssue
        coachingPsbRatingKudo
        coachingDaMishandledPackageIssue
        coachingDaMishandledPackageCO
        coachingDaMishandledPackageThresholdIssue
        coachingDaMishandledPackageThreshold
        coachingDaWasUnprofessionalIssue
        coachingDaWasUnprofessionalCO
        coachingDaWasUnprofessionalThresholdIssue
        coachingDaWasUnprofessionalThreshold
        coachingDaIgnoreInstructionsIssue
        coachingDaIgnoreInstructionsCO
        coachingDaIgnoreInstructionsThresholdIssue
        coachingDaIgnoreInstructionsThreshold
        coachingDeliveredToWrongAddressIssue
        coachingDeliveredToWrongAddressCO
        coachingDeliveredToWrongAddressThresholdIssue
        coachingDeliveredToWrongAddressThreshold
        coachingNeverReceivedDeliveryIssue
        coachingNeverReceivedDeliveryCO
        coachingNeverReceivedDeliveryThresholdIssue
        coachingNeverReceivedDeliveryThreshold
        coachingReceivedWrongItemIssue
        coachingReceivedWrongItemCO
        coachingReceivedWrongItemThresholdIssue
        coachingReceivedWrongItemThreshold
        coachingTraningRemainingIssue
        coachingTraningRemainingCO
        coachingTraningRemainingPR
        coachingCameraObstructionIssue
        coachingCameraObstructionCO
        coachingCameraObstructionThresholdIssue
        coachingCameraObstructionThreshold
        coachingDriverDistractionIssue
        coachingDriverDistractionCO
        coachingDriverDistractionThresholdIssue
        coachingDriverDistractionThreshold
        coachingDriverDrowsinessIssue
        coachingDriverDrowsinessCO
        coachingDriverDrowsinessThresholdIssue
        coachingDriverDrowsinessThreshold
        coachingDriverInitiatedIssue
        coachingDriverInitiatedCO
        coachingDriverInitiatedThresholdIssue
        coachingDriverInitiatedThreshold
        coachingDriverStarPR
        coachingDriverStarKudo
        coachingDriverStarThresholdPR
        coachingDriverStarThresholdKudo
        coachingFaceMaskComplianceIssue
        coachingFaceMaskComplianceCO
        coachingFaceMaskComplianceThresholdIssue
        coachingFaceMaskComplianceThreshold
        coachingFollowingDistanceIssue
        coachingFollowingDistanceCO
        coachingFollowingDistanceThresholdIssue
        coachingFollowingDistanceThreshold
        coachingHardAccelerationIssue
        coachingHardAccelerationCO
        coachingHardAccelerationThresholdIssue
        coachingHardAccelerationThreshold
        coachingHardBrakingIssue
        coachingHardBrakingCO
        coachingHardBrakingThresholdIssue
        coachingHardBrakingThreshold
        coachingHardTurnIssue
        coachingHardTurnCO
        coachingHardTurnThresholdIssue
        coachingHardTurnThreshold
        coachingHighGIssue
        coachingHighGCO
        coachingHighGThresholdIssue
        coachingHighGThreshold
        coachingLowImpactIssue
        coachingLowImpactCO
        coachingLowImpactThresholdIssue
        coachingLowImpactThreshold
        coachingSeatbeltComplianceIssue
        coachingSeatbeltComplianceCO
        coachingSeatbeltComplianceThresholdIssue
        coachingSeatbeltComplianceThreshold
        coachingSignViolationsIssue
        coachingSignViolationsCO
        coachingSignViolationsThresholdIssue
        coachingSignViolationsThreshold
        coachingSpeedingViolationsIssue
        coachingSpeedingViolationsCO
        coachingSpeedingViolationsThresholdIssue
        coachingSpeedingViolationsThreshold
        coachingTrafficLightViolationIssue
        coachingTrafficLightViolationCO
        coachingTrafficLightViolationThresholdIssue
        coachingTrafficLightViolationThreshold
        coachingUTurnIssue
        coachingUTurnCO
        coachingUTurnThresholdIssue
        coachingUTurnThreshold
        coachingWeavingIssue
        coachingWeavingCO
        coachingWeavingThresholdIssue
        coachingWeavingThreshold
        coachingDriverRankRange
        usesXLcoaching
        shortCode
        growSurfParticipantId
        growSurfReferrerEmail
        growSurfReferrerFullName
        growSurfReferredEmail
        growSurfReferredFullName
        growSurfReferralComplete
        growSurfReferredByEmailBackup
        growSurfReferredByFullNameBackup
        growSurfParticipantEmail
        growSurfParticipantFullName
        growSurfParticipantReferralComplete
        stripeCustomerId
        stripeBillingEmail
        driverReportDayRange
        permissionHeraAi
        permissionVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogsHeraAi
        featureEnabledVehiclePhotoLogsHeraAi
        featureAccessVehiclePhotoLogReview
        featureEnabledVehiclePhotoLogReview
        featureEnabledInventoryManagement
        featureAccessInventoryManagement
        permissionInventoryManagement
        featureAccessSchedulingAndRostering
        featureEnabledSchedulingAndRostering
        permissionSchedulingAndRostering
        featureAccessRosterChecklist
        featureEnabledRosterChecklist
        permissionRosterChecklist
        featureAccessCounselings
        featureEnabledCounselings
        permissionCounselings
        featureAccessAssociateApp
        featureEnabledAssociateApp
        permissionAssociateApp
        featureAccessCustomEmailSending
        featureEnabledCustomEmailSending
        featureAccessHeraMessenger2
        featureEnabledHeraMessenger2
        permissionHeraMessenger2
        featureAccessPhoneAutomation
        featureEnabledPhoneAutomation
        permissionPhoneAutomation
        featureAccessWirelessSupportSync
        featureEnabledWirelessSupportSync
        permissionWirelessSupportSync
        featureAccessFilesManagement
        featureEnabledFilesManagement
        featureAccessFilesSignatureRequest
        featureEnabledFilesSignatureRequest
        featureAccessAIChat
        featureEnabledAIChat
        permissionAIChat
        featureAccessAmazonChromePlugin
        featureEnabledAmazonChromePlugin
        permissionAmazonChromePlugin
        featureAccessHierarchicalPermissions
        featureEnabledHierarchicalPermissions
        permissionHierarchicalPermissions
        payrollProvider
        customerCheckedUserRolesDateTime
        featureAccessPayrollProvider
        featureEnabledPayrollProvider
        permissionPayrollProvider
        accountType
        customerType
        customerSubType
        accountCountry
        isTemporaryAccount
        allowParentData
        parentAccountId
        isTemplate
        templateTenantId
        miradoreApiKey
        miradoreSiteName
        odometerReadingMaxThreshold
        defaultCommunicationChannels
        companyScoreCardsByYearWeek {
          nextToken
          __typename
        }
        textractjobs {
          nextToken
          __typename
        }
        updatedAt
        invoices {
          nextToken
          __typename
        }
        messages {
          nextToken
          __typename
        }
        parentAccount {
          id
          group
          createdAt
          companyName
          nameLog
          numberOfSeats
          logo
          accidentReport
          workmansComp
          dispatchNumber
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZip
          zohoCrmAccountRecordId
          originationNumber
          timeZone
          locale
          trialExpDate
          firstInterestDateTime
          firstStartedTrialDateTime
          firstConvertedToPaidDateTime
          firstChurnedDateTime
          accountPremiumStatus
          accountCanceledNotes
          accountCanceledReason
          notes
          costStandard
          costBundle
          costPerformance
          costRostering
          costStaff
          costVehicles
          costMessaging
          discountPercent
          discountFixed
          discountPercentLabel
          discountFixedLabel
          payOutstandingByDate
          flatMonthlyBillingAmount
          flatMonthlyBillingLabel
          ownerUserId
          lastPaidPositiveInvoiceLineItemDateTime
          totalNumberOfMonthsPaidByTenant
          lifetimePaymentTotal
          averageMonthlyInvoiceTotal
          isTestingAccount
          calculatedOutstandingBalance
          bundleDeactivationAllowedAt
          performanceDeactivationAllowedAt
          rosteringDeactivationAllowedAt
          staffDeactivationAllowedAt
          vehiclesDeactivationAllowedAt
          automatedCoachingSendTime
          allowLibraryUpload
          coachingCustomMessage
          messageServiceProvider
          OriginationNumberOrderId
          OriginationNumberStatus
          customerStatus
          coachingFicoThresholdIssue
          coachingFicoThreshold
          coachingFicoThresholdPR
          coachingFicoThresholdKudo
          coachingFicoIssue
          coachingFicoCO
          coachingFicoPR
          coachingFicoKudo
          coachingDcrThresholdIssue
          coachingDcrThreshold
          coachingDcrThresholdPR
          coachingDcrThresholdKudo
          coachingDcrIssue
          coachingDcrCO
          coachingDcrPR
          coachingDcrKudo
          coachingDcDpmoThresholdIssue
          coachingDcDpmoThreshold
          coachingDcDpmoThresholdPR
          coachingDcDpmoThresholdKudo
          coachingDcDpmoIssue
          coachingDcDpmoCO
          coachingDcDpmoPR
          coachingDcDpmoKudo
          coachingDarThresholdIssue
          coachingDarThreshold
          coachingDarThresholdPR
          coachingDarThresholdKudo
          coachingDarIssue
          coachingDarCO
          coachingDarPR
          coachingDarKudo
          coachingDnrThresholdIssue
          coachingDnrThreshold
          coachingDnrThresholdPR
          coachingDnrThresholdKudo
          coachingDnrIssue
          coachingDnrCO
          coachingDnrPR
          coachingDnrKudo
          coachingDsbThresholdIssue
          coachingDsbThreshold
          coachingDsbThresholdPR
          coachingDsbThresholdKudo
          coachingDsbIssue
          coachingDsbCO
          coachingDsbPR
          coachingDsbKudo
          coachingSwcPodThresholdIssue
          coachingSwcPodThreshold
          coachingSwcPodThresholdKudo
          coachingSwcPodThresholdPR
          coachingSwcPodIssue
          coachingSwcPodCO
          coachingSwcPodPR
          coachingSwcPodKudo
          coachingSwcCcThresholdIssue
          coachingSwcCcThreshold
          coachingSwcCcThresholdKudo
          coachingSwcCcThresholdPR
          coachingSwcCcIssue
          coachingSwcCcCO
          coachingSwcCcPR
          coachingSwcCcKudo
          coachingSwcScThresholdIssue
          coachingSwcScThreshold
          coachingSwcScThresholdKudo
          coachingSwcScThresholdPR
          coachingSwcScIssue
          coachingSwcScCO
          coachingSwcScPR
          coachingSwcScKudo
          coachingSwcAdThresholdIssue
          coachingSwcAdThreshold
          coachingSwcAdThresholdKudo
          coachingSwcAdThresholdPR
          coachingSwcAdIssue
          coachingSwcAdCO
          coachingSwcAdPR
          coachingSwcAdKudo
          coachingSeatbeltOffThresholdIssue
          coachingSeatbeltOffThreshold
          coachingSeatbeltOffThresholdPR
          coachingSeatbeltOffThresholdKudo
          coachingSeatbeltOffIssue
          coachingSeatbeltOffCO
          coachingSeatbeltOffPR
          coachingSeatbeltOffKudo
          coachingSpeedingEventThresholdIssue
          coachingSpeedingEventThreshold
          coachingSpeedingEventThresholdPR
          coachingSpeedingEventThresholdKudo
          coachingSpeedingEventIssue
          coachingSpeedingEventCO
          coachingSpeedingEventPR
          coachingSpeedingEventKudo
          coachingDistractionsRateThresholdIssue
          coachingDistractionsRateThreshold
          coachingDistractionsRateThresholdPR
          coachingDistractionsRateThresholdKudo
          coachingDistractionsRateIssue
          coachingDistractionsRateCO
          coachingDistractionsRatePR
          coachingDistractionsRateKudo
          coachingFollowingDistanceRateThresholdIssue
          coachingFollowingDistanceRateThreshold
          coachingFollowingDistanceRateThresholdPR
          coachingFollowingDistanceRateThresholdKudo
          coachingFollowingDistanceRateIssue
          coachingFollowingDistanceRateCO
          coachingFollowingDistanceRatePR
          coachingFollowingDistanceRateKudo
          coachingSignSignalViolationsRateThresholdIssue
          coachingSignSignalViolationsRateThreshold
          coachingSignSignalViolationsRateThresholdPR
          coachingSignSignalViolationsRateThresholdKudo
          coachingSignSignalViolationsRateIssue
          coachingSignSignalViolationsRateCO
          coachingSignSignalViolationsRatePR
          coachingSignSignalViolationsRateKudo
          coachingOverallTierThresholdIssue
          coachingOverallTierThresholdKudo
          coachingOverallTierIssue
          coachingOverallTierKudo
          coachingOverallTierRatingIssue
          coachingOverallTierRatingKudo
          coachingConsecutiveTierThresholdIssue
          coachingConsecutiveTierThresholdKudo
          coachingConsecutiveTierIssue
          coachingConsecutiveTierKudo
          coachingConsecutiveTierRatingIssue
          coachingConsecutiveTierRatingKudo
          coachingPositiveFeedbackThresholdIssue
          coachingPositiveFeedbackThreshold
          coachingPositiveFeedbackThresholdPR
          coachingPositiveFeedbackThresholdKudo
          coachingPositiveFeedbackIssue
          coachingPositiveFeedbackCO
          coachingPositiveFeedbackPR
          coachingPositiveFeedbackKudo
          coachingDailyFicoThresholdIssue
          coachingDailyFicoThreshold
          coachingDailyFicoThresholdPR
          coachingDailyFicoThresholdKudo
          coachingDailyFicoIssue
          coachingDailyFicoCO
          coachingDailyFicoPR
          coachingDailyFicoKudo
          coachingSeatbeltThresholdIssue
          coachingSeatbeltThreshold
          coachingSeatbeltThresholdPR
          coachingSeatbeltThresholdKudo
          coachingSeatbeltIssue
          coachingSeatbeltCO
          coachingSeatbeltPR
          coachingSeatbeltKudo
          coachingSseIssue
          coachingSseCO
          coachingSsePR
          coachingSseKudo
          coachingSseThresholdIssue
          coachingSseThreshold
          coachingSseThresholdPR
          coachingSseThresholdKudo
          coachingDvcrsIssue
          coachingDvcrsCO
          coachingDvcrsPR
          coachingHarshBrakingRateThresholdIssue
          coachingHarshBrakingRateThreshold
          coachingHarshBrakingRateThresholdPR
          coachingHarshBrakingRateThresholdKudo
          coachingHarshBrakingRateIssue
          coachingHarshBrakingRateCO
          coachingHarshBrakingRatePR
          coachingHarshBrakingRateKudo
          coachingDaTierThresholdIssue
          coachingDaTierThresholdKudo
          coachingDaTierIssue
          coachingDaTierKudo
          coachingDaTierPR
          coachingDaTierCO
          coachingDaTierRatingIssue
          coachingDaTierRatingCO
          coachingDaTierRatingPR
          coachingDaTierRatingKudo
          coachingCdfScoreThresholdIssue
          coachingCdfScoreThreshold
          coachingCdfScoreThresholdPR
          coachingCdfScoreThresholdKudo
          coachingCdfScoreIssue
          coachingCdfScoreKudo
          coachingCdfScoreRatingIssue
          coachingCdfScoreCO
          coachingCdfScorePR
          coachingCdfScoreRatingKudo
          coachingCdfDpmoThresholdIssue
          coachingCdfDpmoThreshold
          coachingCdfDpmoThresholdPR
          coachingCdfDpmoThresholdKudo
          coachingCdfDpmoIssue
          coachingCdfDpmoKudo
          coachingCdfDpmoRatingIssue
          coachingCdfDpmoCO
          coachingCdfDpmoPR
          coachingCdfDpmoRatingKudo
          coachingHarshCorneringRateThresholdIssue
          coachingHarshCorneringRateThreshold
          coachingHarshCorneringRateThresholdPR
          coachingHarshCorneringRateThresholdKudo
          coachingHarshCorneringRateIssue
          coachingHarshCorneringRateCO
          coachingHarshCorneringRatePR
          coachingHarshCorneringRateKudo
          coachingPpsCompliancePercentThresholdIssue
          coachingPpsCompliancePercentThreshold
          coachingPpsCompliancePercentThresholdPR
          coachingPpsCompliancePercentThresholdKudo
          coachingPpsCompliancePercentIssue
          coachingPpsCompliancePercentCO
          coachingPpsCompliancePercentPR
          coachingPpsCompliancePercentKudo
          coachingPpsBreachesThresholdIssue
          coachingPpsBreachesThreshold
          coachingPpsBreachesThresholdPR
          coachingPpsBreachesThresholdKudo
          coachingPpsBreachesIssue
          coachingPpsBreachesCO
          coachingPpsBreachesPR
          coachingPpsBreachesKudo
          coachingDailyPpsCompliancePercentIssue
          coachingDailyPpsCompliancePercentThresholdIssue
          coachingDailyPpsCompliancePercentCO
          coachingDailyPpsCompliancePercentThreshold
          coachingDailyPpsCompliancePercentPR
          coachingDailyPpsCompliancePercentThresholdPR
          coachingDailyPpsCompliancePercentKudo
          coachingDailyPpsCompliancePercentThresholdKudo
          coachingDailyPpsMissingBrakeIssue
          coachingDailyPpsMissingBrakeThresholdIssue
          coachingDailyPpsMissingBrakeCO
          coachingDailyPpsMissingBrakeThreshold
          coachingDailyPpsMissingBrakePR
          coachingDailyPpsMissingBrakeThresholdPR
          coachingDailyPpsMissingBrakeKudo
          coachingDailyPpsMissingBrakeThresholdKudo
          coachingDailyPpsMissingGearIssue
          coachingDailyPpsMissingGearThresholdIssue
          coachingDailyPpsMissingGearCO
          coachingDailyPpsMissingGearThreshold
          coachingDailyPpsMissingGearPR
          coachingDailyPpsMissingGearThresholdPR
          coachingDailyPpsMissingGearKudo
          coachingDailyPpsMissingGearThresholdKudo
          coachingDailyComplianceRateThresholdIssue
          coachingDailyComplianceRateThreshold
          coachingDailyComplianceRateThresholdPR
          coachingDailyComplianceRateThresholdKudo
          coachingDailyComplianceRateIssue
          coachingDailyComplianceRateCO
          coachingDailyComplianceRatePR
          coachingDailyComplianceRateKudo
          coachingPsbThresholdIssue
          coachingPsbThreshold
          coachingPsbThresholdPR
          coachingPsbThresholdKudo
          coachingPsbIssue
          coachingPsbCO
          coachingPsbPR
          coachingPsbKudo
          coachingPsbRatingIssue
          coachingPsbRatingKudo
          coachingDaMishandledPackageIssue
          coachingDaMishandledPackageCO
          coachingDaMishandledPackageThresholdIssue
          coachingDaMishandledPackageThreshold
          coachingDaWasUnprofessionalIssue
          coachingDaWasUnprofessionalCO
          coachingDaWasUnprofessionalThresholdIssue
          coachingDaWasUnprofessionalThreshold
          coachingDaIgnoreInstructionsIssue
          coachingDaIgnoreInstructionsCO
          coachingDaIgnoreInstructionsThresholdIssue
          coachingDaIgnoreInstructionsThreshold
          coachingDeliveredToWrongAddressIssue
          coachingDeliveredToWrongAddressCO
          coachingDeliveredToWrongAddressThresholdIssue
          coachingDeliveredToWrongAddressThreshold
          coachingNeverReceivedDeliveryIssue
          coachingNeverReceivedDeliveryCO
          coachingNeverReceivedDeliveryThresholdIssue
          coachingNeverReceivedDeliveryThreshold
          coachingReceivedWrongItemIssue
          coachingReceivedWrongItemCO
          coachingReceivedWrongItemThresholdIssue
          coachingReceivedWrongItemThreshold
          coachingTraningRemainingIssue
          coachingTraningRemainingCO
          coachingTraningRemainingPR
          coachingCameraObstructionIssue
          coachingCameraObstructionCO
          coachingCameraObstructionThresholdIssue
          coachingCameraObstructionThreshold
          coachingDriverDistractionIssue
          coachingDriverDistractionCO
          coachingDriverDistractionThresholdIssue
          coachingDriverDistractionThreshold
          coachingDriverDrowsinessIssue
          coachingDriverDrowsinessCO
          coachingDriverDrowsinessThresholdIssue
          coachingDriverDrowsinessThreshold
          coachingDriverInitiatedIssue
          coachingDriverInitiatedCO
          coachingDriverInitiatedThresholdIssue
          coachingDriverInitiatedThreshold
          coachingDriverStarPR
          coachingDriverStarKudo
          coachingDriverStarThresholdPR
          coachingDriverStarThresholdKudo
          coachingFaceMaskComplianceIssue
          coachingFaceMaskComplianceCO
          coachingFaceMaskComplianceThresholdIssue
          coachingFaceMaskComplianceThreshold
          coachingFollowingDistanceIssue
          coachingFollowingDistanceCO
          coachingFollowingDistanceThresholdIssue
          coachingFollowingDistanceThreshold
          coachingHardAccelerationIssue
          coachingHardAccelerationCO
          coachingHardAccelerationThresholdIssue
          coachingHardAccelerationThreshold
          coachingHardBrakingIssue
          coachingHardBrakingCO
          coachingHardBrakingThresholdIssue
          coachingHardBrakingThreshold
          coachingHardTurnIssue
          coachingHardTurnCO
          coachingHardTurnThresholdIssue
          coachingHardTurnThreshold
          coachingHighGIssue
          coachingHighGCO
          coachingHighGThresholdIssue
          coachingHighGThreshold
          coachingLowImpactIssue
          coachingLowImpactCO
          coachingLowImpactThresholdIssue
          coachingLowImpactThreshold
          coachingSeatbeltComplianceIssue
          coachingSeatbeltComplianceCO
          coachingSeatbeltComplianceThresholdIssue
          coachingSeatbeltComplianceThreshold
          coachingSignViolationsIssue
          coachingSignViolationsCO
          coachingSignViolationsThresholdIssue
          coachingSignViolationsThreshold
          coachingSpeedingViolationsIssue
          coachingSpeedingViolationsCO
          coachingSpeedingViolationsThresholdIssue
          coachingSpeedingViolationsThreshold
          coachingTrafficLightViolationIssue
          coachingTrafficLightViolationCO
          coachingTrafficLightViolationThresholdIssue
          coachingTrafficLightViolationThreshold
          coachingUTurnIssue
          coachingUTurnCO
          coachingUTurnThresholdIssue
          coachingUTurnThreshold
          coachingWeavingIssue
          coachingWeavingCO
          coachingWeavingThresholdIssue
          coachingWeavingThreshold
          coachingDriverRankRange
          usesXLcoaching
          shortCode
          growSurfParticipantId
          growSurfReferrerEmail
          growSurfReferrerFullName
          growSurfReferredEmail
          growSurfReferredFullName
          growSurfReferralComplete
          growSurfReferredByEmailBackup
          growSurfReferredByFullNameBackup
          growSurfParticipantEmail
          growSurfParticipantFullName
          growSurfParticipantReferralComplete
          stripeCustomerId
          stripeBillingEmail
          driverReportDayRange
          permissionHeraAi
          permissionVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogsHeraAi
          featureEnabledVehiclePhotoLogsHeraAi
          featureAccessVehiclePhotoLogReview
          featureEnabledVehiclePhotoLogReview
          featureEnabledInventoryManagement
          featureAccessInventoryManagement
          permissionInventoryManagement
          featureAccessSchedulingAndRostering
          featureEnabledSchedulingAndRostering
          permissionSchedulingAndRostering
          featureAccessRosterChecklist
          featureEnabledRosterChecklist
          permissionRosterChecklist
          featureAccessCounselings
          featureEnabledCounselings
          permissionCounselings
          featureAccessAssociateApp
          featureEnabledAssociateApp
          permissionAssociateApp
          featureAccessCustomEmailSending
          featureEnabledCustomEmailSending
          featureAccessHeraMessenger2
          featureEnabledHeraMessenger2
          permissionHeraMessenger2
          featureAccessPhoneAutomation
          featureEnabledPhoneAutomation
          permissionPhoneAutomation
          featureAccessWirelessSupportSync
          featureEnabledWirelessSupportSync
          permissionWirelessSupportSync
          featureAccessFilesManagement
          featureEnabledFilesManagement
          featureAccessFilesSignatureRequest
          featureEnabledFilesSignatureRequest
          featureAccessAIChat
          featureEnabledAIChat
          permissionAIChat
          featureAccessAmazonChromePlugin
          featureEnabledAmazonChromePlugin
          permissionAmazonChromePlugin
          featureAccessHierarchicalPermissions
          featureEnabledHierarchicalPermissions
          permissionHierarchicalPermissions
          payrollProvider
          customerCheckedUserRolesDateTime
          featureAccessPayrollProvider
          featureEnabledPayrollProvider
          permissionPayrollProvider
          accountType
          customerType
          customerSubType
          accountCountry
          isTemporaryAccount
          allowParentData
          parentAccountId
          isTemplate
          templateTenantId
          miradoreApiKey
          miradoreSiteName
          odometerReadingMaxThreshold
          defaultCommunicationChannels
          updatedAt
          __typename
        }
        users {
          nextToken
          __typename
        }
        valueLists {
          nextToken
          __typename
        }
        premiumStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createMessageServiceProvider = /* GraphQL */ `
  mutation CreateMessageServiceProvider(
    $input: CreateMessageServiceProviderInput!
    $condition: ModelMessageServiceProviderConditionInput
  ) {
    createMessageServiceProvider(input: $input, condition: $condition) {
      id
      messageServiceProviderTenantId
      group
      date
      previousMessageServicerProvider
      currentMessageServicerProvider
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessageServiceProvider = /* GraphQL */ `
  mutation UpdateMessageServiceProvider(
    $input: UpdateMessageServiceProviderInput!
    $condition: ModelMessageServiceProviderConditionInput
  ) {
    updateMessageServiceProvider(input: $input, condition: $condition) {
      id
      messageServiceProviderTenantId
      group
      date
      previousMessageServicerProvider
      currentMessageServicerProvider
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessageServiceProvider = /* GraphQL */ `
  mutation DeleteMessageServiceProvider(
    $input: DeleteMessageServiceProviderInput!
    $condition: ModelMessageServiceProviderConditionInput
  ) {
    deleteMessageServiceProvider(input: $input, condition: $condition) {
      id
      messageServiceProviderTenantId
      group
      date
      previousMessageServicerProvider
      currentMessageServicerProvider
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTelnyx = /* GraphQL */ `
  mutation CreateTelnyx(
    $input: CreateTelnyxInput!
    $condition: ModelTelnyxConditionInput
  ) {
    createTelnyx(input: $input, condition: $condition) {
      id
      group
      phoneNumber
      telnyxId
      status
      date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTelnyx = /* GraphQL */ `
  mutation UpdateTelnyx(
    $input: UpdateTelnyxInput!
    $condition: ModelTelnyxConditionInput
  ) {
    updateTelnyx(input: $input, condition: $condition) {
      id
      group
      phoneNumber
      telnyxId
      status
      date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTelnyx = /* GraphQL */ `
  mutation DeleteTelnyx(
    $input: DeleteTelnyxInput!
    $condition: ModelTelnyxConditionInput
  ) {
    deleteTelnyx(input: $input, condition: $condition) {
      id
      group
      phoneNumber
      telnyxId
      status
      date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAuditLog = /* GraphQL */ `
  mutation CreateAuditLog(
    $input: CreateAuditLogInput!
    $condition: ModelAuditLogConditionInput
  ) {
    createAuditLog(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      mutatedDataDiff
      createdAt
      ipAddress
      ttl
      pageUrl
      logRocketSessionUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const updateAuditLog = /* GraphQL */ `
  mutation UpdateAuditLog(
    $input: UpdateAuditLogInput!
    $condition: ModelAuditLogConditionInput
  ) {
    updateAuditLog(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      mutatedDataDiff
      createdAt
      ipAddress
      ttl
      pageUrl
      logRocketSessionUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const deleteAuditLog = /* GraphQL */ `
  mutation DeleteAuditLog(
    $input: DeleteAuditLogInput!
    $condition: ModelAuditLogConditionInput
  ) {
    deleteAuditLog(input: $input, condition: $condition) {
      id
      tenantID
      group
      email
      userID
      cognitoSub
      firstName
      lastName
      tenantName
      mutationName
      mutationNameText
      mutatedRecordId
      mutatedData
      mutatedDataDiff
      createdAt
      ipAddress
      ttl
      pageUrl
      logRocketSessionUrl
      userType
      updatedAt
      __typename
    }
  }
`;
export const createProperParkingSequenceSummary = /* GraphQL */ `
  mutation CreateProperParkingSequenceSummary(
    $input: CreateProperParkingSequenceSummaryInput!
    $condition: ModelProperParkingSequenceSummaryConditionInput
  ) {
    createProperParkingSequenceSummary(input: $input, condition: $condition) {
      id
      properParkingSequenceSummaryTextractJobId
      group
      week
      year
      yearWeek
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProperParkingSequenceSummary = /* GraphQL */ `
  mutation UpdateProperParkingSequenceSummary(
    $input: UpdateProperParkingSequenceSummaryInput!
    $condition: ModelProperParkingSequenceSummaryConditionInput
  ) {
    updateProperParkingSequenceSummary(input: $input, condition: $condition) {
      id
      properParkingSequenceSummaryTextractJobId
      group
      week
      year
      yearWeek
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProperParkingSequenceSummary = /* GraphQL */ `
  mutation DeleteProperParkingSequenceSummary(
    $input: DeleteProperParkingSequenceSummaryInput!
    $condition: ModelProperParkingSequenceSummaryConditionInput
  ) {
    deleteProperParkingSequenceSummary(input: $input, condition: $condition) {
      id
      properParkingSequenceSummaryTextractJobId
      group
      week
      year
      yearWeek
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProperParkingSequence = /* GraphQL */ `
  mutation CreateProperParkingSequence(
    $input: CreateProperParkingSequenceInput!
    $condition: ModelProperParkingSequenceConditionInput
  ) {
    createProperParkingSequence(input: $input, condition: $condition) {
      id
      properParkingSequenceStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      date
      employeeName
      transporterId
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateProperParkingSequence = /* GraphQL */ `
  mutation UpdateProperParkingSequence(
    $input: UpdateProperParkingSequenceInput!
    $condition: ModelProperParkingSequenceConditionInput
  ) {
    updateProperParkingSequence(input: $input, condition: $condition) {
      id
      properParkingSequenceStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      date
      employeeName
      transporterId
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteProperParkingSequence = /* GraphQL */ `
  mutation DeleteProperParkingSequence(
    $input: DeleteProperParkingSequenceInput!
    $condition: ModelProperParkingSequenceConditionInput
  ) {
    deleteProperParkingSequence(input: $input, condition: $condition) {
      id
      properParkingSequenceStaffId
      group
      matched
      matchedS
      messageHasBeenSent
      week
      year
      date
      employeeName
      transporterId
      evaluatedStops
      compliance
      percentCompliance
      invalid
      percentInvalid
      missingGearInPark
      percentMissingGearInPark
      missingParkingBrake
      percentMissingParkingBrake
      totalBreaches
      percentTotalBreaches
      createdAt
      updatedAt
      staff {
        id
        staffDefaultVehicleId
        staffDefaultVehicle2Id
        staffDefaultVehicle3Id
        group
        transporterId
        firstName
        lastName
        alternateNames
        phone
        email
        keyFocusArea
        coachingOpportunity
        status
        dlExpiration
        vehicleReport
        gasCardPin
        dob
        gender
        pronouns
        assignedLead
        isALead
        reportsToStaffId
        hourlyStatus
        hireDate
        terminationDate
        finalCheckIssueDate
        returnedUniform
        latestScorecard
        smsLastMessageTimestamp
        smsLastMessage
        vehicleType
        photo
        onboardingPinned
        netradyneDriverId
        heraScore
        heraRank
        prevHeraRank
        receiveTextMessages
        receiveTextMessagesChangeLog
        receiveEmailMessages
        receiveEmailMessagesChangeLog
        notes
        onboardingNotes
        customDeliveryVan
        authorizedLBS
        preferredDaysOff
        emailAddedToSuppressionListDateTime
        timesRescuerCounter
        timesRescuedCounter
        scoreCardsFantasticConsecutiveCounter
        scoreCardsFantasticCounter
        nickname
        overrideDisplayName
        displayName
        payrollProviderExternalId
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        eocScores {
          nextToken
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        drugTests {
          nextToken
          __typename
        }
        infractions {
          nextToken
          scannedCount
          __typename
        }
        injuries {
          nextToken
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        messages {
          nextToken
          __typename
        }
        deviceAssociateMessages {
          nextToken
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        onBoarding {
          nextToken
          __typename
        }
        physicals {
          nextToken
          __typename
        }
        podQualities {
          nextToken
          __typename
        }
        replaceByRoute {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        routeHelper {
          nextToken
          scannedCount
          __typename
        }
        routeRescuer {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        messagePreferencesHistory {
          nextToken
          __typename
        }
        cxFeedback {
          nextToken
          __typename
        }
        mentor {
          nextToken
          __typename
        }
        netrdadyneAlerts {
          nextToken
          __typename
        }
        scoreCards {
          nextToken
          __typename
        }
        staffStatusHistory {
          nextToken
          __typename
        }
        routeStatusHistory {
          nextToken
          __typename
        }
        assigneeTasks {
          nextToken
          __typename
        }
        authorizedToDrive {
          nextToken
          scannedCount
          __typename
        }
        uniforms {
          nextToken
          __typename
        }
        defaultVehicle {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle2 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        defaultVehicle3 {
          id
          vehicleDeviceId
          vehicleDevice2Id
          vehicleCompanyId
          vehicleParkingSpaceId
          vehicleVehicleTypeId
          group
          name
          vehicle
          type
          state
          licensePlateExp
          dateStart
          dateEnd
          ownership
          provider
          otherProvider
          category
          vin
          make
          model
          year
          rentalAgreementNumber
          images
          rentalContracts
          accidentReports
          licensePlate
          mileage
          gasCard
          status
          statusReason
          notes
          lastOdometerReadingDate
          overTenThousandPounds
          customDeliveryVan
          tollPassId
          assignedDeviceName
          createdAt
          updatedAt
          __typename
        }
        routeRescuerStaff {
          nextToken
          __typename
        }
        messageReadStatus {
          nextToken
          __typename
        }
        properParkingSequences {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createVehicleExpirationDates = /* GraphQL */ `
  mutation CreateVehicleExpirationDates(
    $input: CreateVehicleExpirationDatesInput!
    $condition: ModelVehicleExpirationDatesConditionInput
  ) {
    createVehicleExpirationDates(input: $input, condition: $condition) {
      id
      vehicleExpirationDatesVehicleId
      vehicleExpirationDatesTypeId
      group
      vehicleId
      dueDate
      createdAt
      updatedAt
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateVehicleExpirationDates = /* GraphQL */ `
  mutation UpdateVehicleExpirationDates(
    $input: UpdateVehicleExpirationDatesInput!
    $condition: ModelVehicleExpirationDatesConditionInput
  ) {
    updateVehicleExpirationDates(input: $input, condition: $condition) {
      id
      vehicleExpirationDatesVehicleId
      vehicleExpirationDatesTypeId
      group
      vehicleId
      dueDate
      createdAt
      updatedAt
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteVehicleExpirationDates = /* GraphQL */ `
  mutation DeleteVehicleExpirationDates(
    $input: DeleteVehicleExpirationDatesInput!
    $condition: ModelVehicleExpirationDatesConditionInput
  ) {
    deleteVehicleExpirationDates(input: $input, condition: $condition) {
      id
      vehicleExpirationDatesVehicleId
      vehicleExpirationDatesTypeId
      group
      vehicleId
      dueDate
      createdAt
      updatedAt
      type {
        id
        optionsCustomListsCustomListsId
        group
        order
        option
        default
        isEnabled
        isCustom
        usedFor
        daysCount
        canBeEdited
        canBeDeleted
        canBeReorder
        pillColor
        recordTemplateJson
        statusType
        driverReportSetting
        heraAiPrompt
        isDefaultForSections
        isHiddenForSections
        alternateImportValues
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        counselings {
          nextToken
          scannedCount
          __typename
        }
        counselingTypes {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        issues {
          nextToken
          scannedCount
          __typename
        }
        kudos {
          nextToken
          scannedCount
          __typename
        }
        replaceByRoutes {
          nextToken
          scannedCount
          __typename
        }
        replaceByRouteParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        routes {
          nextToken
          scannedCount
          __typename
        }
        routeHelperStatus {
          nextToken
          scannedCount
          __typename
        }
        routeParkingSpace {
          nextToken
          scannedCount
          __typename
        }
        previousRouteStatusHistory {
          nextToken
          __typename
        }
        currentRouteStatusHistory {
          nextToken
          __typename
        }
        customLists {
          id
          group
          type
          enabledRecordTemplates
          listCategory
          listName
          listDisplay
          canDeleteAllOptions
          canUseHeraAiPrompts
          allowAlternateImportValues
          createdAt
          updatedAt
          __typename
        }
        associates {
          nextToken
          scannedCount
          __typename
        }
        vehicles {
          nextToken
          scannedCount
          __typename
        }
        parkingSpace {
          nextToken
          scannedCount
          __typename
        }
        companies {
          nextToken
          scannedCount
          __typename
        }
        __typename
      }
      vehicle {
        id
        vehicleDeviceId
        vehicleDevice2Id
        vehicleCompanyId
        vehicleParkingSpaceId
        vehicleVehicleTypeId
        group
        name
        vehicle
        type
        state
        licensePlateExp
        dateStart
        dateEnd
        ownership
        provider
        otherProvider
        category
        vin
        make
        model
        year
        rentalAgreementNumber
        images
        rentalContracts
        accidentReports
        licensePlate
        mileage
        gasCard
        status
        statusReason
        notes
        lastOdometerReadingDate
        overTenThousandPounds
        customDeliveryVan
        tollPassId
        assignedDeviceName
        createdAt
        updatedAt
        accidents {
          nextToken
          scannedCount
          __typename
        }
        maintenanceRecords {
          nextToken
          scannedCount
          __typename
        }
        vehicleDamage {
          nextToken
          scannedCount
          __typename
        }
        odometerReadings {
          nextToken
          scannedCount
          __typename
        }
        device {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        device2 {
          id
          group
          deviceName
          phoneNumber
          carrier
          status
          imei
          notes
          deviceType
          deviceOperatingSystem
          deviceEnrollmentDate
          deviceICCID
          deviceSoftwareUpdateStatus
          deviceMiradoreId
          deviceCarrierValueListItemId
          wirelessSupportConnection
          deviceNameMiradore
          latestLastPing
          latestBattery
          deviceLastMessageTimestamp
          deviceLastMessage
          model
          manufacturer
          createdAt
          updatedAt
          __typename
        }
        dailyLogs {
          nextToken
          scannedCount
          __typename
        }
        documents {
          nextToken
          scannedCount
          __typename
        }
        mentionedInNotes {
          nextToken
          __typename
        }
        replacedRoutes {
          nextToken
          scannedCount
          __typename
        }
        route {
          nextToken
          scannedCount
          __typename
        }
        labels {
          nextToken
          __typename
        }
        defaultStaff {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff2 {
          nextToken
          scannedCount
          __typename
        }
        defaultStaff3 {
          nextToken
          scannedCount
          __typename
        }
        vehicleType {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        company {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        parkingSpace {
          id
          optionsCustomListsCustomListsId
          group
          order
          option
          default
          isEnabled
          isCustom
          usedFor
          daysCount
          canBeEdited
          canBeDeleted
          canBeReorder
          pillColor
          recordTemplateJson
          statusType
          driverReportSetting
          heraAiPrompt
          isDefaultForSections
          isHiddenForSections
          alternateImportValues
          createdAt
          updatedAt
          __typename
        }
        vehicleRecordHistory {
          nextToken
          __typename
        }
        reminders {
          nextToken
          __typename
        }
        vehicleStatusHistory {
          nextToken
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
